"use strict";
var __defProp = Object.defineProperty;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __getOwnPropNames = Object.getOwnPropertyNames;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __export = (target, all) => {
  for (var name in all)
    __defProp(target, name, { get: all[name], enumerable: true });
};
var __copyProps = (to, from, except, desc) => {
  if (from && typeof from === "object" || typeof from === "function") {
    for (let key of __getOwnPropNames(from))
      if (!__hasOwnProp.call(to, key) && key !== except)
        __defProp(to, key, { get: () => from[key], enumerable: !(desc = __getOwnPropDesc(from, key)) || desc.enumerable });
  }
  return to;
};
var __toCommonJS = (mod) => __copyProps(__defProp({}, "__esModule", { value: true }), mod);

// src/index.ts
var src_exports = {};
__export(src_exports, {
  ParserType: () => ParserType,
  SolanaFMParser: () => SolanaFMParser,
  checkIfAccountParser: () => checkIfAccountParser,
  checkIfErrorsParser: () => checkIfErrorsParser,
  checkIfEventParser: () => checkIfEventParser,
  checkIfInstructionParser: () => checkIfInstructionParser,
  isDataWithMappedType: () => isDataWithMappedType,
  isIdlAccounts: () => isIdlAccounts
});
module.exports = __toCommonJS(src_exports);

// src/types/AnchorTypes.ts
function isIdlAccounts(accountItem) {
  return "accounts" in accountItem;
}

// src/types/NewAnchorTypes.ts
var checkIfIdlDefinedFieldsNamed = (fields) => {
  const fieldsToCheck = fields;
  if (!fieldsToCheck[0])
    return false;
  if (fieldsToCheck[0].name !== void 0)
    return true;
  return false;
};
function isIdlAccounts2(accountItem) {
  return "accounts" in accountItem;
}

// src/helpers/idl.ts
var isDataWithMappedType = (data) => {
  return data.type && data.data;
};
var mapAccountKeysToName = (accountKeys, idlIxAccounts, mapTypes) => {
  if (idlIxAccounts && accountKeys) {
    const names = [];
    idlIxAccounts.forEach((idlIxAccount) => {
      names.push(
        extractIdlIxAccountName(idlIxAccount) ?? {
          name: "Unknown"
        }
      );
    });
    const flattenedArray = names.flat(5);
    const nonOptionalFlattenArray = flattenedArray.filter((accountKey) => !accountKey.optional);
    let translatedAccountKeysObj = {};
    if (nonOptionalFlattenArray.length >= accountKeys.length) {
      accountKeys.forEach((accountKey, index) => {
        let objectKey = nonOptionalFlattenArray[index] ?? {
          name: "Unknown"
        };
        const object = {
          [objectKey.name]: mapTypes ? { data: accountKey, type: "publicKey" } : accountKey
        };
        translatedAccountKeysObj = Object.assign(translatedAccountKeysObj, object);
      });
    } else {
      let namesIndex = 0;
      let optionalKeyCounter = 1;
      accountKeys.forEach((accountKey) => {
        let objectKey = flattenedArray[namesIndex] ?? {
          name: "Unknown"
        };
        if (objectKey.optional) {
          if (accountKeys.length < nonOptionalFlattenArray.length + optionalKeyCounter) {
            const nonOptionalIdlAccount = getNonOptionalIdlAccount(namesIndex, flattenedArray);
            if (nonOptionalIdlAccount) {
              objectKey = nonOptionalIdlAccount.idlAccount ?? {
                name: "Unknown"
              };
              namesIndex = nonOptionalIdlAccount.index;
            }
          }
          optionalKeyCounter++;
        }
        const object = {
          [objectKey.name]: mapTypes ? { data: accountKey, type: "publicKey" } : accountKey
        };
        translatedAccountKeysObj = Object.assign(translatedAccountKeysObj, object);
        namesIndex++;
      });
    }
    return translatedAccountKeysObj;
  }
  return {};
};
var getNonOptionalIdlAccount = (nameIndex, idlAccounts) => {
  let index = nameIndex;
  let idlAccount = idlAccounts[index] ?? {
    name: "Unknown"
  };
  if (idlAccount) {
    if (idlAccount?.optional) {
      index++;
      return getNonOptionalIdlAccount(index, idlAccounts);
    }
    return {
      idlAccount,
      index
    };
  }
  return void 0;
};
var extractIdlIxAccountName = (idlAccount) => {
  if (idlAccount) {
    if (isIdlAccounts(idlAccount)) {
      const idlIxAccounts = [];
      idlAccount.accounts.forEach((account) => {
        let extractedName = extractIdlIxAccountName(account);
        if (extractedName) {
          if (Array.isArray(extractedName)) {
            extractedName = extractIdlIxAccountName(account);
          } else {
            idlIxAccounts.push({
              name: idlAccount.name + "." + extractedName.name,
              optional: extractedName.optional
            });
          }
        }
      });
      return idlIxAccounts;
    } else {
      return {
        name: idlAccount.name,
        optional: idlAccount.isOptional
      };
    }
  }
  return void 0;
};
var mapDataTypeToName = (data, idlFields, shankDiscriminant) => {
  const dataKeys = Object.keys(data);
  const mappedDataType = {};
  dataKeys.forEach((keyName) => {
    if (idlFields && idlFields.length > 0) {
      const filteredIdlField = idlFields?.find((idlField) => idlField.name === keyName);
      if (filteredIdlField) {
        mappedDataType[keyName] = {
          type: filteredIdlField.type,
          data: data[keyName]
        };
      } else if (shankDiscriminant) {
        mappedDataType[keyName] = {
          type: shankDiscriminant.type,
          data: data[keyName]
        };
      } else {
        mappedDataType[keyName] = {
          data: data[keyName],
          type: "Unknown Type"
        };
      }
    }
  });
  return Object.keys(mappedDataType).length > 0 ? mappedDataType : data;
};
var mapNewAnchorDataTypeToName = (data, idlFields) => {
  const dataKeys = Object.keys(data);
  const mappedDataType = {};
  dataKeys.forEach((keyName) => {
    if (idlFields && idlFields.length > 0) {
      if (checkIfIdlDefinedFieldsNamed(idlFields)) {
        const filteredIdlField = idlFields.find((idlField) => idlField.name === keyName);
        if (filteredIdlField) {
          mappedDataType[keyName] = {
            type: filteredIdlField.type,
            data: data[keyName]
          };
        } else {
          mappedDataType[keyName] = {
            data: data[keyName],
            type: "Unknown Type"
          };
        }
      }
    }
  });
  return Object.keys(mappedDataType).length > 0 ? mappedDataType : data;
};

// src/parsers/v2/account/anchor.ts
var import_anchor = require("@coral-xyz/anchor");
var import_utils = require("@solanafm/utils");

// src/types/Parsers.ts
var ParserType = /* @__PURE__ */ ((ParserType2) => {
  ParserType2["ACCOUNT"] = "account";
  ParserType2["INSTRUCTION"] = "instruction";
  ParserType2["EVENT"] = "event";
  ParserType2["ERROR"] = "error";
  return ParserType2;
})(ParserType || {});
var checkIfInstructionParser = (parser) => {
  return parser ? "instructionsLayout" in parser && parser.instructionsLayout !== void 0 : false;
};
var checkIfEventParser = (parser) => {
  return parser ? "eventsLayout" in parser && parser.eventsLayout !== void 0 : false;
};
var checkIfErrorsParser = (parser) => {
  return parser ? "errorsLayout" in parser && parser.errorsLayout !== void 0 : false;
};
var checkIfAccountParser = (parser) => {
  return parser ? "accountLayouts" in parser && parser.accountLayouts !== void 0 : false;
};

// src/parsers/v2/account/anchor.ts
var createAnchorAccountParser = (idlItem) => {
  const idl = idlItem.idl;
  const accountLayouts = new import_anchor.BorshAccountsCoder(idl);
  const parseAccount = (accountData, maptypes) => {
    const bufferData = Buffer.from(accountData, "base64");
    const accountDiscriminator = bufferData.subarray(0, 8);
    const accountName = Array.from(idl.accounts ?? []).find(
      (key) => import_anchor.BorshAccountsCoder.accountDiscriminator(key.name).equals(accountDiscriminator)
    );
    let decodedAccountData = accountLayouts.decodeAny(bufferData);
    if (decodedAccountData) {
      const filteredIdlAccount = idl.accounts?.filter((account) => account.name === accountName?.name) ?? [];
      if (maptypes) {
        decodedAccountData = mapDataTypeToName(decodedAccountData, filteredIdlAccount[0]?.type.fields);
      }
      return {
        name: accountName?.name,
        data: (0, import_utils.convertBNToNumberInObject)(decodedAccountData),
        type: "account" /* ACCOUNT */
      };
    }
    return null;
  };
  const getProgramName = () => {
    return idl.name;
  };
  return {
    accountLayouts,
    parseAccount,
    getProgramName
  };
};

// src/parsers/v2/account/anchor-v1.ts
var import_anchor_new = require("@coral-xyz/anchor-new");
var import_utils2 = require("@solanafm/utils");
var createAnchorV1AccountParser = (idlItem) => {
  const idl = idlItem.idl;
  const accountLayouts = new import_anchor_new.BorshAccountsCoder(idl);
  const parseAccount = (accountData, maptypes) => {
    const bufferData = Buffer.from(accountData, "base64");
    const accountDiscriminator = bufferData.subarray(0, 8);
    const accountName = Array.from(idl.accounts ?? []).find(
      (key) => accountLayouts.accountDiscriminator(key.name).equals(accountDiscriminator)
    );
    let decodedAccountData = accountLayouts.decodeAny(bufferData);
    if (decodedAccountData) {
      const filteredIdlType = idl.types?.filter((type) => type.name === accountName?.name) ?? [];
      if (maptypes) {
        if (filteredIdlType[0]?.type.kind === "struct" && filteredIdlType[0]?.type.fields)
          decodedAccountData = mapNewAnchorDataTypeToName(decodedAccountData, filteredIdlType[0]?.type.fields);
      }
      return {
        name: accountName?.name,
        data: (0, import_utils2.convertBNToNumberInObject)(decodedAccountData),
        type: "account" /* ACCOUNT */
      };
    }
    return null;
  };
  const getProgramName = () => {
    return idl.metadata.name;
  };
  return {
    accountLayouts,
    parseAccount,
    getProgramName
  };
};

// src/parsers/v2/account/config.ts
var import_utils4 = require("@solanafm/utils");

// src/helpers/KinobiTreeGenerator.ts
var import_serializers = require("@metaplex-foundation/umi/serializers");
var import_spl_type_length_value = require("@solana/spl-type-length-value");
var import_kinobi_lite = require("@solanafm/kinobi-lite");
var import_utils3 = require("@solanafm/utils");

// src/helpers/common.ts
var toSnakeCase = (str) => {
  return str.match(/[A-Z]{2,}(?=[A-Z][a-z]+[0-9]*|\b)|[A-Z]?[a-z]+[0-9]*|[A-Z]|[0-9]+/g).map((x) => x.toLowerCase()).join("_");
};

// src/helpers/KinobiTreeGenerator.ts
var KinobiTreeGenerator = class _KinobiTreeGenerator {
  rootNode;
  treeGeneratorType;
  constructor(idl, treeGeneratorType = 1 /* INSTRUCTIONS */, kinobiJsonString) {
    const kinobiTree = kinobiJsonString ? (0, import_kinobi_lite.createFromJson)(kinobiJsonString) : (0, import_kinobi_lite.createFromIdls)([idl]);
    if (idl.metadata.address === "Config1111111111111111111111111111111111111") {
      kinobiTree.update(
        new import_kinobi_lite.TransformNodesVisitor([
          {
            selector: { kind: "structFieldTypeNode", name: "info" },
            transformer: (node) => {
              (0, import_kinobi_lite.assertStructFieldTypeNode)(node);
              return (0, import_kinobi_lite.structFieldTypeNode)({
                ...node,
                child: (0, import_kinobi_lite.stringTypeNode)({
                  size: (0, import_kinobi_lite.prefixedSize)((0, import_kinobi_lite.numberTypeNode)("u64"))
                })
              });
            }
          }
        ])
      );
    } else if (idl.metadata.address === "BPFLoaderUpgradeab1e11111111111111111111111") {
      kinobiTree.update(
        new import_kinobi_lite.TransformNodesVisitor([
          {
            selector: { kind: "structFieldTypeNode", name: "data" },
            transformer: (node) => {
              (0, import_kinobi_lite.assertStructFieldTypeNode)(node);
              return (0, import_kinobi_lite.structFieldTypeNode)({
                ...node,
                child: (0, import_kinobi_lite.bytesTypeNode)({
                  kind: "remainder"
                })
              });
            }
          }
        ])
      );
    } else if (idl.metadata.address === "noopb9bkMVfRPU8AsbpTUg8AQkHtKwMYZiFUjNRtMmV") {
      kinobiTree.update(
        new import_kinobi_lite.TransformNodesVisitor([
          {
            selector: { kind: "structFieldTypeNode", name: "data" },
            transformer: (node) => {
              (0, import_kinobi_lite.assertStructFieldTypeNode)(node);
              return (0, import_kinobi_lite.structFieldTypeNode)({
                ...node,
                child: (0, import_kinobi_lite.bytesTypeNode)({
                  kind: "remainder"
                })
              });
            }
          }
        ])
      );
    } else if (idl.metadata.address === "11111111111111111111111111111111") {
      kinobiTree.update(
        new import_kinobi_lite.TransformNodesVisitor([
          {
            selector: { kind: "structFieldTypeNode", name: "seed" },
            transformer: (node) => {
              (0, import_kinobi_lite.assertStructFieldTypeNode)(node);
              return (0, import_kinobi_lite.structFieldTypeNode)({
                ...node,
                child: (0, import_kinobi_lite.stringTypeNode)({
                  size: (0, import_kinobi_lite.prefixedSize)((0, import_kinobi_lite.numberTypeNode)("u64"))
                })
              });
            }
          }
        ])
      );
    }
    this.rootNode = kinobiTree.getRoot();
    this.treeGeneratorType = treeGeneratorType;
  }
  /**
   * Constructs a map with the discriminant as the key and the serializer as the value for a single shank-generated IDL
   * @param treeGeneratorType - The type of tree generator to construct
   * @param interfaceDiscriminantMode - Uses 8-bytes discriminant for the map key name if true, otherwise uses the discriminant value from the IDL
   * @param interfacePrefixString - String to prefix the interface name with
   * @returns A map with the discriminant as the key and the serializer as the value
   */
  constructLayout(treeGeneratorType = 1 /* INSTRUCTIONS */, interfaceDiscriminantMode = false, interfacePrefixString) {
    return this._constructLayout(treeGeneratorType, interfaceDiscriminantMode, interfacePrefixString);
  }
  _constructLayout(treeGeneratorType, interfaceDiscriminantMode, interfacePrefixString) {
    const typeNodes = (0, import_kinobi_lite.getAllDefinedTypes)(this.rootNode);
    switch (treeGeneratorType) {
      case 1 /* INSTRUCTIONS */:
        const instructionLayout = /* @__PURE__ */ new Map();
        const instructionNodes = (0, import_kinobi_lite.getAllInstructions)(this.rootNode);
        instructionNodes.forEach((instructionNode, index) => {
          if ((0, import_kinobi_lite.isStructTypeNode)(instructionNode.dataArgs.struct)) {
            const fields = instructionNode.dataArgs.struct.fields;
            if (fields[0]) {
              const ixDiscriminant = fields[0].defaultsTo?.value;
              if (ixDiscriminant?.kind === "number") {
                const discriminant = ixDiscriminant.value;
                const serializer = _KinobiTreeGenerator.createSerializer(
                  instructionNode.dataArgs.struct,
                  typeNodes,
                  instructionNode.name
                );
                const fmShankSerializer = {
                  serializer: serializer[1],
                  instructionName: serializer[0]
                };
                instructionLayout.set(discriminant, fmShankSerializer);
              }
              if (!ixDiscriminant) {
                const serializer = _KinobiTreeGenerator.createSerializer(
                  instructionNode.dataArgs.struct,
                  typeNodes,
                  instructionNode.name
                );
                const fmShankSerializer = {
                  serializer: serializer[1],
                  instructionName: serializer[0]
                };
                if (interfaceDiscriminantMode) {
                  const ixName = toSnakeCase(instructionNode.name);
                  const discriminant = (0, import_spl_type_length_value.splDiscriminate)(`${interfacePrefixString ?? ""}:${ixName}`);
                  instructionLayout.set((0, import_utils3.encodeBase58)(discriminant), fmShankSerializer);
                } else {
                  instructionLayout.set(index, fmShankSerializer);
                }
              }
            }
          }
        });
        return instructionLayout;
      case 0 /* ACCOUNTS */:
        const accountNodes = (0, import_kinobi_lite.getAllAccounts)(this.rootNode);
        const accountLayout = /* @__PURE__ */ new Map();
        accountNodes.forEach((account, index) => {
          if ((0, import_kinobi_lite.isStructTypeNode)(account.data.struct)) {
            const fields = account.data.struct.fields;
            const ixDiscriminant = fields[0]?.defaultsTo?.value;
            if (ixDiscriminant) {
              if (ixDiscriminant?.kind === "number") {
                const discriminant = ixDiscriminant.value;
                const serializer = _KinobiTreeGenerator.createSerializer(
                  account.data.struct,
                  typeNodes,
                  account.name,
                  treeGeneratorType
                );
                const fmShankSerializer = {
                  serializer: serializer[1],
                  instructionName: serializer[0]
                };
                accountLayout.set(discriminant, fmShankSerializer);
              } else if (ixDiscriminant?.kind === "list") {
                const discriminant = ixDiscriminant.values;
                const array3 = [];
                discriminant.forEach((value) => {
                  if (value.kind === "number") {
                    array3.push(value.value);
                  }
                });
                const buffer = Buffer.from(array3);
                const serializer = _KinobiTreeGenerator.createSerializer(
                  account.data.struct,
                  typeNodes,
                  account.name,
                  treeGeneratorType
                );
                const fmShankSerializer = {
                  serializer: serializer[1],
                  instructionName: serializer[0]
                };
                accountLayout.set(buffer.toString("base64"), fmShankSerializer);
              }
            } else {
              const serializer = _KinobiTreeGenerator.createSerializer(
                account.data.struct,
                typeNodes,
                account.name,
                treeGeneratorType
              );
              const fmShankSerializer = {
                serializer: serializer[1],
                instructionName: serializer[0]
              };
              const accountDiscriminator = index;
              accountLayout.set(accountDiscriminator, fmShankSerializer);
            }
          }
        });
        return accountLayout;
      case 2 /* TYPES */:
        const parentTypeNodes = (0, import_kinobi_lite.getAllDefinedTypes)(this.rootNode);
        const typeLayout = /* @__PURE__ */ new Map();
        parentTypeNodes.forEach((typeNode) => {
          const serializer = _KinobiTreeGenerator.createSerializer(
            typeNode.data,
            typeNodes,
            typeNode.name,
            treeGeneratorType
          );
          const fmShankSerializer = {
            serializer: serializer[1],
            instructionName: serializer[0]
          };
          typeLayout.set(typeNode.idlName, fmShankSerializer);
        });
        return typeLayout;
      case 3 /* EVENTS */:
        const eventNodes = (0, import_kinobi_lite.getAllEvents)(this.rootNode);
        const eventsLayout = /* @__PURE__ */ new Map();
        eventNodes.forEach((eventNode, index) => {
          if ((0, import_kinobi_lite.isStructTypeNode)(eventNode.dataArgs.struct)) {
            const serializer = _KinobiTreeGenerator.createSerializer(
              eventNode.dataArgs.struct,
              typeNodes,
              eventNode.dataArgs.name,
              treeGeneratorType
            );
            const fmShankSerializer = {
              serializer: serializer[1],
              instructionName: serializer[0]
            };
            const eventDiscriminator = index;
            eventsLayout.set(eventDiscriminator, fmShankSerializer);
          }
        });
        return eventsLayout;
      default:
        return /* @__PURE__ */ new Map();
    }
  }
  static createSerializer(field, types, keyName, treeGeneratorType = 1 /* INSTRUCTIONS */) {
    switch (field.kind) {
      case "arrayTypeNode":
        const innerArrayLayout = _KinobiTreeGenerator.createSerializer(field.child, types, keyName, treeGeneratorType);
        if (innerArrayLayout[1] !== null) {
          let size2 = void 0;
          switch (field.size.kind) {
            case "fixed":
              size2 = field.size.value;
              break;
            case "prefixed":
              size2 = _KinobiTreeGenerator.createNumberSerializer(field.size.prefix.format, "size")[1] ?? void 0;
              break;
            case "remainder":
              return [keyName, (0, import_serializers.array)(innerArrayLayout[1], { size: "remainder" })];
          }
          return [keyName, (0, import_serializers.array)(innerArrayLayout[1], { size: size2 })];
        }
        return ["typeArrayNodeNull", null];
      case "boolTypeNode":
        return [keyName, (0, import_serializers.bool)()];
      case "bytesTypeNode":
        let size = null;
        switch (field.size.kind) {
          case "fixed":
            size = field.size.value;
            break;
          case "prefixed":
            size = _KinobiTreeGenerator.createNumberSerializer(field.size.prefix.format, "bytesPrefixedNumber")[1];
            break;
          case "remainder":
            size = "variable";
            break;
          default:
            break;
        }
        if (size) {
          return [
            keyName,
            (0, import_serializers.bytes)({
              size
            })
          ];
        }
        return [keyName, (0, import_serializers.bytes)()];
      case "linkTypeNode":
        const definedType = field.name;
        const filteredDefinedType = types.filter((type) => {
          return type.name === definedType;
        });
        const typeManifest = filteredDefinedType[0];
        if (typeManifest) {
          const innerDefinedLinkLayout = _KinobiTreeGenerator.createSerializer(
            typeManifest.data,
            types,
            typeManifest.name,
            treeGeneratorType
          );
          return innerDefinedLinkLayout;
        }
        return ["typeDefinedLinkNodeNull", null];
      case "enumTypeNode":
        const innerEnumLayouts = [];
        const enumDiscSize = _KinobiTreeGenerator.createNumberSerializer(field.size.format, "size");
        field.variants.forEach((variant) => {
          const layout = _KinobiTreeGenerator.createSerializer(variant, types, variant.name, treeGeneratorType);
          innerEnumLayouts.push(layout);
        });
        if (enumDiscSize && enumDiscSize[1]) {
          return [
            keyName,
            (0, import_serializers.dataEnum)(innerEnumLayouts, {
              size: enumDiscSize[1]
            })
          ];
        }
        return [keyName, (0, import_serializers.dataEnum)(innerEnumLayouts)];
      case "mapTypeNode":
        const keyLayout = _KinobiTreeGenerator.createSerializer(field.key, types, keyName, treeGeneratorType);
        const valueLayout = _KinobiTreeGenerator.createSerializer(field.value, types, keyName, treeGeneratorType);
        if (keyLayout[1] && valueLayout[1]) {
          let size2 = void 0;
          switch (field.size.kind) {
            case "fixed":
              size2 = field.size.value;
              break;
            case "prefixed":
              size2 = _KinobiTreeGenerator.createNumberSerializer(field.size.prefix.format, "size")[1] ?? void 0;
              break;
            case "remainder":
              return [
                keyName,
                (0, import_serializers.map)(keyLayout[1], valueLayout[1], {
                  description: "",
                  size: "remainder"
                })
              ];
          }
          return [
            keyName,
            (0, import_serializers.map)(keyLayout[1], valueLayout[1], {
              description: "",
              size: size2
            })
          ];
        }
        return ["typeMapNodeNull", null];
      case "numberTypeNode":
        const serializer = _KinobiTreeGenerator.createNumberSerializer(field.format, keyName);
        return serializer;
      case "optionTypeNode":
        const innerOptionLayout = _KinobiTreeGenerator.createSerializer(field.child, types, keyName, treeGeneratorType);
        const options = {
          fixed: field.fixed,
          prefix: _KinobiTreeGenerator.createNumberSerializer(field.prefix.format, "size")[1] ?? void 0
        };
        if (innerOptionLayout[1]) {
          return [keyName, (0, import_serializers.option)(innerOptionLayout[1], options)];
        }
        return ["typeOptionNodeNull", null];
      case "publicKeyTypeNode":
        return [keyName, (0, import_serializers.publicKey)()];
      case "setTypeNode":
        const innerSetLayout = _KinobiTreeGenerator.createSerializer(field.child, types, keyName, treeGeneratorType);
        if (innerSetLayout[1]) {
          return [keyName, (0, import_serializers.set)(innerSetLayout[1])];
        }
        return ["typeSetNodeNull", null];
      case "stringTypeNode":
        let stringSize = null;
        switch (field.size.kind) {
          case "fixed":
            stringSize = field.size.value;
            break;
          case "prefixed":
            stringSize = _KinobiTreeGenerator.createNumberSerializer(
              field.size.prefix.format,
              "stringPrefixedNumber"
            )[1];
            break;
          case "remainder":
            stringSize = "variable";
            break;
          default:
            break;
        }
        if (stringSize) {
          return [
            keyName,
            (0, import_serializers.string)({
              size: stringSize
            })
          ];
        }
        return [keyName, (0, import_serializers.string)()];
      case "structTypeNode":
        const structLayout = [];
        field.fields.forEach((innerField) => {
          const name = innerField.name;
          const innerStructLayout = _KinobiTreeGenerator.createSerializer(
            innerField.child,
            types,
            name,
            treeGeneratorType
          );
          if (innerStructLayout[1] !== null) {
            const innerLayout = innerStructLayout[1];
            structLayout.push([innerStructLayout[0], innerLayout]);
          }
        });
        return [keyName, (0, import_serializers.struct)(structLayout)];
      case "tupleTypeNode":
        const innerTupleLayouts = [];
        field.children.forEach((item) => {
          const innerItemLayout = _KinobiTreeGenerator.createSerializer(item, types, keyName, treeGeneratorType);
          if (innerItemLayout[1]) {
            innerTupleLayouts.push(innerItemLayout[1]);
          }
        });
        return [keyName, (0, import_serializers.tuple)(innerTupleLayouts)];
      case "enumEmptyVariantTypeNode":
        return [field.name, (0, import_serializers.unit)()];
      case "enumStructVariantTypeNode":
        const innerEnumLayout = _KinobiTreeGenerator.createSerializer(field.struct, types, keyName, treeGeneratorType);
        if (innerEnumLayout[1]) {
          return [keyName, innerEnumLayout[1]];
        }
        return ["typeEnumStructVariantNodeNull", null];
      case "enumTupleVariantTypeNode":
        const innerEnumTupleLayout = _KinobiTreeGenerator.createSerializer(
          field.tuple,
          types,
          keyName,
          treeGeneratorType
        );
        if (innerEnumTupleLayout[1]) {
          return [keyName, innerEnumTupleLayout[1]];
        }
        return ["typeEnumStructVariantNodeNull", null];
      default:
        console.error("Unknown node type", field);
        return ["nullSerializer", null];
    }
  }
  static createNumberSerializer(field, keyName) {
    switch (field) {
      case "u8":
        return [keyName, (0, import_serializers.u8)()];
      case "u16":
        return [keyName, (0, import_serializers.u16)()];
      case "u32":
        return [keyName, (0, import_serializers.u32)()];
      case "u64":
        return [keyName, (0, import_serializers.u64)()];
      case "u128":
        return [keyName, (0, import_serializers.u128)()];
      case "i8":
        return [keyName, (0, import_serializers.i8)()];
      case "i16":
        return [keyName, (0, import_serializers.i16)()];
      case "i32":
        return [keyName, (0, import_serializers.i32)()];
      case "i64":
        return [keyName, (0, import_serializers.i64)()];
      case "i128":
        return [keyName, (0, import_serializers.i128)()];
      case "f32":
        return [keyName, (0, import_serializers.f32)()];
      case "f64":
        return [keyName, (0, import_serializers.f64)()];
      default:
        console.error("Unidentifiable field of:", field);
        return ["null", null];
    }
  }
};

// src/parsers/v2/account/config.ts
var createShankConfigAccount = (idlItem, accountHash) => {
  const idl = idlItem.idl;
  const accountLayouts = new KinobiTreeGenerator(idl).constructLayout(0 /* ACCOUNTS */);
  const parseAccount = (accountData, mapTypes) => {
    try {
      const dataBuffer = Buffer.from(accountData, "base64");
      let accountSerializer = void 0;
      if (accountHash === "StakeConfig11111111111111111111111111111111") {
        accountSerializer = accountLayouts.get(0);
      } else {
        accountSerializer = accountLayouts.get(1);
      }
      if (accountSerializer && dataBuffer.byteLength > 0) {
        const decodedAccountData = accountSerializer.serializer?.deserialize(dataBuffer);
        if (decodedAccountData && decodedAccountData[0]) {
          const filteredIdlAccount = idl.accounts?.filter(
            (account) => account.name.toLowerCase() === accountSerializer?.instructionName.toLowerCase()
          ) ?? [];
          if (mapTypes) {
            decodedAccountData[0] = mapDataTypeToName(decodedAccountData[0], filteredIdlAccount[0]?.type.fields);
          }
          return {
            name: accountSerializer.instructionName,
            data: (0, import_utils4.convertBNToNumberInObject)(decodedAccountData[0]),
            type: "account" /* ACCOUNT */
          };
        }
      }
      return null;
    } catch (error) {
      console.error(error);
      return null;
    }
  };
  const getProgramName = () => {
    return "config";
  };
  return {
    accountLayouts,
    parseAccount,
    getProgramName
  };
};

// src/parsers/v2/account/name-service.ts
var import_utils5 = require("@solanafm/utils");
var createShankNameServiceAccount = (idlItem) => {
  const idl = idlItem.idl;
  const accountLayouts = new KinobiTreeGenerator(idl).constructLayout(0 /* ACCOUNTS */);
  const ACCOUNT_MIN_SIZE = 96;
  const parseAccount = (accountData, mapTypes) => {
    try {
      const dataBuffer = Buffer.from(accountData, "base64");
      let accountSerializer = void 0;
      if (dataBuffer.byteLength < ACCOUNT_MIN_SIZE) {
        return null;
      }
      if (dataBuffer.byteLength >= ACCOUNT_MIN_SIZE) {
        accountSerializer = accountLayouts.get(0);
      }
      if (accountSerializer && dataBuffer.length > 0) {
        const decodedAccountData = accountSerializer.serializer?.deserialize(dataBuffer);
        if (decodedAccountData && decodedAccountData[0]) {
          const filteredIdlAccount = idl.accounts?.filter(
            (account) => account.name.toLowerCase() === accountSerializer?.instructionName.toLowerCase()
          ) ?? [];
          if (mapTypes) {
            decodedAccountData[0] = mapDataTypeToName(decodedAccountData[0], filteredIdlAccount[0]?.type.fields);
          }
          return {
            name: accountSerializer.instructionName,
            data: (0, import_utils5.convertBNToNumberInObject)(decodedAccountData[0]),
            type: "account" /* ACCOUNT */
          };
        }
      }
      return null;
    } catch (error) {
      console.error(error);
      return null;
    }
  };
  const getProgramName = () => {
    return idl.name;
  };
  return {
    accountLayouts,
    parseAccount,
    getProgramName
  };
};

// src/parsers/v2/account/phoenix.ts
var import_utils6 = require("@solanafm/utils");

// src/idls/phoenix.ts
var PhoenixIDL = {
  version: "0.2.3",
  name: "phoenix_v1",
  accounts: [
    {
      name: "Seat",
      type: {
        kind: "struct",
        fields: [
          {
            name: "market",
            type: "publicKey"
          },
          {
            name: "trader",
            type: "publicKey"
          },
          {
            name: "approval_status",
            type: "u64"
          },
          {
            name: "_padding",
            type: {
              array: ["u64", 6]
            }
          }
        ]
      }
    },
    {
      name: "MarketHeader",
      type: {
        kind: "struct",
        fields: [
          {
            name: "status",
            type: "u64"
          },
          {
            name: "market_size_params",
            type: {
              defined: "MarketSizeParams"
            }
          },
          {
            name: "base_params",
            type: {
              defined: "TokenParams"
            }
          },
          {
            name: "base_lot_size",
            type: "u64"
          },
          {
            name: "quote_params",
            type: {
              defined: "TokenParams"
            }
          },
          {
            name: "quote_lot_size",
            type: "u64"
          },
          {
            name: "tick_size_in_quote_atoms_per_base_unit",
            type: "u64"
          },
          {
            name: "authority",
            type: "publicKey"
          },
          {
            name: "fee_recipient",
            type: "publicKey"
          },
          {
            name: "market_sequence_number",
            type: "u64"
          },
          {
            name: "successor",
            type: "publicKey"
          },
          {
            name: "raw_base_units_per_base_unit",
            type: "u32"
          }
        ]
      }
    }
  ],
  instructions: [
    {
      name: "Swap",
      accounts: [
        {
          name: "phoenixProgram",
          isMut: false,
          isSigner: false,
          desc: "Phoenix program"
        },
        {
          name: "logAuthority",
          isMut: false,
          isSigner: false,
          desc: "Phoenix log authority"
        },
        {
          name: "market",
          isMut: true,
          isSigner: false,
          desc: "This account holds the market state"
        },
        {
          name: "trader",
          isMut: false,
          isSigner: true
        },
        {
          name: "baseAccount",
          isMut: true,
          isSigner: false,
          desc: "Trader base token account"
        },
        {
          name: "quoteAccount",
          isMut: true,
          isSigner: false,
          desc: "Trader quote token account"
        },
        {
          name: "baseVault",
          isMut: true,
          isSigner: false,
          desc: "Base vault PDA, seeds are [b'vault', market_address, base_mint_address]"
        },
        {
          name: "quoteVault",
          isMut: true,
          isSigner: false,
          desc: "Quote vault PDA, seeds are [b'vault', market_address, quote_mint_address]"
        },
        {
          name: "tokenProgram",
          isMut: false,
          isSigner: false,
          desc: "Token program"
        }
      ],
      args: [
        {
          name: "orderPacket",
          type: {
            defined: "OrderPacket"
          }
        }
      ],
      discriminant: {
        type: "u8",
        value: 0
      }
    },
    {
      name: "SwapWithFreeFunds",
      accounts: [
        {
          name: "phoenixProgram",
          isMut: false,
          isSigner: false,
          desc: "Phoenix program"
        },
        {
          name: "logAuthority",
          isMut: false,
          isSigner: false,
          desc: "Phoenix log authority"
        },
        {
          name: "market",
          isMut: true,
          isSigner: false,
          desc: "This account holds the market state"
        },
        {
          name: "trader",
          isMut: false,
          isSigner: true
        },
        {
          name: "seat",
          isMut: false,
          isSigner: false
        }
      ],
      args: [
        {
          name: "orderPacket",
          type: {
            defined: "OrderPacket"
          }
        }
      ],
      discriminant: {
        type: "u8",
        value: 1
      }
    },
    {
      name: "PlaceLimitOrder",
      accounts: [
        {
          name: "phoenixProgram",
          isMut: false,
          isSigner: false,
          desc: "Phoenix program"
        },
        {
          name: "logAuthority",
          isMut: false,
          isSigner: false,
          desc: "Phoenix log authority"
        },
        {
          name: "market",
          isMut: true,
          isSigner: false,
          desc: "This account holds the market state"
        },
        {
          name: "trader",
          isMut: false,
          isSigner: true
        },
        {
          name: "seat",
          isMut: false,
          isSigner: false
        },
        {
          name: "baseAccount",
          isMut: true,
          isSigner: false,
          desc: "Trader base token account"
        },
        {
          name: "quoteAccount",
          isMut: true,
          isSigner: false,
          desc: "Trader quote token account"
        },
        {
          name: "baseVault",
          isMut: true,
          isSigner: false,
          desc: "Base vault PDA, seeds are [b'vault', market_address, base_mint_address]"
        },
        {
          name: "quoteVault",
          isMut: true,
          isSigner: false,
          desc: "Quote vault PDA, seeds are [b'vault', market_address, quote_mint_address]"
        },
        {
          name: "tokenProgram",
          isMut: false,
          isSigner: false,
          desc: "Token program"
        }
      ],
      args: [
        {
          name: "orderPacket",
          type: {
            defined: "OrderPacket"
          }
        }
      ],
      discriminant: {
        type: "u8",
        value: 2
      }
    },
    {
      name: "PlaceLimitOrderWithFreeFunds",
      accounts: [
        {
          name: "phoenixProgram",
          isMut: false,
          isSigner: false,
          desc: "Phoenix program"
        },
        {
          name: "logAuthority",
          isMut: false,
          isSigner: false,
          desc: "Phoenix log authority"
        },
        {
          name: "market",
          isMut: true,
          isSigner: false,
          desc: "This account holds the market state"
        },
        {
          name: "trader",
          isMut: false,
          isSigner: true
        },
        {
          name: "seat",
          isMut: false,
          isSigner: false
        }
      ],
      args: [
        {
          name: "orderPacket",
          type: {
            defined: "OrderPacket"
          }
        }
      ],
      discriminant: {
        type: "u8",
        value: 3
      }
    },
    {
      name: "ReduceOrder",
      accounts: [
        {
          name: "phoenixProgram",
          isMut: false,
          isSigner: false,
          desc: "Phoenix program"
        },
        {
          name: "logAuthority",
          isMut: false,
          isSigner: false,
          desc: "Phoenix log authority"
        },
        {
          name: "market",
          isMut: true,
          isSigner: false,
          desc: "This account holds the market state"
        },
        {
          name: "trader",
          isMut: false,
          isSigner: true
        },
        {
          name: "baseAccount",
          isMut: true,
          isSigner: false,
          desc: "Trader base token account"
        },
        {
          name: "quoteAccount",
          isMut: true,
          isSigner: false,
          desc: "Trader quote token account"
        },
        {
          name: "baseVault",
          isMut: true,
          isSigner: false,
          desc: "Base vault PDA, seeds are [b'vault', market_address, base_mint_address]"
        },
        {
          name: "quoteVault",
          isMut: true,
          isSigner: false,
          desc: "Quote vault PDA, seeds are [b'vault', market_address, quote_mint_address]"
        },
        {
          name: "tokenProgram",
          isMut: false,
          isSigner: false,
          desc: "Token program"
        }
      ],
      args: [
        {
          name: "params",
          type: {
            defined: "ReduceOrderParams"
          }
        }
      ],
      discriminant: {
        type: "u8",
        value: 4
      }
    },
    {
      name: "ReduceOrderWithFreeFunds",
      accounts: [
        {
          name: "phoenixProgram",
          isMut: false,
          isSigner: false,
          desc: "Phoenix program"
        },
        {
          name: "logAuthority",
          isMut: false,
          isSigner: false,
          desc: "Phoenix log authority"
        },
        {
          name: "market",
          isMut: true,
          isSigner: false,
          desc: "This account holds the market state"
        },
        {
          name: "trader",
          isMut: true,
          isSigner: true
        }
      ],
      args: [
        {
          name: "params",
          type: {
            defined: "ReduceOrderParams"
          }
        }
      ],
      discriminant: {
        type: "u8",
        value: 5
      }
    },
    {
      name: "CancelAllOrders",
      accounts: [
        {
          name: "phoenixProgram",
          isMut: false,
          isSigner: false,
          desc: "Phoenix program"
        },
        {
          name: "logAuthority",
          isMut: false,
          isSigner: false,
          desc: "Phoenix log authority"
        },
        {
          name: "market",
          isMut: true,
          isSigner: false,
          desc: "This account holds the market state"
        },
        {
          name: "trader",
          isMut: false,
          isSigner: true
        },
        {
          name: "baseAccount",
          isMut: true,
          isSigner: false,
          desc: "Trader base token account"
        },
        {
          name: "quoteAccount",
          isMut: true,
          isSigner: false,
          desc: "Trader quote token account"
        },
        {
          name: "baseVault",
          isMut: true,
          isSigner: false,
          desc: "Base vault PDA, seeds are [b'vault', market_address, base_mint_address]"
        },
        {
          name: "quoteVault",
          isMut: true,
          isSigner: false,
          desc: "Quote vault PDA, seeds are [b'vault', market_address, quote_mint_address]"
        },
        {
          name: "tokenProgram",
          isMut: false,
          isSigner: false,
          desc: "Token program"
        }
      ],
      args: [],
      discriminant: {
        type: "u8",
        value: 6
      }
    },
    {
      name: "CancelAllOrdersWithFreeFunds",
      accounts: [
        {
          name: "phoenixProgram",
          isMut: false,
          isSigner: false,
          desc: "Phoenix program"
        },
        {
          name: "logAuthority",
          isMut: false,
          isSigner: false,
          desc: "Phoenix log authority"
        },
        {
          name: "market",
          isMut: true,
          isSigner: false,
          desc: "This account holds the market state"
        },
        {
          name: "trader",
          isMut: false,
          isSigner: true
        }
      ],
      args: [],
      discriminant: {
        type: "u8",
        value: 7
      }
    },
    {
      name: "CancelUpTo",
      accounts: [
        {
          name: "phoenixProgram",
          isMut: false,
          isSigner: false,
          desc: "Phoenix program"
        },
        {
          name: "logAuthority",
          isMut: false,
          isSigner: false,
          desc: "Phoenix log authority"
        },
        {
          name: "market",
          isMut: true,
          isSigner: false,
          desc: "This account holds the market state"
        },
        {
          name: "trader",
          isMut: false,
          isSigner: true
        },
        {
          name: "baseAccount",
          isMut: true,
          isSigner: false,
          desc: "Trader base token account"
        },
        {
          name: "quoteAccount",
          isMut: true,
          isSigner: false,
          desc: "Trader quote token account"
        },
        {
          name: "baseVault",
          isMut: true,
          isSigner: false,
          desc: "Base vault PDA, seeds are [b'vault', market_address, base_mint_address]"
        },
        {
          name: "quoteVault",
          isMut: true,
          isSigner: false,
          desc: "Quote vault PDA, seeds are [b'vault', market_address, quote_mint_address]"
        },
        {
          name: "tokenProgram",
          isMut: false,
          isSigner: false,
          desc: "Token program"
        }
      ],
      args: [
        {
          name: "params",
          type: {
            defined: "CancelUpToParams"
          }
        }
      ],
      discriminant: {
        type: "u8",
        value: 8
      }
    },
    {
      name: "CancelUpToWithFreeFunds",
      accounts: [
        {
          name: "phoenixProgram",
          isMut: false,
          isSigner: false,
          desc: "Phoenix program"
        },
        {
          name: "logAuthority",
          isMut: false,
          isSigner: false,
          desc: "Phoenix log authority"
        },
        {
          name: "market",
          isMut: true,
          isSigner: false,
          desc: "This account holds the market state"
        },
        {
          name: "trader",
          isMut: false,
          isSigner: true
        }
      ],
      args: [
        {
          name: "params",
          type: {
            defined: "CancelUpToParams"
          }
        }
      ],
      discriminant: {
        type: "u8",
        value: 9
      }
    },
    {
      name: "CancelMultipleOrdersById",
      accounts: [
        {
          name: "phoenixProgram",
          isMut: false,
          isSigner: false,
          desc: "Phoenix program"
        },
        {
          name: "logAuthority",
          isMut: false,
          isSigner: false,
          desc: "Phoenix log authority"
        },
        {
          name: "market",
          isMut: true,
          isSigner: false,
          desc: "This account holds the market state"
        },
        {
          name: "trader",
          isMut: false,
          isSigner: true
        },
        {
          name: "baseAccount",
          isMut: true,
          isSigner: false,
          desc: "Trader base token account"
        },
        {
          name: "quoteAccount",
          isMut: true,
          isSigner: false,
          desc: "Trader quote token account"
        },
        {
          name: "baseVault",
          isMut: true,
          isSigner: false,
          desc: "Base vault PDA, seeds are [b'vault', market_address, base_mint_address]"
        },
        {
          name: "quoteVault",
          isMut: true,
          isSigner: false,
          desc: "Quote vault PDA, seeds are [b'vault', market_address, quote_mint_address]"
        },
        {
          name: "tokenProgram",
          isMut: false,
          isSigner: false,
          desc: "Token program"
        }
      ],
      args: [
        {
          name: "params",
          type: {
            defined: "CancelMultipleOrdersByIdParams"
          }
        }
      ],
      discriminant: {
        type: "u8",
        value: 10
      }
    },
    {
      name: "CancelMultipleOrdersByIdWithFreeFunds",
      accounts: [
        {
          name: "phoenixProgram",
          isMut: false,
          isSigner: false,
          desc: "Phoenix program"
        },
        {
          name: "logAuthority",
          isMut: false,
          isSigner: false,
          desc: "Phoenix log authority"
        },
        {
          name: "market",
          isMut: true,
          isSigner: false,
          desc: "This account holds the market state"
        },
        {
          name: "trader",
          isMut: false,
          isSigner: true
        }
      ],
      args: [
        {
          name: "params",
          type: {
            defined: "CancelMultipleOrdersByIdParams"
          }
        }
      ],
      discriminant: {
        type: "u8",
        value: 11
      }
    },
    {
      name: "WithdrawFunds",
      accounts: [
        {
          name: "phoenixProgram",
          isMut: false,
          isSigner: false,
          desc: "Phoenix program"
        },
        {
          name: "logAuthority",
          isMut: false,
          isSigner: false,
          desc: "Phoenix log authority"
        },
        {
          name: "market",
          isMut: true,
          isSigner: false,
          desc: "This account holds the market state"
        },
        {
          name: "trader",
          isMut: false,
          isSigner: true
        },
        {
          name: "baseAccount",
          isMut: true,
          isSigner: false,
          desc: "Trader base token account"
        },
        {
          name: "quoteAccount",
          isMut: true,
          isSigner: false,
          desc: "Trader quote token account"
        },
        {
          name: "baseVault",
          isMut: true,
          isSigner: false,
          desc: "Base vault PDA, seeds are [b'vault', market_address, base_mint_address]"
        },
        {
          name: "quoteVault",
          isMut: true,
          isSigner: false,
          desc: "Quote vault PDA, seeds are [b'vault', market_address, quote_mint_address]"
        },
        {
          name: "tokenProgram",
          isMut: false,
          isSigner: false,
          desc: "Token program"
        }
      ],
      args: [
        {
          name: "withdrawFundsParams",
          type: {
            defined: "WithdrawParams"
          }
        }
      ],
      discriminant: {
        type: "u8",
        value: 12
      }
    },
    {
      name: "DepositFunds",
      accounts: [
        {
          name: "phoenixProgram",
          isMut: false,
          isSigner: false,
          desc: "Phoenix program"
        },
        {
          name: "logAuthority",
          isMut: false,
          isSigner: false,
          desc: "Phoenix log authority"
        },
        {
          name: "market",
          isMut: true,
          isSigner: false,
          desc: "This account holds the market state"
        },
        {
          name: "trader",
          isMut: false,
          isSigner: true
        },
        {
          name: "seat",
          isMut: false,
          isSigner: false
        },
        {
          name: "baseAccount",
          isMut: true,
          isSigner: false,
          desc: "Trader base token account"
        },
        {
          name: "quoteAccount",
          isMut: true,
          isSigner: false,
          desc: "Trader quote token account"
        },
        {
          name: "baseVault",
          isMut: true,
          isSigner: false,
          desc: "Base vault PDA, seeds are [b'vault', market_address, base_mint_address]"
        },
        {
          name: "quoteVault",
          isMut: true,
          isSigner: false,
          desc: "Quote vault PDA, seeds are [b'vault', market_address, quote_mint_address]"
        },
        {
          name: "tokenProgram",
          isMut: false,
          isSigner: false,
          desc: "Token program"
        }
      ],
      args: [
        {
          name: "depositFundsParams",
          type: {
            defined: "DepositParams"
          }
        }
      ],
      discriminant: {
        type: "u8",
        value: 13
      }
    },
    {
      name: "RequestSeat",
      accounts: [
        {
          name: "phoenixProgram",
          isMut: false,
          isSigner: false,
          desc: "Phoenix program"
        },
        {
          name: "logAuthority",
          isMut: false,
          isSigner: false,
          desc: "Phoenix log authority"
        },
        {
          name: "market",
          isMut: true,
          isSigner: false,
          desc: "This account holds the market state"
        },
        {
          name: "payer",
          isMut: true,
          isSigner: true
        },
        {
          name: "seat",
          isMut: true,
          isSigner: false
        },
        {
          name: "systemProgram",
          isMut: false,
          isSigner: false,
          desc: "System program"
        }
      ],
      args: [],
      discriminant: {
        type: "u8",
        value: 14
      }
    },
    {
      name: "Log",
      accounts: [
        {
          name: "logAuthority",
          isMut: false,
          isSigner: true,
          desc: "Log authority"
        }
      ],
      args: [],
      discriminant: {
        type: "u8",
        value: 15
      }
    },
    {
      name: "PlaceMultiplePostOnlyOrders",
      accounts: [
        {
          name: "phoenixProgram",
          isMut: false,
          isSigner: false,
          desc: "Phoenix program"
        },
        {
          name: "logAuthority",
          isMut: false,
          isSigner: false,
          desc: "Phoenix log authority"
        },
        {
          name: "market",
          isMut: true,
          isSigner: false,
          desc: "This account holds the market state"
        },
        {
          name: "trader",
          isMut: false,
          isSigner: true
        },
        {
          name: "seat",
          isMut: false,
          isSigner: false
        },
        {
          name: "baseAccount",
          isMut: true,
          isSigner: false,
          desc: "Trader base token account"
        },
        {
          name: "quoteAccount",
          isMut: true,
          isSigner: false,
          desc: "Trader quote token account"
        },
        {
          name: "baseVault",
          isMut: true,
          isSigner: false,
          desc: "Base vault PDA, seeds are [b'vault', market_address, base_mint_address]"
        },
        {
          name: "quoteVault",
          isMut: true,
          isSigner: false,
          desc: "Quote vault PDA, seeds are [b'vault', market_address, quote_mint_address]"
        },
        {
          name: "tokenProgram",
          isMut: false,
          isSigner: false,
          desc: "Token program"
        }
      ],
      args: [
        {
          name: "multipleOrderPacket",
          type: {
            defined: "MultipleOrderPacket"
          }
        }
      ],
      discriminant: {
        type: "u8",
        value: 16
      }
    },
    {
      name: "PlaceMultiplePostOnlyOrdersWithFreeFunds",
      accounts: [
        {
          name: "phoenixProgram",
          isMut: false,
          isSigner: false,
          desc: "Phoenix program"
        },
        {
          name: "logAuthority",
          isMut: false,
          isSigner: false,
          desc: "Phoenix log authority"
        },
        {
          name: "market",
          isMut: true,
          isSigner: false,
          desc: "This account holds the market state"
        },
        {
          name: "trader",
          isMut: false,
          isSigner: true
        },
        {
          name: "seat",
          isMut: false,
          isSigner: false
        }
      ],
      args: [
        {
          name: "multipleOrderPacket",
          type: {
            defined: "MultipleOrderPacket"
          }
        }
      ],
      discriminant: {
        type: "u8",
        value: 17
      }
    },
    {
      name: "InitializeMarket",
      accounts: [
        {
          name: "phoenixProgram",
          isMut: false,
          isSigner: false,
          desc: "Phoenix program"
        },
        {
          name: "logAuthority",
          isMut: false,
          isSigner: false,
          desc: "Phoenix log authority"
        },
        {
          name: "market",
          isMut: true,
          isSigner: false,
          desc: "This account holds the market state"
        },
        {
          name: "marketCreator",
          isMut: true,
          isSigner: true,
          desc: "The market_creator account must sign for the creation of new vaults"
        },
        {
          name: "baseMint",
          isMut: false,
          isSigner: false,
          desc: "Base mint account"
        },
        {
          name: "quoteMint",
          isMut: false,
          isSigner: false,
          desc: "Quote mint account"
        },
        {
          name: "baseVault",
          isMut: true,
          isSigner: false,
          desc: "Base vault PDA, seeds are [b'vault', market_address, base_mint_address]"
        },
        {
          name: "quoteVault",
          isMut: true,
          isSigner: false,
          desc: "Quote vault PDA, seeds are [b'vault', market_address, quote_mint_address]"
        },
        {
          name: "systemProgram",
          isMut: false,
          isSigner: false,
          desc: "System program"
        },
        {
          name: "tokenProgram",
          isMut: false,
          isSigner: false,
          desc: "Token program"
        }
      ],
      args: [
        {
          name: "initializeParams",
          type: {
            defined: "InitializeParams"
          }
        }
      ],
      discriminant: {
        type: "u8",
        value: 100
      }
    },
    {
      name: "ClaimAuthority",
      accounts: [
        {
          name: "phoenixProgram",
          isMut: false,
          isSigner: false,
          desc: "Phoenix program"
        },
        {
          name: "logAuthority",
          isMut: false,
          isSigner: false,
          desc: "Phoenix log authority"
        },
        {
          name: "market",
          isMut: true,
          isSigner: false,
          desc: "This account holds the market state"
        },
        {
          name: "successor",
          isMut: false,
          isSigner: true,
          desc: "The successor account must sign to claim authority"
        }
      ],
      args: [],
      discriminant: {
        type: "u8",
        value: 101
      }
    },
    {
      name: "NameSuccessor",
      accounts: [
        {
          name: "phoenixProgram",
          isMut: false,
          isSigner: false,
          desc: "Phoenix program"
        },
        {
          name: "logAuthority",
          isMut: false,
          isSigner: false,
          desc: "Phoenix log authority"
        },
        {
          name: "market",
          isMut: true,
          isSigner: false,
          desc: "This account holds the market state"
        },
        {
          name: "marketAuthority",
          isMut: false,
          isSigner: true,
          desc: "The market_authority account must sign to name successor"
        }
      ],
      args: [
        {
          name: "successor",
          type: "publicKey"
        }
      ],
      discriminant: {
        type: "u8",
        value: 102
      }
    },
    {
      name: "ChangeMarketStatus",
      accounts: [
        {
          name: "phoenixProgram",
          isMut: false,
          isSigner: false,
          desc: "Phoenix program"
        },
        {
          name: "logAuthority",
          isMut: false,
          isSigner: false,
          desc: "Phoenix log authority"
        },
        {
          name: "market",
          isMut: true,
          isSigner: false,
          desc: "This account holds the market state"
        },
        {
          name: "marketAuthority",
          isMut: false,
          isSigner: true,
          desc: "The market_authority account must sign to change market status"
        }
      ],
      args: [
        {
          name: "marketStatus",
          type: {
            defined: "MarketStatus"
          }
        }
      ],
      discriminant: {
        type: "u8",
        value: 103
      }
    },
    {
      name: "ChangeSeatStatus",
      accounts: [
        {
          name: "phoenixProgram",
          isMut: false,
          isSigner: false,
          desc: "Phoenix program"
        },
        {
          name: "logAuthority",
          isMut: false,
          isSigner: false,
          desc: "Phoenix log authority"
        },
        {
          name: "market",
          isMut: true,
          isSigner: false,
          desc: "This account holds the market state"
        },
        {
          name: "marketAuthority",
          isMut: false,
          isSigner: true,
          desc: "The market_authority account must sign to change seat status"
        },
        {
          name: "seat",
          isMut: true,
          isSigner: false
        }
      ],
      args: [
        {
          name: "approvalStatus",
          type: {
            defined: "SeatApprovalStatus"
          }
        }
      ],
      discriminant: {
        type: "u8",
        value: 104
      }
    },
    {
      name: "RequestSeatAuthorized",
      accounts: [
        {
          name: "phoenixProgram",
          isMut: false,
          isSigner: false,
          desc: "Phoenix program"
        },
        {
          name: "logAuthority",
          isMut: false,
          isSigner: false,
          desc: "Phoenix log authority"
        },
        {
          name: "market",
          isMut: true,
          isSigner: false,
          desc: "This account holds the market state"
        },
        {
          name: "marketAuthority",
          isMut: false,
          isSigner: true,
          desc: "The market_authority account must sign to request a seat on behalf of a trader"
        },
        {
          name: "payer",
          isMut: true,
          isSigner: true
        },
        {
          name: "trader",
          isMut: false,
          isSigner: false
        },
        {
          name: "seat",
          isMut: true,
          isSigner: false
        },
        {
          name: "systemProgram",
          isMut: false,
          isSigner: false,
          desc: "System program"
        }
      ],
      args: [],
      discriminant: {
        type: "u8",
        value: 105
      }
    },
    {
      name: "EvictSeat",
      accounts: [
        {
          name: "phoenixProgram",
          isMut: false,
          isSigner: false,
          desc: "Phoenix program"
        },
        {
          name: "logAuthority",
          isMut: false,
          isSigner: false,
          desc: "Phoenix log authority"
        },
        {
          name: "market",
          isMut: true,
          isSigner: false,
          desc: "This account holds the market state"
        },
        {
          name: "marketAuthority",
          isMut: false,
          isSigner: true,
          desc: "The market_authority account must sign to evict a seat"
        },
        {
          name: "trader",
          isMut: false,
          isSigner: false
        },
        {
          name: "seat",
          isMut: false,
          isSigner: false,
          desc: "The trader's PDA seat account, seeds are [b'seat', market_address, trader_address]"
        },
        {
          name: "baseAccount",
          isMut: true,
          isSigner: false
        },
        {
          name: "quoteAccount",
          isMut: true,
          isSigner: false
        },
        {
          name: "baseVault",
          isMut: true,
          isSigner: false
        },
        {
          name: "quoteVault",
          isMut: true,
          isSigner: false
        },
        {
          name: "tokenProgram",
          isMut: false,
          isSigner: false,
          desc: "Token program"
        }
      ],
      args: [],
      discriminant: {
        type: "u8",
        value: 106
      }
    },
    {
      name: "ForceCancelOrders",
      accounts: [
        {
          name: "phoenixProgram",
          isMut: false,
          isSigner: false,
          desc: "Phoenix program"
        },
        {
          name: "logAuthority",
          isMut: false,
          isSigner: false,
          desc: "Phoenix log authority"
        },
        {
          name: "market",
          isMut: true,
          isSigner: false,
          desc: "This account holds the market state"
        },
        {
          name: "marketAuthority",
          isMut: false,
          isSigner: true,
          desc: "The market_authority account must sign to claim authority"
        },
        {
          name: "trader",
          isMut: false,
          isSigner: false
        },
        {
          name: "seat",
          isMut: false,
          isSigner: false,
          desc: "The trader's PDA seat account, seeds are [b'seat', market_address, trader_address]"
        },
        {
          name: "baseAccount",
          isMut: true,
          isSigner: false,
          desc: "Trader base token account"
        },
        {
          name: "quoteAccount",
          isMut: true,
          isSigner: false,
          desc: "Trader quote token account"
        },
        {
          name: "baseVault",
          isMut: true,
          isSigner: false,
          desc: "Base vault PDA, seeds are [b'vault', market_address, base_mint_address]"
        },
        {
          name: "quoteVault",
          isMut: true,
          isSigner: false,
          desc: "Quote vault PDA, seeds are [b'vault', market_address, quote_mint_address]"
        },
        {
          name: "tokenProgram",
          isMut: false,
          isSigner: false,
          desc: "Token program"
        }
      ],
      args: [
        {
          name: "params",
          type: {
            defined: "CancelUpToParams"
          }
        }
      ],
      discriminant: {
        type: "u8",
        value: 107
      }
    },
    {
      name: "CollectFees",
      accounts: [
        {
          name: "phoenixProgram",
          isMut: false,
          isSigner: false,
          desc: "Phoenix program"
        },
        {
          name: "logAuthority",
          isMut: false,
          isSigner: false,
          desc: "Phoenix log authority"
        },
        {
          name: "market",
          isMut: true,
          isSigner: false,
          desc: "This account holds the market state"
        },
        {
          name: "sweeper",
          isMut: false,
          isSigner: true,
          desc: "Signer of collect fees instruction"
        },
        {
          name: "feeRecipient",
          isMut: true,
          isSigner: false,
          desc: "Fee collector quote token account"
        },
        {
          name: "quoteVault",
          isMut: true,
          isSigner: false,
          desc: "Quote vault PDA, seeds are [b'vault', market_address, quote_mint_address]"
        },
        {
          name: "tokenProgram",
          isMut: false,
          isSigner: false,
          desc: "Token program"
        }
      ],
      args: [],
      discriminant: {
        type: "u8",
        value: 108
      }
    },
    {
      name: "ChangeFeeRecipient",
      accounts: [
        {
          name: "phoenixProgram",
          isMut: false,
          isSigner: false,
          desc: "Phoenix program"
        },
        {
          name: "logAuthority",
          isMut: false,
          isSigner: false,
          desc: "Phoenix log authority"
        },
        {
          name: "market",
          isMut: true,
          isSigner: false,
          desc: "This account holds the market state"
        },
        {
          name: "marketAuthority",
          isMut: false,
          isSigner: true,
          desc: "The market_authority account must sign to change the free recipient"
        },
        {
          name: "newFeeRecipient",
          isMut: false,
          isSigner: false,
          desc: "New fee recipient"
        }
      ],
      args: [],
      discriminant: {
        type: "u8",
        value: 109
      }
    }
  ],
  types: [
    {
      name: "MarketSizeParams",
      type: {
        kind: "struct",
        fields: [
          {
            name: "bidsSize",
            type: "u64"
          },
          {
            name: "asksSize",
            type: "u64"
          },
          {
            name: "numSeats",
            type: "u64"
          }
        ]
      }
    },
    {
      name: "TokenParams",
      type: {
        kind: "struct",
        fields: [
          {
            name: "decimals",
            type: "u32"
          },
          {
            name: "vaultBump",
            type: "u32"
          },
          {
            name: "mintKey",
            type: "publicKey"
          },
          {
            name: "vaultKey",
            type: "publicKey"
          }
        ]
      }
    },
    {
      name: "Seat",
      type: {
        kind: "struct",
        fields: [
          {
            name: "discriminant",
            type: "u64"
          },
          {
            name: "market",
            type: "publicKey"
          },
          {
            name: "trader",
            type: "publicKey"
          },
          {
            name: "approvalStatus",
            type: "u64"
          },
          {
            name: "padding",
            type: {
              array: ["u64", 6]
            }
          }
        ]
      }
    },
    {
      name: "AuditLogHeader",
      type: {
        kind: "struct",
        fields: [
          {
            name: "instruction",
            type: "u8"
          },
          {
            name: "sequenceNumber",
            type: "u64"
          },
          {
            name: "timestamp",
            type: "i64"
          },
          {
            name: "slot",
            type: "u64"
          },
          {
            name: "market",
            type: "publicKey"
          },
          {
            name: "signer",
            type: "publicKey"
          },
          {
            name: "totalEvents",
            type: "u16"
          }
        ]
      }
    },
    {
      name: "FillEvent",
      type: {
        kind: "struct",
        fields: [
          {
            name: "index",
            type: "u16"
          },
          {
            name: "makerId",
            type: "publicKey"
          },
          {
            name: "orderSequenceNumber",
            type: "u64"
          },
          {
            name: "priceInTicks",
            type: "u64"
          },
          {
            name: "baseLotsFilled",
            type: "u64"
          },
          {
            name: "baseLotsRemaining",
            type: "u64"
          }
        ]
      }
    },
    {
      name: "ReduceEvent",
      type: {
        kind: "struct",
        fields: [
          {
            name: "index",
            type: "u16"
          },
          {
            name: "orderSequenceNumber",
            type: "u64"
          },
          {
            name: "priceInTicks",
            type: "u64"
          },
          {
            name: "baseLotsRemoved",
            type: "u64"
          },
          {
            name: "baseLotsRemaining",
            type: "u64"
          }
        ]
      }
    },
    {
      name: "PlaceEvent",
      type: {
        kind: "struct",
        fields: [
          {
            name: "index",
            type: "u16"
          },
          {
            name: "orderSequenceNumber",
            type: "u64"
          },
          {
            name: "clientOrderId",
            type: "u128"
          },
          {
            name: "priceInTicks",
            type: "u64"
          },
          {
            name: "baseLotsPlaced",
            type: "u64"
          }
        ]
      }
    },
    {
      name: "EvictEvent",
      type: {
        kind: "struct",
        fields: [
          {
            name: "index",
            type: "u16"
          },
          {
            name: "makerId",
            type: "publicKey"
          },
          {
            name: "orderSequenceNumber",
            type: "u64"
          },
          {
            name: "priceInTicks",
            type: "u64"
          },
          {
            name: "baseLotsEvicted",
            type: "u64"
          }
        ]
      }
    },
    {
      name: "FillSummaryEvent",
      type: {
        kind: "struct",
        fields: [
          {
            name: "index",
            type: "u16"
          },
          {
            name: "clientOrderId",
            type: "u128"
          },
          {
            name: "totalBaseLotsFilled",
            type: "u64"
          },
          {
            name: "totalQuoteLotsFilled",
            type: "u64"
          },
          {
            name: "totalFeeInQuoteLots",
            type: "u64"
          }
        ]
      }
    },
    {
      name: "FeeEvent",
      type: {
        kind: "struct",
        fields: [
          {
            name: "index",
            type: "u16"
          },
          {
            name: "feesCollectedInQuoteLots",
            type: "u64"
          }
        ]
      }
    },
    {
      name: "TimeInForceEvent",
      type: {
        kind: "struct",
        fields: [
          {
            name: "index",
            type: "u16"
          },
          {
            name: "orderSequenceNumber",
            type: "u64"
          },
          {
            name: "lastValidSlot",
            type: "u64"
          },
          {
            name: "lastValidUnixTimestampInSeconds",
            type: "u64"
          }
        ]
      }
    },
    {
      name: "ExpiredOrderEvent",
      type: {
        kind: "struct",
        fields: [
          {
            name: "index",
            type: "u16"
          },
          {
            name: "makerId",
            type: "publicKey"
          },
          {
            name: "orderSequenceNumber",
            type: "u64"
          },
          {
            name: "priceInTicks",
            type: "u64"
          },
          {
            name: "baseLotsRemoved",
            type: "u64"
          }
        ]
      }
    },
    {
      name: "CancelUpToParams",
      type: {
        kind: "struct",
        fields: [
          {
            name: "side",
            type: {
              defined: "Side"
            }
          },
          {
            name: "tickLimit",
            type: {
              option: "u64"
            }
          },
          {
            name: "numOrdersToSearch",
            type: {
              option: "u32"
            }
          },
          {
            name: "numOrdersToCancel",
            type: {
              option: "u32"
            }
          }
        ]
      }
    },
    {
      name: "CancelMultipleOrdersByIdParams",
      type: {
        kind: "struct",
        fields: [
          {
            name: "orders",
            type: {
              vec: {
                defined: "CancelOrderParams"
              }
            }
          }
        ]
      }
    },
    {
      name: "DepositParams",
      type: {
        kind: "struct",
        fields: [
          {
            name: "quoteLotsToDeposit",
            type: "u64"
          },
          {
            name: "baseLotsToDeposit",
            type: "u64"
          }
        ]
      }
    },
    {
      name: "InitializeParams",
      type: {
        kind: "struct",
        fields: [
          {
            name: "marketSizeParams",
            type: {
              defined: "MarketSizeParams"
            }
          },
          {
            name: "numQuoteLotsPerQuoteUnit",
            type: "u64"
          },
          {
            name: "tickSizeInQuoteLotsPerBaseUnit",
            type: "u64"
          },
          {
            name: "numBaseLotsPerBaseUnit",
            type: "u64"
          },
          {
            name: "takerFeeBps",
            type: "u16"
          },
          {
            name: "feeCollector",
            type: "publicKey"
          },
          {
            name: "rawBaseUnitsPerBaseUnit",
            type: {
              option: "u32"
            }
          }
        ]
      }
    },
    {
      name: "MultipleOrderPacket",
      type: {
        kind: "struct",
        fields: [
          {
            name: "bids",
            type: {
              vec: {
                defined: "CondensedOrder"
              }
            }
          },
          {
            name: "asks",
            type: {
              vec: {
                defined: "CondensedOrder"
              }
            }
          },
          {
            name: "clientOrderId",
            type: {
              option: "u128"
            }
          },
          {
            name: "rejectPostOnly",
            type: "bool"
          }
        ]
      }
    },
    {
      name: "CondensedOrder",
      type: {
        kind: "struct",
        fields: [
          {
            name: "priceInTicks",
            type: "u64"
          },
          {
            name: "sizeInBaseLots",
            type: "u64"
          },
          {
            name: "lastValidSlot",
            type: {
              option: "u64"
            }
          },
          {
            name: "lastValidUnixTimestampInSeconds",
            type: {
              option: "u64"
            }
          }
        ]
      }
    },
    {
      name: "CancelOrderParams",
      type: {
        kind: "struct",
        fields: [
          {
            name: "side",
            type: {
              defined: "Side"
            }
          },
          {
            name: "priceInTicks",
            type: "u64"
          },
          {
            name: "orderSequenceNumber",
            type: "u64"
          }
        ]
      }
    },
    {
      name: "ReduceOrderParams",
      type: {
        kind: "struct",
        fields: [
          {
            name: "baseParams",
            type: {
              defined: "CancelOrderParams"
            }
          },
          {
            name: "size",
            type: "u64"
          }
        ]
      }
    },
    {
      name: "WithdrawParams",
      type: {
        kind: "struct",
        fields: [
          {
            name: "quoteLotsToWithdraw",
            type: {
              option: "u64"
            }
          },
          {
            name: "baseLotsToWithdraw",
            type: {
              option: "u64"
            }
          }
        ]
      }
    },
    {
      name: "MarketHeader",
      type: {
        kind: "struct",
        fields: [
          {
            name: "discriminant",
            type: "u64"
          },
          {
            name: "status",
            type: "u64"
          },
          {
            name: "marketSizeParams",
            type: {
              defined: "MarketSizeParams"
            }
          },
          {
            name: "baseParams",
            type: {
              defined: "TokenParams"
            }
          },
          {
            name: "baseLotSize",
            type: "u64"
          },
          {
            name: "quoteParams",
            type: {
              defined: "TokenParams"
            }
          },
          {
            name: "quoteLotSize",
            type: "u64"
          },
          {
            name: "tickSizeInQuoteAtomsPerBaseUnit",
            type: "u64"
          },
          {
            name: "authority",
            type: "publicKey"
          },
          {
            name: "feeRecipient",
            type: "publicKey"
          },
          {
            name: "marketSequenceNumber",
            type: "u64"
          },
          {
            name: "successor",
            type: "publicKey"
          },
          {
            name: "rawBaseUnitsPerBaseUnit",
            type: "u32"
          },
          {
            name: "padding1",
            type: "u32"
          },
          {
            name: "padding2",
            type: {
              array: ["u64", 32]
            }
          }
        ]
      }
    },
    {
      name: "PhoenixMarketEvent",
      type: {
        kind: "enum",
        variants: [
          {
            name: "Uninitialized"
          },
          {
            name: "Header",
            fields: [
              {
                defined: "AuditLogHeader"
              }
            ]
          },
          {
            name: "Fill",
            fields: [
              {
                defined: "FillEvent"
              }
            ]
          },
          {
            name: "Place",
            fields: [
              {
                defined: "PlaceEvent"
              }
            ]
          },
          {
            name: "Reduce",
            fields: [
              {
                defined: "ReduceEvent"
              }
            ]
          },
          {
            name: "Evict",
            fields: [
              {
                defined: "EvictEvent"
              }
            ]
          },
          {
            name: "FillSummary",
            fields: [
              {
                defined: "FillSummaryEvent"
              }
            ]
          },
          {
            name: "Fee",
            fields: [
              {
                defined: "FeeEvent"
              }
            ]
          },
          {
            name: "TimeInForce",
            fields: [
              {
                defined: "TimeInForceEvent"
              }
            ]
          },
          {
            name: "ExpiredOrder",
            fields: [
              {
                defined: "ExpiredOrderEvent"
              }
            ]
          }
        ]
      }
    },
    {
      name: "MarketStatus",
      type: {
        kind: "enum",
        variants: [
          {
            name: "Uninitialized"
          },
          {
            name: "Active"
          },
          {
            name: "PostOnly"
          },
          {
            name: "Paused"
          },
          {
            name: "Closed"
          },
          {
            name: "Tombstoned"
          }
        ]
      }
    },
    {
      name: "SeatApprovalStatus",
      type: {
        kind: "enum",
        variants: [
          {
            name: "NotApproved"
          },
          {
            name: "Approved"
          },
          {
            name: "Retired"
          }
        ]
      }
    },
    {
      name: "OrderPacket",
      type: {
        kind: "enum",
        variants: [
          {
            name: "PostOnly",
            fields: [
              {
                name: "side",
                type: {
                  defined: "Side"
                }
              },
              {
                name: "price_in_ticks",
                type: "u64"
              },
              {
                name: "num_base_lots",
                type: "u64"
              },
              {
                name: "client_order_id",
                type: "u128"
              },
              {
                name: "reject_post_only",
                type: "bool"
              },
              {
                name: "use_only_deposited_funds",
                type: "bool"
              },
              {
                name: "last_valid_slot",
                type: {
                  option: "u64"
                }
              },
              {
                name: "last_valid_unix_timestamp_in_seconds",
                type: {
                  option: "u64"
                }
              }
            ]
          },
          {
            name: "Limit",
            fields: [
              {
                name: "side",
                type: {
                  defined: "Side"
                }
              },
              {
                name: "price_in_ticks",
                type: "u64"
              },
              {
                name: "num_base_lots",
                type: "u64"
              },
              {
                name: "self_trade_behavior",
                type: {
                  defined: "SelfTradeBehavior"
                }
              },
              {
                name: "match_limit",
                type: {
                  option: "u64"
                }
              },
              {
                name: "client_order_id",
                type: "u128"
              },
              {
                name: "use_only_deposited_funds",
                type: "bool"
              },
              {
                name: "last_valid_slot",
                type: {
                  option: "u64"
                }
              },
              {
                name: "last_valid_unix_timestamp_in_seconds",
                type: {
                  option: "u64"
                }
              }
            ]
          },
          {
            name: "ImmediateOrCancel",
            fields: [
              {
                name: "side",
                type: {
                  defined: "Side"
                }
              },
              {
                name: "price_in_ticks",
                type: {
                  option: "u64"
                }
              },
              {
                name: "num_base_lots",
                type: "u64"
              },
              {
                name: "num_quote_lots",
                type: "u64"
              },
              {
                name: "min_base_lots_to_fill",
                type: "u64"
              },
              {
                name: "min_quote_lots_to_fill",
                type: "u64"
              },
              {
                name: "self_trade_behavior",
                type: {
                  defined: "SelfTradeBehavior"
                }
              },
              {
                name: "match_limit",
                type: {
                  option: "u64"
                }
              },
              {
                name: "client_order_id",
                type: "u128"
              },
              {
                name: "use_only_deposited_funds",
                type: "bool"
              },
              {
                name: "last_valid_slot",
                type: {
                  option: "u64"
                }
              },
              {
                name: "last_valid_unix_timestamp_in_seconds",
                type: {
                  option: "u64"
                }
              }
            ]
          }
        ]
      }
    },
    {
      name: "Side",
      type: {
        kind: "enum",
        variants: [
          {
            name: "Bid"
          },
          {
            name: "Ask"
          }
        ]
      }
    },
    {
      name: "SelfTradeBehavior",
      type: {
        kind: "enum",
        variants: [
          {
            name: "Abort"
          },
          {
            name: "CancelProvide"
          },
          {
            name: "DecrementTake"
          }
        ]
      }
    }
  ],
  errors: [
    {
      code: 0,
      name: "InvalidMarketParameters",
      msg: "Invalid market parameters error"
    },
    {
      code: 1,
      name: "InvalidMarketAuthority",
      msg: "Invalid market authority error"
    },
    {
      code: 2,
      name: "FailedToLoadMarketFromAccount",
      msg: "Market deserialization error"
    },
    {
      code: 3,
      name: "MarketAlreadyInitialized",
      msg: "Market already initialized error"
    },
    {
      code: 4,
      name: "MarketUninitialized",
      msg: "Market is not initialized error"
    },
    {
      code: 5,
      name: "InvalidStateTransition",
      msg: "Invalid state transition error"
    },
    {
      code: 6,
      name: "InvalidMarketSigner",
      msg: "Invalid market signer error"
    },
    {
      code: 7,
      name: "InvalidLotSize",
      msg: "Invalid lot size error"
    },
    {
      code: 8,
      name: "InvalidTickSize",
      msg: "Invalid tick size error"
    },
    {
      code: 9,
      name: "InvalidMint",
      msg: "Invalid mint error"
    },
    {
      code: 10,
      name: "InvalidBaseVault",
      msg: "Invalid base vault error"
    },
    {
      code: 11,
      name: "InvalidQuoteVault",
      msg: "Invalid quote vault error"
    },
    {
      code: 12,
      name: "InvalidBaseAccount",
      msg: "Invalid base account error"
    },
    {
      code: 13,
      name: "InvalidQuoteAccount",
      msg: "Invalid quote account error"
    },
    {
      code: 14,
      name: "TooManyEvents",
      msg: "Too many events error"
    },
    {
      code: 15,
      name: "NewOrderError",
      msg: "New order error"
    },
    {
      code: 16,
      name: "ReduceOrderError",
      msg: "Reduce order error"
    },
    {
      code: 17,
      name: "CancelMultipleOrdersError",
      msg: "Cancel multiple orders error"
    },
    {
      code: 18,
      name: "WithdrawFundsError",
      msg: "Withdraw funds error"
    },
    {
      code: 19,
      name: "RemoveEmptyOrdersError",
      msg: "Remove empty orders error"
    },
    {
      code: 20,
      name: "TraderNotFound",
      msg: "Trader not found error"
    },
    {
      code: 21,
      name: "InvalidSeatStatus",
      msg: "Invalid seat status"
    },
    {
      code: 22,
      name: "EvictionError",
      msg: "Failed to evict trader"
    },
    {
      code: 23,
      name: "NonEmptyScratchBuffer",
      msg: "Non empty scratch buffer"
    },
    {
      code: 24,
      name: "FailedToSerializeEvent",
      msg: "Failed to serialize event"
    },
    {
      code: 25,
      name: "FailedToFlushBuffer",
      msg: "Failed to flush buffer"
    }
  ],
  metadata: {
    origin: "shank",
    address: "PhoeNiXZ8ByJGLkxNfZRnkUfjvmuYqLR89jjFHGqdXY"
  }
};

// src/parsers/v2/account/phoenix.ts
var createShankPhoenixAccount = (idlItem) => {
  const idl = idlItem.idl;
  const accountLayouts = new KinobiTreeGenerator(
    {
      version: "",
      name: "",
      instructions: [],
      metadata: {
        address: ""
      }
    },
    0 /* ACCOUNTS */,
    idl
  ).constructLayout(0 /* ACCOUNTS */);
  const parseAccount = (accountData, mapTypes) => {
    try {
      const dataBuffer = Buffer.from(accountData, "base64");
      const discriminant = dataBuffer.subarray(0, 8).toString("base64");
      const accountSerializer = accountLayouts.get(discriminant);
      if (accountSerializer && dataBuffer.byteLength > 0) {
        const decodedAccountData = accountSerializer.serializer?.deserialize(dataBuffer);
        if (decodedAccountData && decodedAccountData[0]) {
          const filteredIdlAccount = PhoenixIDL.accounts?.filter(
            (account) => account.name.toLowerCase() === accountSerializer?.instructionName.toLowerCase()
          ) ?? [];
          if (mapTypes) {
            decodedAccountData[0] = mapDataTypeToName(decodedAccountData[0], filteredIdlAccount[0]?.type.fields);
          }
          return {
            name: accountSerializer.instructionName,
            data: (0, import_utils6.convertBNToNumberInObject)(decodedAccountData[0]),
            type: "account" /* ACCOUNT */
          };
        }
      }
      return null;
    } catch (error) {
      console.error(error);
      return null;
    }
  };
  const getProgramName = () => {
    return "phoenix";
  };
  return {
    accountLayouts,
    parseAccount,
    getProgramName
  };
};

// src/parsers/v2/account/shank.ts
var import_utils7 = require("@solanafm/utils");
var createShankAccountParser = (idlItem, serializationType) => {
  const idl = idlItem.idl;
  const accountSerializationType = serializationType ?? 1 /* BORSH */;
  const accountLayouts = new KinobiTreeGenerator(idl).constructLayout(0 /* ACCOUNTS */);
  const parseAccount = (accountData, mapTypes) => {
    try {
      let dataBuffer = Buffer.from(accountData, "base64");
      let accountSerializer = void 0;
      if (dataBuffer.byteLength > 0) {
        switch (accountSerializationType) {
          case 0 /* BINCODE */:
            const bincodeDiscriminant = Buffer.from(dataBuffer).readUint32LE(0);
            dataBuffer = dataBuffer.subarray(4);
            accountSerializer = accountLayouts.get(bincodeDiscriminant);
            break;
          case 1 /* BORSH */:
            const borshDiscriminant = Buffer.from(dataBuffer).readUint8(0);
            accountSerializer = accountLayouts.get(borshDiscriminant);
            break;
          case 2 /* SYSVAR */:
            accountSerializer = accountLayouts.get(0);
            break;
        }
        if (accountSerializer) {
          const decodedAccountData = accountSerializer.serializer?.deserialize(dataBuffer);
          if (decodedAccountData && decodedAccountData[0]) {
            const filteredIdlAccount = idl.accounts?.filter(
              (account) => account.name.toLowerCase() === accountSerializer?.instructionName.toLowerCase()
            ) ?? [];
            if (mapTypes) {
              decodedAccountData[0] = mapDataTypeToName(decodedAccountData[0], filteredIdlAccount[0]?.type.fields);
            }
            return {
              name: accountSerializer.instructionName,
              data: (0, import_utils7.convertBNToNumberInObject)(decodedAccountData[0]),
              type: "account" /* ACCOUNT */
            };
          }
        }
      }
      return null;
    } catch (error) {
      console.error(error);
      return null;
    }
  };
  const getProgramName = () => {
    return idl.name;
  };
  return {
    accountLayouts,
    parseAccount,
    getProgramName
  };
};

// src/parsers/v2/account/token.ts
var import_utils8 = require("@solanafm/utils");
var createShankTokenAccount = (idlItem) => {
  const idl = idlItem.idl;
  const accountLayouts = new KinobiTreeGenerator(idl).constructLayout(0 /* ACCOUNTS */);
  const ACCOUNT_MAX_SIZE = 165;
  const MINT_MAX_SIZE = 82;
  const MULTISIG_MAX_SIZE = 355;
  const parseAccount = (accountData, mapTypes) => {
    try {
      const dataBuffer = Buffer.from(accountData, "base64");
      let accountSerializer = void 0;
      if (dataBuffer.byteLength < MINT_MAX_SIZE && dataBuffer.byteLength > MULTISIG_MAX_SIZE) {
        return null;
      }
      if (dataBuffer.byteLength < ACCOUNT_MAX_SIZE && dataBuffer.byteLength === MINT_MAX_SIZE) {
        accountSerializer = accountLayouts.get(0);
      } else if (dataBuffer.byteLength < MULTISIG_MAX_SIZE && dataBuffer.byteLength === ACCOUNT_MAX_SIZE) {
        accountSerializer = accountLayouts.get(1);
      } else if (dataBuffer.byteLength > ACCOUNT_MAX_SIZE && dataBuffer.byteLength === MULTISIG_MAX_SIZE) {
        accountSerializer = accountLayouts.get(2);
        if (accountSerializer) {
          const decodedAccountData = accountSerializer.serializer?.deserialize(dataBuffer);
          if (decodedAccountData && decodedAccountData[0]) {
            decodedAccountData[0].signers = decodedAccountData[0].signers.filter(
              (signer) => signer !== "11111111111111111111111111111111"
            );
            const filteredIdlAccount = idl.accounts?.filter(
              (account) => account.name.toLowerCase() === accountSerializer?.instructionName.toLowerCase()
            ) ?? [];
            if (mapTypes) {
              decodedAccountData[0] = mapDataTypeToName(decodedAccountData[0], filteredIdlAccount[0]?.type.fields);
            }
            return {
              name: accountSerializer.instructionName,
              data: (0, import_utils8.convertBNToNumberInObject)(decodedAccountData[0]),
              type: "account" /* ACCOUNT */
            };
          }
        }
      }
      if (accountSerializer) {
        const decodedAccountData = accountSerializer.serializer?.deserialize(dataBuffer);
        if (decodedAccountData && decodedAccountData[0]) {
          const filteredIdlAccount = idl.accounts?.filter(
            (account) => account.name.toLowerCase() === accountSerializer?.instructionName.toLowerCase()
          ) ?? [];
          if (mapTypes) {
            decodedAccountData[0] = mapDataTypeToName(decodedAccountData[0], filteredIdlAccount[0]?.type.fields);
          }
          return {
            name: accountSerializer.instructionName,
            data: (0, import_utils8.convertBNToNumberInObject)(decodedAccountData[0]),
            type: "account" /* ACCOUNT */
          };
        }
      }
      return null;
    } catch (error) {
      console.error(error);
      return null;
    }
  };
  const getProgramName = () => {
    return idl.name;
  };
  return {
    accountLayouts,
    parseAccount,
    getProgramName
  };
};

// src/parsers/v2/account/metadata.ts
var import_umi_serializers = require("@metaplex-foundation/umi-serializers");
var import_utils9 = require("@solanafm/utils");
var createShankMetaplexAccountParser = (idlItem) => {
  const idl = idlItem.idl;
  const accountLayouts = new KinobiTreeGenerator(idl).constructLayout(0 /* ACCOUNTS */);
  const parseAccount = (accountData, mapTypes) => {
    try {
      let dataBuffer = Buffer.from(accountData, "base64");
      if (dataBuffer.byteLength > 0) {
        const borshDiscriminant = Buffer.from(dataBuffer).readUint8(0);
        const accountSerializer = accountLayouts.get(borshDiscriminant);
        if (accountSerializer && borshDiscriminant === 4) {
          let sanitisedMetaAccount = sanitySerializeMetadataAccount(dataBuffer, accountSerializer, idl);
          if (sanitisedMetaAccount && Object.keys(sanitisedMetaAccount).length > 0) {
            const filteredIdlAccount = (idl.accounts ?? [])[3];
            if (mapTypes) {
              sanitisedMetaAccount = mapDataTypeToName(sanitisedMetaAccount, filteredIdlAccount?.type.fields);
            }
            return {
              name: accountSerializer.instructionName,
              data: (0, import_utils9.convertBNToNumberInObject)(sanitisedMetaAccount),
              type: "account" /* ACCOUNT */
            };
          }
        }
        if (accountSerializer) {
          const decodedAccountData = accountSerializer.serializer?.deserialize(dataBuffer);
          if (decodedAccountData && decodedAccountData[0]) {
            const filteredIdlAccount = idl.accounts?.filter(
              (account) => account.name.toLowerCase() === accountSerializer?.instructionName.toLowerCase()
            ) ?? [];
            if (mapTypes) {
              decodedAccountData[0] = mapDataTypeToName(decodedAccountData[0], filteredIdlAccount[0]?.type.fields);
            }
            return {
              name: accountSerializer.instructionName,
              data: (0, import_utils9.convertBNToNumberInObject)(decodedAccountData[0]),
              type: "account" /* ACCOUNT */
            };
          }
        }
      }
      return null;
    } catch (error) {
      console.error(error);
      return null;
    }
  };
  const getProgramName = () => {
    return idl.name;
  };
  return {
    accountLayouts,
    parseAccount,
    getProgramName
  };
};
var sanitySerializeMetadataAccount = (accountDataBuffer, accountSerializer, idl) => {
  try {
    const decodedAccountData = accountSerializer.serializer?.deserialize(accountDataBuffer);
    if (decodedAccountData && decodedAccountData[0]) {
      return decodedAccountData[0];
    }
    return null;
  } catch (error) {
    if (error) {
      const typeLayouts = new KinobiTreeGenerator(idl).constructLayout(2 /* TYPES */);
      const keySerializer = typeLayouts.get("Key")?.serializer;
      const dataSerializer = typeLayouts.get("Data")?.serializer;
      const tokenStandardSerializer = typeLayouts.get("TokenStandard")?.serializer;
      const collectionSerializer = typeLayouts.get("Collection")?.serializer;
      const usesSerializer = typeLayouts.get("Uses")?.serializer;
      const collectionDetailsSerializer = typeLayouts.get("CollectionDetails")?.serializer;
      const programmableConfigSerializer = typeLayouts.get("ProgrammableConfig")?.serializer;
      if (keySerializer && dataSerializer && tokenStandardSerializer && collectionSerializer && usesSerializer && collectionDetailsSerializer && programmableConfigSerializer) {
        let cursor = 0;
        let customStruct = {};
        const [key, _] = keySerializer.deserialize(accountDataBuffer, cursor);
        cursor += keySerializer.maxSize ?? 1;
        customStruct[typeLayouts.get("Key").instructionName] = key;
        const [updateAuthority] = (0, import_umi_serializers.publicKey)().deserialize(accountDataBuffer, cursor);
        cursor += 32;
        customStruct["updateAuthority"] = updateAuthority;
        const [mint] = (0, import_umi_serializers.publicKey)().deserialize(accountDataBuffer, cursor);
        cursor += 32;
        customStruct["mint"] = mint;
        const [data, dataDelta] = dataSerializer.deserialize(accountDataBuffer, cursor);
        cursor += dataDelta - cursor;
        customStruct[typeLayouts.get("Data").instructionName] = data;
        const [primarySaleHappened] = (0, import_umi_serializers.bool)().deserialize(accountDataBuffer, cursor);
        cursor += 1;
        customStruct["primarySaleHappened"] = primarySaleHappened;
        const [isMutable] = (0, import_umi_serializers.bool)().deserialize(accountDataBuffer, cursor);
        cursor += 1;
        customStruct["isMutable"] = isMutable;
        const [editionNonce, editionNonceDelta] = (0, import_umi_serializers.option)((0, import_umi_serializers.u8)()).deserialize(accountDataBuffer, cursor);
        cursor += editionNonceDelta - cursor;
        customStruct["editionNonce"] = editionNonce;
        const [tokenStandard, tokenDelta, tokenCorrupted] = tryReadType(
          tokenStandardSerializer,
          accountDataBuffer,
          cursor
        );
        cursor += tokenDelta;
        customStruct[typeLayouts.get("TokenStandard").instructionName] = tokenStandard;
        const [collection, collectionDelta, collectionCorrupted] = tokenCorrupted ? [null, 1, true] : tryReadType(collectionSerializer, accountDataBuffer, cursor);
        cursor += collectionDelta;
        customStruct[typeLayouts.get("Collection").instructionName] = collection;
        const [uses, usesDelta, usesCorrupted] = tokenCorrupted || collectionCorrupted ? [null, 1, true] : tryReadType(usesSerializer, accountDataBuffer, cursor);
        cursor += usesDelta;
        customStruct[typeLayouts.get("Uses").instructionName] = uses;
        const [collectionDetails, collectionDetailsDelta] = tokenCorrupted || collectionCorrupted || usesCorrupted ? [null, 1, true] : tryReadType(collectionDetailsSerializer, accountDataBuffer, cursor);
        cursor += collectionDetailsDelta;
        customStruct[typeLayouts.get("CollectionDetails").instructionName] = collectionDetails;
        const [programmableConfig, programmableConfigDelta] = tokenCorrupted || collectionCorrupted || usesCorrupted ? [null, 1, true] : tryReadType(programmableConfigSerializer, accountDataBuffer, cursor);
        cursor += programmableConfigDelta;
        customStruct[typeLayouts.get("ProgrammableConfig").instructionName] = programmableConfig;
        return customStruct;
      }
    }
    return null;
  }
};
function tryReadType(serializer, accountBuffer, offset) {
  try {
    if (serializer) {
      const [parsedData, parsedDataDelta] = (0, import_umi_serializers.option)(serializer).deserialize(accountBuffer, offset);
      return [parsedData, parsedDataDelta - offset, false];
    }
    return [null, 1, true];
  } catch (e) {
    return [null, 1, true];
  }
}

// src/parsers/v2/account/token-v2.ts
var import_umi_serializers3 = require("@metaplex-foundation/umi-serializers");
var import_utils10 = require("@solanafm/utils");

// src/helpers/rust-option.ts
var import_umi = require("@metaplex-foundation/umi");
var import_umi_serializers2 = require("@metaplex-foundation/umi-serializers");
var tryToSerializeCOptionPubkey = (dataBuffer, serializationType) => {
  switch (serializationType) {
    case 1 /* BORSH */:
      let offset = 0;
      const [isSome, prefixOffset] = (0, import_umi_serializers2.u32)().deserialize(dataBuffer, offset);
      offset = prefixOffset;
      if (isSome === 0) {
        return [(0, import_umi.none)(), offset];
      } else if (isSome === 1) {
        const [value, newOffset] = (0, import_umi_serializers2.publicKey)().deserialize(dataBuffer, offset);
        offset = newOffset;
        return [(0, import_umi.some)(value), offset];
      }
      throw new Error("Unable to serialize COption<Pubkey> as Option Value is not 0 or 1");
    default:
      throw new Error("Unable to serialize COption<Pubkey> as Option Value is not 0 or 1");
  }
};

// src/parsers/v2/account/token-v2.ts
var createShankTokenV2Account = (idlItem) => {
  const idl = idlItem.idl;
  const accountLayouts = new KinobiTreeGenerator(idl).constructLayout(0 /* ACCOUNTS */);
  const typesLayouts = new KinobiTreeGenerator(idl).constructLayout(2 /* TYPES */);
  const MINT_MAX_SIZE = 82;
  const ACCOUNT_MAX_SIZE = 165;
  const MULTISIG_MAX_SIZE = 355;
  const parseAccount = (accountData, mapTypes) => {
    try {
      const dataBuffer = Buffer.from(accountData, "base64");
      let accountSerializer = void 0;
      if (dataBuffer.byteLength < ACCOUNT_MAX_SIZE && dataBuffer.byteLength === MINT_MAX_SIZE) {
        accountSerializer = accountLayouts.get(0);
        if (accountSerializer) {
          const parsedAccountData = parseAccountWithoutExtensions(accountSerializer, dataBuffer, idl, mapTypes);
          return {
            name: accountSerializer.instructionName,
            data: (0, import_utils10.convertBNToNumberInObject)(parsedAccountData),
            type: "account" /* ACCOUNT */
          };
        }
      } else if (dataBuffer.byteLength < MULTISIG_MAX_SIZE && dataBuffer.byteLength === ACCOUNT_MAX_SIZE) {
        accountSerializer = accountLayouts.get(1);
        if (accountSerializer) {
          const parsedAccountData = parseAccountWithoutExtensions(accountSerializer, dataBuffer, idl, mapTypes);
          return {
            name: accountSerializer.instructionName,
            data: (0, import_utils10.convertBNToNumberInObject)(parsedAccountData),
            type: "account" /* ACCOUNT */
          };
        }
      }
      if (dataBuffer.byteLength > ACCOUNT_MAX_SIZE && dataBuffer.byteLength === MULTISIG_MAX_SIZE) {
        accountSerializer = accountLayouts.get(2);
        if (accountSerializer) {
          const parsedAccountData = parseAccountWithoutExtensions(accountSerializer, dataBuffer, idl, mapTypes);
          parsedAccountData.signers = parsedAccountData.signers.filter(
            (signer) => signer !== "11111111111111111111111111111111"
          );
          return {
            name: accountSerializer.instructionName,
            data: (0, import_utils10.convertBNToNumberInObject)(parsedAccountData),
            type: "account" /* ACCOUNT */
          };
        }
      } else if (dataBuffer.byteLength >= ACCOUNT_MAX_SIZE) {
        let isMintAccount = false;
        try {
          const hasMintAuthorityCOption = tryToSerializeCOptionPubkey(
            dataBuffer.subarray(0, 36),
            1 /* BORSH */
          );
          const hasFreezeAuthorityCOption = tryToSerializeCOptionPubkey(
            dataBuffer.subarray(46, 82),
            1 /* BORSH */
          );
          if (hasMintAuthorityCOption && hasFreezeAuthorityCOption) {
            isMintAccount = true;
          }
        } catch (_) {
        }
        if (isMintAccount) {
          accountSerializer = accountLayouts.get(0);
          if (accountSerializer) {
            const decodedAccountData = accountSerializer.serializer?.deserialize(dataBuffer);
            if (decodedAccountData && decodedAccountData[1] === MINT_MAX_SIZE) {
              const { accountType, extensions } = parseExtensions(dataBuffer, typesLayouts);
              const combinedAccountData = {
                ...decodedAccountData[0],
                extensions,
                accountType
              };
              return {
                name: accountSerializer.instructionName,
                data: (0, import_utils10.convertBNToNumberInObject)(combinedAccountData),
                type: "account" /* ACCOUNT */
              };
            }
          }
        } else {
          accountSerializer = accountLayouts.get(1);
          if (accountSerializer) {
            const decodedAccountData = accountSerializer.serializer?.deserialize(dataBuffer);
            if (decodedAccountData && decodedAccountData[1] === ACCOUNT_MAX_SIZE) {
              const { accountType, extensions } = parseExtensions(dataBuffer, typesLayouts);
              const combinedAccountData = {
                ...decodedAccountData[0],
                extensions,
                accountType
              };
              return {
                name: accountSerializer.instructionName,
                data: (0, import_utils10.convertBNToNumberInObject)(combinedAccountData),
                type: "account" /* ACCOUNT */
              };
            }
          }
        }
      }
      return null;
    } catch (error) {
      console.error(error);
      return null;
    }
  };
  const getProgramName = () => {
    return idl.name;
  };
  return {
    accountLayouts,
    parseAccount,
    getProgramName
  };
};
var parseExtensions = (dataBuffer, typesLayouts) => {
  const extensionsDataBuffer = dataBuffer.subarray(165);
  const extensionAccountTypeSerializer = typesLayouts.get("AccountType");
  const extensionTypeSerializer = typesLayouts.get("ExtensionTypeWithFields");
  let extensions;
  let accountType;
  let numberOfExtensions = 0;
  let offset = 1;
  while (offset < extensionsDataBuffer.subarray(1).byteLength) {
    const extensionBuffer = extensionsDataBuffer.subarray(offset);
    const extensionLength = extensionBuffer.readUint16LE(2);
    offset = offset + 2 + 2 + extensionLength;
    numberOfExtensions++;
  }
  if (extensionAccountTypeSerializer && extensionAccountTypeSerializer.serializer) {
    const decodedAccountType = extensionAccountTypeSerializer.serializer.deserialize(extensionsDataBuffer);
    accountType = decodedAccountType[0];
  }
  if (extensionTypeSerializer && extensionTypeSerializer.serializer) {
    const extensionSerializerArray = (0, import_umi_serializers3.array)(extensionTypeSerializer.serializer, {
      size: numberOfExtensions
    });
    const decodedExtensionData = extensionSerializerArray.deserialize(extensionsDataBuffer.subarray(1));
    extensions = decodedExtensionData[0];
  }
  return {
    extensions,
    accountType
  };
};
var parseAccountWithoutExtensions = (accountSerializer, dataBuffer, idl, mapTypes) => {
  if (accountSerializer) {
    const decodedAccountData = accountSerializer.serializer?.deserialize(dataBuffer);
    if (decodedAccountData && decodedAccountData[0]) {
      const filteredIdlAccount = idl.accounts?.filter(
        (account) => account.name.toLowerCase() === accountSerializer?.instructionName.toLowerCase()
      ) ?? [];
      if (mapTypes) {
        decodedAccountData[0] = mapDataTypeToName(decodedAccountData[0], filteredIdlAccount[0]?.type.fields);
      }
      return decodedAccountData[0];
    }
  }
  return null;
};

// src/interfaces/AccountParserInterface.ts
var createAccountParser = (idlItem, programHash, accountHash) => {
  switch (idlItem.idlType) {
    case "anchor":
      return createAnchorAccountParser(idlItem);
    case "anchorV1":
      return createAnchorV1AccountParser(idlItem);
    case "shank":
      const localSysvars = [
        "SysvarC1ock11111111111111111111111111111111",
        "SysvarEpochSchedu1e111111111111111111111111",
        "SysvarFees111111111111111111111111111111111",
        "SysvarRecentB1ockHashes11111111111111111111",
        "SysvarRent111111111111111111111111111111111",
        "SysvarRewards111111111111111111111111111111",
        "SysvarS1otHashes111111111111111111111111111",
        "SysvarStakeHistory1111111111111111111111111"
      ];
      const localBincode = [
        "Vote111111111111111111111111111111111111111",
        "Stake11111111111111111111111111111111111111",
        "BPFLoaderUpgradeab1e11111111111111111111111",
        "AddressLookupTab1e1111111111111111111111111"
      ];
      const localBorsh = [
        "metaqbxxUerdq28cj1RbAWkYQm3ybzjb6a8bt518x1s",
        "SPoo1Ku8WFXoNDMHPsrGSTSG1Y47rzgn41SLUNakuHy",
        "namesLPneVptA9Z5rqUDD9tMTWEJwofgaYwp8cawRkX"
      ];
      switch (programHash) {
        case "Config1111111111111111111111111111111111111":
          return createShankConfigAccount(idlItem, accountHash ?? "");
        case "TokenkegQfeZyiNwAJbNbGKPFXCWuBvf9Ss623VQ5DA":
          return createShankTokenAccount(idlItem);
        case "TokenzQdBNbLqP5VEhdkAS6EPFLC1PHnBqCXEpPxuEb":
          return createShankTokenV2Account(idlItem);
        case "namesLPneVptA9Z5rqUDD9tMTWEJwofgaYwp8cawRkX":
          return createShankNameServiceAccount(idlItem);
        case "metaqbxxUerdq28cj1RbAWkYQm3ybzjb6a8bt518x1s":
          return createShankMetaplexAccountParser(idlItem);
      }
      if (accountHash && localSysvars.includes(accountHash)) {
        return createShankAccountParser(idlItem, 2 /* SYSVAR */);
      } else if (localBincode.includes(programHash)) {
        return createShankAccountParser(idlItem, 0 /* BINCODE */);
      } else if (localBorsh.includes(programHash)) {
        return createShankAccountParser(idlItem, 1 /* BORSH */);
      }
      return createShankAccountParser(idlItem);
    case "kinobi":
      switch (programHash) {
        case "PhoeNiXZ8ByJGLkxNfZRnkUfjvmuYqLR89jjFHGqdXY":
          return createShankPhoenixAccount(idlItem);
        default:
          return null;
      }
    default:
      return null;
  }
};

// src/parsers/v2/error/AnchorErrorParser.ts
var LangErrorCode = {
  // Instructions.
  InstructionMissing: 100,
  InstructionFallbackNotFound: 101,
  InstructionDidNotDeserialize: 102,
  InstructionDidNotSerialize: 103,
  // IDL instructions.
  IdlInstructionStub: 1e3,
  IdlInstructionInvalidProgram: 1001,
  // Constraints.
  ConstraintMut: 2e3,
  ConstraintHasOne: 2001,
  ConstraintSigner: 2002,
  ConstraintRaw: 2003,
  ConstraintOwner: 2004,
  ConstraintRentExempt: 2005,
  ConstraintSeeds: 2006,
  ConstraintExecutable: 2007,
  ConstraintState: 2008,
  ConstraintAssociated: 2009,
  ConstraintAssociatedInit: 2010,
  ConstraintClose: 2011,
  ConstraintAddress: 2012,
  ConstraintZero: 2013,
  ConstraintTokenMint: 2014,
  ConstraintTokenOwner: 2015,
  ConstraintMintMintAuthority: 2016,
  ConstraintMintFreezeAuthority: 2017,
  ConstraintMintDecimals: 2018,
  ConstraintSpace: 2019,
  ConstraintAccountIsNone: 2020,
  // Require.
  RequireViolated: 2500,
  RequireEqViolated: 2501,
  RequireKeysEqViolated: 2502,
  RequireNeqViolated: 2503,
  RequireKeysNeqViolated: 2504,
  RequireGtViolated: 2505,
  RequireGteViolated: 2506,
  // Accounts.
  AccountDiscriminatorAlreadySet: 3e3,
  AccountDiscriminatorNotFound: 3001,
  AccountDiscriminatorMismatch: 3002,
  AccountDidNotDeserialize: 3003,
  AccountDidNotSerialize: 3004,
  AccountNotEnoughKeys: 3005,
  AccountNotMutable: 3006,
  AccountOwnedByWrongProgram: 3007,
  InvalidProgramId: 3008,
  InvalidProgramExecutable: 3009,
  AccountNotSigner: 3010,
  AccountNotSystemOwned: 3011,
  AccountNotInitialized: 3012,
  AccountNotProgramData: 3013,
  AccountNotAssociatedTokenAccount: 3014,
  AccountSysvarMismatch: 3015,
  AccountReallocExceedsLimit: 3016,
  AccountDuplicateReallocs: 3017,
  // Miscellaneous
  DeclaredProgramIdMismatch: 4100,
  // Used for APIs that shouldn't be used anymore.
  Deprecated: 5e3
};
var LangErrorMessage = /* @__PURE__ */ new Map([
  // Instructions.
  [
    LangErrorCode.InstructionMissing,
    {
      name: "InstructionMissing",
      msg: "8 byte instruction identifier not provided"
    }
  ],
  [
    LangErrorCode.InstructionFallbackNotFound,
    {
      name: "InstructionFallbackNotFound",
      msg: "Fallback functions are not supported"
    }
  ],
  [
    LangErrorCode.InstructionDidNotDeserialize,
    {
      name: "InstructionDidNotDeserialize",
      msg: "The program could not deserialize the given instruction"
    }
  ],
  [
    LangErrorCode.InstructionDidNotSerialize,
    {
      name: "InstructionDidNotSerialize",
      msg: "The program could not serialize the given instruction"
    }
  ],
  // Idl instructions.
  [
    LangErrorCode.IdlInstructionStub,
    {
      name: "IdlInstructionStub",
      msg: "The program was compiled without idl instructions"
    }
  ],
  [
    LangErrorCode.IdlInstructionInvalidProgram,
    {
      name: "IdlInstructionInvalidProgram",
      msg: "The transaction was given an invalid program for the IDL instruction"
    }
  ],
  // Constraints.
  [
    LangErrorCode.ConstraintMut,
    {
      name: "ConstraintMut",
      msg: "A mut constraint was violated"
    }
  ],
  [
    LangErrorCode.ConstraintHasOne,
    {
      name: "ConstraintHasOne",
      msg: "A has one constraint was violated"
    }
  ],
  [
    LangErrorCode.ConstraintSigner,
    {
      name: "ConstraintSigner",
      msg: "A signer constraint was violated"
    }
  ],
  [
    LangErrorCode.ConstraintRaw,
    {
      name: "ConstraintRaw",
      msg: "A raw constraint was violated"
    }
  ],
  [
    LangErrorCode.ConstraintOwner,
    {
      name: "ConstraintOwner",
      msg: "An owner constraint was violated"
    }
  ],
  [
    LangErrorCode.ConstraintRentExempt,
    {
      name: "ConstraintRentExempt",
      msg: "A rent exemption constraint was violated"
    }
  ],
  [
    LangErrorCode.ConstraintSeeds,
    {
      name: "ConstraintSeeds",
      msg: "A seeds constraint was violated"
    }
  ],
  [
    LangErrorCode.ConstraintExecutable,
    {
      name: "ConstraintExecutable",
      msg: "An executable constraint was violated"
    }
  ],
  [
    LangErrorCode.ConstraintState,
    {
      name: "ConstraintState",
      msg: "Deprecated Error, feel free to replace with something else"
    }
  ],
  [
    LangErrorCode.ConstraintAssociated,
    {
      name: "ConstraintAssociated",
      msg: "An associated constraint was violated"
    }
  ],
  [
    LangErrorCode.ConstraintAssociatedInit,
    {
      name: "ConstraintAssociatedInit",
      msg: "An associated init constraint was violated"
    }
  ],
  [
    LangErrorCode.ConstraintClose,
    {
      name: "ConstraintClose",
      msg: "A close constraint was violated"
    }
  ],
  [
    LangErrorCode.ConstraintAddress,
    {
      name: "ConstraintAddress",
      msg: "An address constraint was violated"
    }
  ],
  [
    LangErrorCode.ConstraintZero,
    {
      name: "ConstraintZero",
      msg: "Expected zero account discriminant"
    }
  ],
  [
    LangErrorCode.ConstraintTokenMint,
    {
      name: "ConstraintTokenMint",
      msg: "A token mint constraint was violated"
    }
  ],
  [
    LangErrorCode.ConstraintTokenOwner,
    {
      name: "ConstraintTokenOwner",
      msg: "A token owner constraint was violated"
    }
  ],
  [
    LangErrorCode.ConstraintMintMintAuthority,
    {
      name: "ConstraintMintMintAuthority",
      msg: "A mint mint authority constraint was violated"
    }
  ],
  [
    LangErrorCode.ConstraintMintFreezeAuthority,
    {
      name: "ConstraintMintFreezeAuthority",
      msg: "A mint freeze authority constraint was violated"
    }
  ],
  [
    LangErrorCode.ConstraintMintDecimals,
    {
      name: "ConstraintMintDecimals",
      msg: "A mint decimals constraint was violated"
    }
  ],
  [
    LangErrorCode.ConstraintSpace,
    {
      name: "ConstraintSpace",
      msg: "A space constraint was violated"
    }
  ],
  [
    LangErrorCode.ConstraintAccountIsNone,
    {
      name: "ConstraintAccountIsNone",
      msg: "A required account for the constraint is None"
    }
  ],
  // Require.
  [
    LangErrorCode.RequireViolated,
    {
      name: "RequireViolated",
      msg: "A require expression was violated"
    }
  ],
  [
    LangErrorCode.RequireEqViolated,
    {
      name: "RequireEqViolated",
      msg: "A require_eq expression was violated"
    }
  ],
  [
    LangErrorCode.RequireKeysEqViolated,
    {
      name: "RequireKeysEqViolated",
      msg: "A require_keys_eq expression was violated"
    }
  ],
  [
    LangErrorCode.RequireNeqViolated,
    {
      name: "RequireNeqViolated",
      msg: "A require_neq expression was violated"
    }
  ],
  [
    LangErrorCode.RequireKeysNeqViolated,
    {
      name: "RequireKeysNeqViolated",
      msg: "A require_keys_neq expression was violated"
    }
  ],
  [
    LangErrorCode.RequireGtViolated,
    {
      name: "RequireGtViolated",
      msg: "A require_gt expression was violated"
    }
  ],
  [
    LangErrorCode.RequireGteViolated,
    {
      name: "RequireGteViolated",
      msg: "A require_gte expression was violated"
    }
  ],
  // Accounts.
  [
    LangErrorCode.AccountDiscriminatorAlreadySet,
    {
      name: "AccountDiscriminatorAlreadySet",
      msg: "The account discriminator was already set on this account"
    }
  ],
  [
    LangErrorCode.AccountDiscriminatorNotFound,
    {
      name: "AccountDiscriminatorNotFound",
      msg: "No 8 byte discriminator was found on the account"
    }
  ],
  [
    LangErrorCode.AccountDiscriminatorMismatch,
    {
      name: "AccountDiscriminatorMismatch",
      msg: "8 byte discriminator did not match what was expected"
    }
  ],
  [
    LangErrorCode.AccountDidNotDeserialize,
    {
      name: "AccountDidNotDeserialize",
      msg: "Failed to deserialize the account"
    }
  ],
  [
    LangErrorCode.AccountDidNotSerialize,
    {
      name: "AccountDidNotSerialize",
      msg: "Failed to serialize the account"
    }
  ],
  [
    LangErrorCode.AccountNotEnoughKeys,
    {
      name: "AccountNotEnoughKeys",
      msg: "Not enough account keys given to the instruction"
    }
  ],
  [
    LangErrorCode.AccountNotMutable,
    {
      name: "AccountNotMutable",
      msg: "The given account is not mutable"
    }
  ],
  [
    LangErrorCode.AccountOwnedByWrongProgram,
    {
      name: "AccountOwnedByWrongProgram",
      msg: "The given account is owned by a different program than expected"
    }
  ],
  [
    LangErrorCode.InvalidProgramId,
    {
      name: "InvalidProgramId",
      msg: "Program ID was not as expected"
    }
  ],
  [
    LangErrorCode.InvalidProgramExecutable,
    {
      name: "InvalidProgramExecutable",
      msg: "Program account is not executable"
    }
  ],
  [
    LangErrorCode.AccountNotSigner,
    {
      name: "AccountNotSigner",
      msg: "The given account did not sign"
    }
  ],
  [
    LangErrorCode.AccountNotSystemOwned,
    {
      name: "AccountNotSystemOwned",
      msg: "The given account is not owned by the system program"
    }
  ],
  [
    LangErrorCode.AccountNotInitialized,
    {
      name: "AccountNotInitialized",
      msg: "The program expected this account to be already initialized"
    }
  ],
  [
    LangErrorCode.AccountNotProgramData,
    {
      name: "AccountNotProgramData",
      msg: "The given account is not a program data account"
    }
  ],
  [
    LangErrorCode.AccountNotAssociatedTokenAccount,
    {
      name: "AccountNotAssociatedTokenAccount",
      msg: "The given account is not the associated token account"
    }
  ],
  [
    LangErrorCode.AccountSysvarMismatch,
    {
      name: "AccountSysvarMismatch",
      msg: "The given public key does not match the required sysvar"
    }
  ],
  [
    LangErrorCode.AccountReallocExceedsLimit,
    {
      name: "AccountReallocExceedsLimit",
      msg: "The account reallocation exceeds the MAX_PERMITTED_DATA_INCREASE limit"
    }
  ],
  [
    LangErrorCode.AccountDuplicateReallocs,
    {
      name: "AccountDuplicateReallocs",
      msg: "The account was duplicated for more than one reallocation"
    }
  ],
  // Miscellaneous
  [
    LangErrorCode.DeclaredProgramIdMismatch,
    {
      name: "DeclaredProgramIdMismatch",
      msg: "The declared program id does not match the actual program id"
    }
  ],
  // Deprecated
  [
    LangErrorCode.Deprecated,
    {
      name: "Deprecated",
      msg: "The API being used is deprecated and should no longer be used"
    }
  ]
]);
var createAnchorErrorParser = (idlItem) => {
  const idl = idlItem.idl;
  const errorsLayout = /* @__PURE__ */ new Map();
  idl?.errors?.forEach((error) => {
    errorsLayout.set(error.code, {
      name: error.name,
      msg: error.msg ?? "No error message specified"
    });
  });
  const parseError = (unparsedErrorCode) => {
    try {
      const errorCode = parseInt(unparsedErrorCode);
      const error = errorsLayout.get(errorCode);
      if (error) {
        return {
          name: error.name,
          data: error.msg,
          type: "error" /* ERROR */
        };
      }
    } catch (parseErr) {
      return null;
    }
    return null;
  };
  return { errorsLayout, parseError };
};

// src/parsers/v2/error/ShankErrorParser.ts
var createShankErrorParser = (idlItem) => {
  const idl = idlItem.idl;
  const errorsLayout = /* @__PURE__ */ new Map();
  idl?.errors?.forEach((error) => {
    if (error.code) {
      errorsLayout.set(error.code, {
        name: error.name ?? "No error name specified",
        msg: error.msg ?? "No error message specified"
      });
    }
  });
  const parseError = (unparsedErrorCode) => {
    try {
      const errorCode = parseInt(unparsedErrorCode);
      const error = errorsLayout.get(errorCode);
      if (error) {
        return {
          name: error.name,
          data: error.msg,
          type: "error" /* ERROR */
        };
      }
    } catch (parseErr) {
      return null;
    }
    return null;
  };
  return { errorsLayout, parseError };
};

// src/interfaces/ErrorParserInterface.ts
var createErrorParser = (idlItem) => {
  switch (idlItem.idlType) {
    case "anchor":
      return createAnchorErrorParser(idlItem);
    case "shank":
      return createShankErrorParser(idlItem);
    default:
      return null;
  }
};

// src/parsers/v2/event/anchor.ts
var import_anchor3 = require("@coral-xyz/anchor");
var import_utils11 = require("@solanafm/utils");
var createAnchorEventParser = (idlItem) => {
  const idl = idlItem.idl;
  const eventsLayout = new import_anchor3.BorshEventCoder(idl);
  const parseEvents = (eventData, mapTypes) => {
    try {
      if (eventsLayout) {
        const decodedEventData = eventsLayout.decode(eventData);
        if (decodedEventData) {
          const filteredIdlEvent = idl.events?.filter((event) => event.name === decodedEventData.name) ?? [];
          if (mapTypes) {
            decodedEventData.data = mapDataTypeToName(decodedEventData.data, filteredIdlEvent[0]?.fields);
          }
          decodedEventData.data = (0, import_utils11.convertBNToNumberInObject)(decodedEventData.data);
          return {
            name: decodedEventData.name,
            data: (0, import_utils11.convertBNToNumberInObject)(decodedEventData.data),
            type: "event" /* EVENT */
          };
        }
      }
      return null;
    } catch (error) {
      console.error(error);
      return null;
    }
  };
  return {
    eventsLayout,
    parseEvents
  };
};

// src/parsers/v2/event/shank.ts
var import_utils12 = require("@solanafm/utils");
var createShankEventParser = (idlItem) => {
  const idl = idlItem.idl;
  const eventsLayout = new KinobiTreeGenerator(idl).constructLayout(3 /* EVENTS */);
  const parseEvents = (eventData, mapTypes) => {
    try {
      if (eventsLayout) {
        let dataBuffer = Buffer.from(eventData, "base64");
        let eventSerializer = void 0;
        if (dataBuffer.byteLength > 0) {
          const borshDiscriminant = Buffer.from(dataBuffer).readUint8(0);
          eventSerializer = eventsLayout.get(borshDiscriminant);
        }
        if (eventSerializer) {
          const decodedEventData = eventSerializer.serializer?.deserialize(dataBuffer);
          if (decodedEventData && decodedEventData[0]) {
            const filteredIdlEvent = idl.events?.filter(
              (event) => event.name.toLowerCase() === eventSerializer.instructionName.toLowerCase()
            ) ?? [];
            if (mapTypes) {
              decodedEventData[0] = mapDataTypeToName(decodedEventData[0], filteredIdlEvent[0]?.fields);
            }
            decodedEventData[0] = (0, import_utils12.convertBNToNumberInObject)(decodedEventData[0]);
            return {
              name: eventSerializer.instructionName,
              data: (0, import_utils12.convertBNToNumberInObject)(decodedEventData[0]),
              type: "event" /* EVENT */
            };
          }
        }
      }
      return null;
    } catch (error) {
      console.error(error);
      return null;
    }
  };
  return {
    eventsLayout,
    parseEvents
  };
};

// src/parsers/v2/event/anchor/bubblegum.ts
var import_utils13 = require("@solanafm/utils");

// src/idls/bubblegum.ts
var BubblegumEventIdl = {
  name: "bubblegum-events",
  instructions: [],
  types: [
    {
      name: "BubblegumEvent",
      type: {
        kind: "struct",
        fields: [
          {
            name: "bubblegumEventType",
            type: {
              defined: "BubblegumEventType"
            }
          },
          {
            name: "version",
            type: {
              defined: "Version"
            }
          },
          {
            name: "leafSchema",
            type: {
              defined: "LeafSchema"
            }
          },
          {
            name: "leafHash",
            type: {
              array: ["u8", 32]
            }
          }
        ]
      }
    },
    {
      name: "LeafSchema",
      type: {
        kind: "enum",
        variants: [
          {
            name: "V1",
            fields: [
              {
                name: "id",
                type: "publicKey"
              },
              {
                name: "owner",
                type: "publicKey"
              },
              {
                name: "delegate",
                type: "publicKey"
              },
              {
                name: "nonce",
                type: "u64"
              },
              {
                name: "data_hash",
                type: {
                  array: ["u8", 32]
                }
              },
              {
                name: "creator_hash",
                type: {
                  array: ["u8", 32]
                }
              }
            ]
          }
        ]
      }
    },
    {
      name: "Version",
      type: {
        kind: "enum",
        variants: [
          {
            name: "V1"
          }
        ]
      }
    },
    {
      name: "BubblegumEventType",
      type: {
        kind: "enum",
        variants: [
          {
            name: "Uninitialized"
          },
          {
            name: "LeafSchemaEvent"
          }
        ]
      }
    }
  ],
  metadata: {
    address: "BGUMAp9Gq7iTEuizy4pqaxsTyUCBK68MDfK752saRPUY",
    origin: "shank"
  },
  version: "0.1.1"
};

// src/idls/spl-compression.ts
var CompressionEventIdl = {
  name: "compression-events",
  instructions: [],
  types: [
    {
      name: "AccountCompressionEvent",
      type: {
        kind: "enum",
        variants: [
          { name: "ChangeLog", fields: [{ defined: "ChangeLogEvent" }] },
          {
            name: "ApplicationData",
            fields: [{ defined: "ApplicationDataEvent" }]
          }
        ]
      }
    },
    {
      name: "ApplicationDataEvent",
      type: {
        kind: "enum",
        variants: [{ name: "V1", fields: [{ defined: "ApplicationDataEventV1" }] }]
      }
    },
    {
      name: "ChangeLogEvent",
      type: {
        kind: "enum",
        variants: [{ name: "V1", fields: [{ defined: "ChangeLogEventV1" }] }]
      }
    },
    {
      name: "ApplicationDataEventV1",
      type: {
        kind: "struct",
        fields: [
          // This is basically just vec<u8>
          {
            name: "applicationDataLen",
            type: "u32"
          }
        ]
      }
    },
    {
      name: "ChangeLogEventV1",
      type: {
        kind: "struct",
        fields: [
          {
            name: "id",
            docs: ["Public key of the ConcurrentMerkleTree"],
            type: "publicKey"
          },
          {
            name: "path",
            docs: ["Nodes of off-chain merkle tree needed by indexer"],
            type: { vec: { defined: "PathNode" } }
          },
          {
            name: "seq",
            docs: [
              "Index corresponding to the number of successful operations on this tree.",
              "Used by the off-chain indexer to figure out when there are gaps to be backfilled."
            ],
            type: "u64"
          },
          {
            name: "index",
            docs: ["Bitmap of node parity (used when hashing)"],
            type: "u32"
          }
        ]
      }
    },
    {
      name: "PathNode",
      type: {
        kind: "struct",
        fields: [
          { name: "node", type: { array: ["u8", 32] } },
          { name: "index", type: "u32" }
        ]
      }
    }
  ],
  metadata: {
    address: "cmtDvXumGCrqC1Age74AVPhSRVXJMd8PJS91L8KbNCK",
    origin: "shank"
  },
  version: "0.1.1"
};

// src/parsers/v2/event/anchor/bubblegum.ts
var createBubblegumEventParser = (_) => {
  const bubblegumTypesLayout = new KinobiTreeGenerator(
    BubblegumEventIdl,
    2 /* TYPES */
  ).constructLayout(2 /* TYPES */);
  const compressionTypesLayout = new KinobiTreeGenerator(
    CompressionEventIdl,
    2 /* TYPES */
  ).constructLayout(2 /* TYPES */);
  const parseEvents = (eventData, mapTypes) => {
    const dataBuffer = Buffer.from(eventData, "base64");
    try {
      if (bubblegumTypesLayout && compressionTypesLayout) {
        const splCompEventStructSerializer = compressionTypesLayout.get("AccountCompressionEvent");
        const bGumEventStructSerializer = bubblegumTypesLayout.get("BubblegumEvent");
        const decodedSplCompData = splCompEventStructSerializer?.serializer?.deserialize(dataBuffer);
        if (decodedSplCompData) {
          const offset = decodedSplCompData[1];
          const applicationDataLen = decodedSplCompData[0][0][0].applicationDataLen;
          if (dataBuffer.byteLength - offset === applicationDataLen) {
            const decodedBGumData = bGumEventStructSerializer?.serializer?.deserialize(dataBuffer, offset);
            if (decodedBGumData) {
              const bgumEvent = {
                splCompressionEvent: decodedSplCompData[0],
                compressionEvent: decodedBGumData[0]
              };
              if (mapTypes) {
                const bGumFields = BubblegumEventIdl.types?.find((type) => type.name === "BubblegumEvent");
                const compressionFields = CompressionEventIdl.types?.find(
                  (type) => type.name === "AccountCompressionEvent"
                );
                if (compressionFields && compressionFields.type.kind === "struct") {
                  bgumEvent.splCompressionEvent = mapDataTypeToName(
                    bgumEvent.splCompressionEvent,
                    compressionFields.type.fields
                  );
                }
                if (bGumFields && bGumFields.type.kind === "struct") {
                  bgumEvent.compressionEvent = mapDataTypeToName(bgumEvent.compressionEvent, bGumFields.type.fields);
                }
              }
              const convertedEvent = (0, import_utils13.convertBNToNumberInObject)(bgumEvent);
              return {
                name: "BubblegumEvent",
                data: convertedEvent,
                type: "event" /* EVENT */
              };
            }
          }
        }
      }
      return null;
    } catch (error) {
      console.error(error);
      return null;
    }
  };
  return {
    eventsLayout: compressionTypesLayout,
    parseEvents
  };
};

// src/parsers/v2/event/anchor/spl-compression.ts
var import_utils14 = require("@solanafm/utils");
var createSPLCompEventParser = (_) => {
  const compressionTypesLayout = new KinobiTreeGenerator(
    CompressionEventIdl,
    2 /* TYPES */
  ).constructLayout(2 /* TYPES */);
  const parseEvents = (eventData, mapTypes) => {
    const dataBuffer = Buffer.from(eventData, "base64");
    try {
      if (compressionTypesLayout) {
        const splCompEventStructSerializer = compressionTypesLayout.get("AccountCompressionEvent");
        const decodedSplCompData = splCompEventStructSerializer?.serializer?.deserialize(dataBuffer);
        if (decodedSplCompData) {
          if (mapTypes) {
            const compressionFields = CompressionEventIdl.types?.find(
              (type) => type.name === "AccountCompressionEvent"
            );
            if (compressionFields && compressionFields.type.kind === "struct") {
              decodedSplCompData[0] = mapDataTypeToName(decodedSplCompData[0], compressionFields.type.fields);
            }
          }
          return {
            data: (0, import_utils14.convertBNToNumberInObject)(decodedSplCompData[0]),
            name: "AccountCompressionEvent",
            type: "event" /* EVENT */
          };
        }
      }
      return null;
    } catch (error) {
      console.error(error);
      return null;
    }
  };
  return {
    eventsLayout: compressionTypesLayout,
    parseEvents
  };
};

// src/parsers/v2/event/anchor/tcomp.ts
var import_anchor5 = require("@coral-xyz/anchor");
var import_utils15 = require("@solanafm/utils");
var createTCompEventParser = (idlItem) => {
  const idl = idlItem.idl;
  const instructionsLayout = new import_anchor5.BorshInstructionCoder(idl);
  const parseEvents = (eventData, mapTypes) => {
    try {
      if (instructionsLayout) {
        const dataBuffer = Buffer.from(eventData, "base64");
        const decodedEventData = instructionsLayout.decode(dataBuffer);
        if (decodedEventData) {
          const filteredIdlEvent = idl.events?.filter((event) => event.name === decodedEventData.name) ?? [];
          if (mapTypes) {
            decodedEventData.data = mapDataTypeToName(decodedEventData.data, filteredIdlEvent[0]?.fields);
          }
          decodedEventData.data = (0, import_utils15.convertBNToNumberInObject)(decodedEventData.data);
          return {
            name: decodedEventData.name,
            data: (0, import_utils15.convertBNToNumberInObject)(decodedEventData.data),
            type: "event" /* EVENT */
          };
        }
      }
      return null;
    } catch (error) {
      console.error(error);
      return null;
    }
  };
  return {
    eventsLayout: instructionsLayout,
    parseEvents
  };
};

// src/parsers/v2/event/shank/phoenix.ts
var import_utils16 = require("@solanafm/utils");
var createPhoenixEventParser = (idlItem) => {
  const idl = idlItem.idl;
  const typesLayout = new KinobiTreeGenerator(
    {
      version: "",
      name: "",
      instructions: [],
      metadata: {
        address: ""
      }
    },
    2 /* TYPES */,
    idl
  ).constructLayout(2 /* TYPES */);
  const parseEvents = (eventData, mapTypes) => {
    try {
      if (typesLayout) {
        const dataBuffer = Buffer.from(eventData, "base64");
        const phoenixEventDeserializer = typesLayout.get("PhoenixMarketEvent");
        const decodedShankData = phoenixEventDeserializer?.serializer?.deserialize(dataBuffer);
        if (decodedShankData) {
          const numberOfEvents = decodedShankData[0]["0"].totalEvents;
          let offset = decodedShankData[1] ?? 0;
          const phoenixEvent = {
            header: decodedShankData[0],
            events: []
          };
          if (dataBuffer.byteLength > offset && numberOfEvents > 0) {
            for (let index = 0; index < numberOfEvents; index++) {
              const decodedEventData = phoenixEventDeserializer?.serializer?.deserialize(dataBuffer, offset);
              if (decodedEventData) {
                offset = decodedEventData[1];
                phoenixEvent.events.push(decodedEventData[0]);
              }
            }
          }
          if (mapTypes) {
            const phoenixMarketEventTypes = PhoenixIDL.types?.find((type) => type.name === "PhoenixMarketEvent");
            const eventHeaderName = (0, import_utils16.capitalizeFirstLetter)(phoenixEvent.header["__kind"]);
            if (phoenixMarketEventTypes) {
              const fields = getPhoenixTypeFields(phoenixMarketEventTypes, eventHeaderName);
              phoenixEvent.header["eventData"] = mapDataTypeToName(phoenixEvent.header["0"], fields);
              delete phoenixEvent.header["0"];
              phoenixEvent.events.forEach((event) => {
                const innerEventHeaderName = (0, import_utils16.capitalizeFirstLetter)(event["__kind"]);
                const eventFields = getPhoenixTypeFields(phoenixMarketEventTypes, innerEventHeaderName);
                event["eventData"] = mapDataTypeToName(event["0"], eventFields);
                delete event["0"];
              });
            }
          }
          const convertedEvent = (0, import_utils16.convertBNToNumberInObject)(phoenixEvent);
          return {
            name: "PhoenixMarketEvent",
            data: convertedEvent,
            type: "event" /* EVENT */
          };
        }
      }
      return null;
    } catch (error) {
      console.error(error);
      return null;
    }
  };
  return {
    eventsLayout: typesLayout,
    parseEvents
  };
};
var getPhoenixTypeFields = (eventEnum, eventHeaderName) => {
  if (eventEnum && eventEnum.type.kind === "enum") {
    const eventHeaderType = eventEnum.type.variants.find((variant) => variant.name === eventHeaderName);
    if (eventHeaderType && eventHeaderType.fields && eventHeaderType.fields.length > 0 && eventHeaderType.fields[0]) {
      const filteredIdlType = PhoenixIDL.types?.find((type) => {
        return type.name === eventHeaderType.fields[0].defined;
      });
      if (filteredIdlType?.type && filteredIdlType.type.kind === "struct") {
        const filteredIdlTypeFields = filteredIdlType.type.fields;
        return filteredIdlTypeFields;
      }
    }
  }
  return [];
};

// src/interfaces/EventParserInterface.ts
var createEventParser = (idlItem, programHash) => {
  switch (idlItem.idlType) {
    case "anchor":
      switch (programHash) {
        case "cmtDvXumGCrqC1Age74AVPhSRVXJMd8PJS91L8KbNCK":
          return createSPLCompEventParser(idlItem);
        case "BGUMAp9Gq7iTEuizy4pqaxsTyUCBK68MDfK752saRPUY":
          return createBubblegumEventParser(idlItem);
        case "TCMPhJdwDryooaGtiocG1u3xcYbRpiJzb283XfCZsDp":
          return createTCompEventParser(idlItem);
        default:
          return createAnchorEventParser(idlItem);
      }
    case "kinobi":
      switch (programHash) {
        case "PhoeNiXZ8ByJGLkxNfZRnkUfjvmuYqLR89jjFHGqdXY":
          return createPhoenixEventParser(idlItem);
        default:
          return null;
      }
    case "shank":
      switch (programHash) {
        default:
          return createShankEventParser(idlItem);
      }
    default:
      return null;
  }
};

// src/parsers/v2/instruction/anchor.ts
var import_anchor6 = require("@coral-xyz/anchor");
var import_utils17 = require("@solanafm/utils");
var createAnchorInstructionParser = (idlItem) => {
  const idl = idlItem.idl;
  const instructionsLayout = new import_anchor6.BorshInstructionCoder(idl);
  const parseInstructions = (instructionData, accountKeys, mapTypes) => {
    try {
      if (instructionsLayout) {
        const ixBuffer = (0, import_utils17.decodeBase58)(instructionData);
        const ixDisc = Buffer.from(ixBuffer.subarray(0, 8));
        const eventDisc = Buffer.from("5EWlLlHLmh0=", "base64");
        if (ixDisc.equals(eventDisc)) {
          return {
            name: "Anchor Self-CPI Log",
            // Checks if there's an account keys array that's being supplied, if not return an empty data since there's no account keys that's being mapped
            data: accountKeys ? {
              logAuthority: {
                data: accountKeys[0],
                type: "publicKey"
              }
            } : null,
            type: "instruction" /* INSTRUCTION */
          };
        }
        const decodedAnchorData = instructionsLayout.decode(instructionData, "base58");
        if (decodedAnchorData) {
          const filteredIdlInstruction = idl.instructions.filter(
            (instruction) => instruction.name === decodedAnchorData.name
          );
          if (mapTypes) {
            decodedAnchorData.data = mapDataTypeToName(decodedAnchorData.data, filteredIdlInstruction[0]?.args);
          }
          if (filteredIdlInstruction.length > 0) {
            const instructionAccounts = filteredIdlInstruction[0]?.accounts;
            const mappedAccountKeys = mapAccountKeysToName(accountKeys, instructionAccounts, mapTypes);
            return {
              name: decodedAnchorData.name,
              data: { ...(0, import_utils17.convertBNToNumberInObject)(decodedAnchorData.data), ...mappedAccountKeys },
              type: "instruction" /* INSTRUCTION */
            };
          }
          return {
            name: decodedAnchorData.name,
            data: (0, import_utils17.convertBNToNumberInObject)(decodedAnchorData.data),
            type: "instruction" /* INSTRUCTION */
          };
        }
        return null;
      }
      return null;
    } catch (error) {
      console.error(error);
      return null;
    }
  };
  const getProgramName = () => {
    return idl.name;
  };
  return {
    instructionsLayout,
    parseInstructions,
    getProgramName
  };
};

// src/parsers/v2/instruction/anchor-v1.ts
var import_anchor_new2 = require("@coral-xyz/anchor-new");
var import_utils18 = require("@solanafm/utils");

// src/helpers/new-idl.ts
var extractIdlIxAccountName2 = (idlAccount) => {
  if (idlAccount) {
    if (isIdlAccounts2(idlAccount)) {
      const idlIxAccounts = [];
      idlAccount.accounts.forEach((account) => {
        let extractedName = extractIdlIxAccountName2(account);
        if (extractedName) {
          if (Array.isArray(extractedName)) {
            extractedName = extractIdlIxAccountName2(account);
          } else {
            idlIxAccounts.push(idlAccount.name + "." + extractedName);
          }
        }
      });
      return idlIxAccounts;
    } else {
      return idlAccount.name;
    }
  }
  return void 0;
};
var mapNewAnchorAccountKeysToName = (accountKeys, idlIxAccounts, mapTypes) => {
  if (idlIxAccounts && accountKeys) {
    const names = [];
    idlIxAccounts.forEach((idlIxAccount) => {
      names.push(extractIdlIxAccountName2(idlIxAccount) ?? "Unknown");
    });
    const flattenedArray = names.flat(5);
    let translatedAccountKeysObj = {};
    accountKeys.forEach((accountKey, index) => {
      const objectKey = flattenedArray[index] ?? "Unknown";
      const object = {
        [objectKey]: mapTypes ? { data: accountKey, type: "publicKey" } : accountKey
      };
      translatedAccountKeysObj = Object.assign(translatedAccountKeysObj, object);
    });
    return translatedAccountKeysObj;
  }
  return {};
};

// src/parsers/v2/instruction/anchor-v1.ts
var createAnchorV1InstructionParser = (idlItem) => {
  const idl = idlItem.idl;
  const instructionsLayout = new import_anchor_new2.BorshInstructionCoder(idl);
  const parseInstructions = (instructionData, accountKeys, mapTypes) => {
    try {
      if (instructionsLayout) {
        const ixBuffer = (0, import_utils18.decodeBase58)(instructionData);
        const ixDisc = Buffer.from(ixBuffer.subarray(0, 8));
        const eventDisc = Buffer.from("5EWlLlHLmh0=", "base64");
        if (ixDisc.equals(eventDisc)) {
          return {
            name: "Anchor Self-CPI Log",
            // Checks if there's an account keys array that's being supplied, if not return an empty data since there's no account keys that's being mapped
            data: accountKeys ? {
              logAuthority: {
                data: accountKeys[0],
                type: "publicKey"
              }
            } : null,
            type: "instruction" /* INSTRUCTION */
          };
        }
        const decodedAnchorData = instructionsLayout.decode(instructionData, "base58");
        if (decodedAnchorData) {
          const filteredIdlInstruction = idl.instructions.filter(
            (instruction) => instruction.name === decodedAnchorData.name
          );
          if (mapTypes) {
            decodedAnchorData.data = mapNewAnchorDataTypeToName(
              decodedAnchorData.data,
              filteredIdlInstruction[0]?.args
            );
          }
          if (filteredIdlInstruction.length > 0) {
            const instructionAccounts = filteredIdlInstruction[0]?.accounts;
            const mappedAccountKeys = mapNewAnchorAccountKeysToName(accountKeys, instructionAccounts, mapTypes);
            return {
              name: decodedAnchorData.name,
              data: { ...(0, import_utils18.convertBNToNumberInObject)(decodedAnchorData.data), ...mappedAccountKeys },
              type: "instruction" /* INSTRUCTION */
            };
          }
          return {
            name: decodedAnchorData.name,
            data: (0, import_utils18.convertBNToNumberInObject)(decodedAnchorData.data),
            type: "instruction" /* INSTRUCTION */
          };
        }
        return null;
      }
      return null;
    } catch (error) {
      console.error(error);
      return null;
    }
  };
  const getProgramName = () => {
    return idl.metadata.name;
  };
  return {
    instructionsLayout,
    parseInstructions,
    getProgramName
  };
};

// src/parsers/v2/instruction/config.ts
var import_umi2 = require("@metaplex-foundation/umi");
var import_utils19 = require("@solanafm/utils");
var createShankIxConfig = (idlItem) => {
  const idl = idlItem.idl;
  const instructionsLayout = new KinobiTreeGenerator(idl).constructLayout();
  const parseInstructions = (instructionData, accountKeys, mapTypes) => {
    try {
      const dataBuffer = import_umi2.base58.serialize(instructionData);
      const filteredIdlInstruction = [];
      let ixSerializer;
      if (dataBuffer.byteLength <= 9) {
        ixSerializer = instructionsLayout.get(0);
        if (idl.instructions[0]) {
          filteredIdlInstruction.push(idl.instructions[0]);
        }
      } else if (dataBuffer.byteLength > 9) {
        ixSerializer = instructionsLayout.get(1);
        if (idl.instructions[1]) {
          filteredIdlInstruction.push(idl.instructions[1]);
        }
      }
      if (ixSerializer && dataBuffer.byteLength > 0) {
        const decodedShankData = ixSerializer.serializer?.deserialize(dataBuffer);
        if (decodedShankData && decodedShankData[0]) {
          if (mapTypes) {
            decodedShankData[0] = mapDataTypeToName(
              decodedShankData[0],
              filteredIdlInstruction[0]?.args,
              filteredIdlInstruction[0]?.discriminant
            );
          }
          if (filteredIdlInstruction.length > 0) {
            const instructionAccounts = filteredIdlInstruction[0]?.accounts;
            const mappedAccountKeys = mapAccountKeysToName(accountKeys, instructionAccounts, mapTypes);
            return {
              name: ixSerializer.instructionName,
              data: { ...(0, import_utils19.convertBNToNumberInObject)(decodedShankData[0]), ...mappedAccountKeys },
              type: "instruction" /* INSTRUCTION */
            };
          }
          return {
            name: ixSerializer.instructionName,
            data: (0, import_utils19.convertBNToNumberInObject)(decodedShankData[0]),
            type: "instruction" /* INSTRUCTION */
          };
        }
      }
      return null;
    } catch (error) {
      console.error(error);
      return null;
    }
  };
  const getProgramName = () => {
    return idl.name;
  };
  return {
    instructionsLayout,
    parseInstructions,
    getProgramName
  };
};

// src/parsers/v2/instruction/memo.ts
var import_umi3 = require("@metaplex-foundation/umi");
var import_utils20 = require("@solanafm/utils");
var createShankIxMemo = (idlItem) => {
  const idl = idlItem.idl;
  const instructionsLayout = new KinobiTreeGenerator(
    {
      version: "",
      name: "",
      instructions: [],
      metadata: {
        address: ""
      }
    },
    1 /* INSTRUCTIONS */,
    idl
  ).constructLayout();
  const parseInstructions = (instructionData, accountKeys, mapTypes) => {
    try {
      const dataBuffer = import_umi3.base58.serialize(instructionData);
      const ixSerializer = instructionsLayout.get(0);
      if (ixSerializer && dataBuffer.byteLength > 0) {
        const decodedShankData = ixSerializer.serializer?.deserialize(dataBuffer);
        if (decodedShankData && decodedShankData[0]) {
          if (mapTypes) {
            const dataKeys = Object.keys(decodedShankData[0]);
            const mappedDataType = {};
            dataKeys.forEach((keyName) => {
              if (keyName === "memo") {
                mappedDataType[keyName] = {
                  type: "string",
                  data: decodedShankData[0][keyName]
                };
              }
              decodedShankData[0] = mappedDataType;
            });
          }
          if (accountKeys && accountKeys.length > 0) {
            return {
              name: ixSerializer.instructionName,
              data: {
                ...(0, import_utils20.convertBNToNumberInObject)(decodedShankData[0]),
                ...mapTypes ? {
                  signers: {
                    data: accountKeys[0],
                    type: "publicKey"
                  }
                } : { signers: accountKeys[0] }
              },
              type: "instruction" /* INSTRUCTION */
            };
          }
          return {
            name: ixSerializer.instructionName,
            data: (0, import_utils20.convertBNToNumberInObject)(decodedShankData[0]),
            type: "instruction" /* INSTRUCTION */
          };
        }
      }
      return null;
    } catch (error) {
      console.error(error);
      return null;
    }
  };
  const getProgramName = () => {
    return "Memo Program";
  };
  return {
    instructionsLayout,
    parseInstructions,
    getProgramName
  };
};

// src/parsers/v2/instruction/shank.ts
var import_umi4 = require("@metaplex-foundation/umi");
var import_utils21 = require("@solanafm/utils");
var createShankInstructionParser = (idlItem) => {
  const idl = idlItem.idl;
  const instructionsLayout = new KinobiTreeGenerator(idl).constructLayout();
  const parseInstructions = (instructionData, accountKeys, mapTypes) => {
    try {
      const dataBuffer = import_umi4.base58.serialize(instructionData);
      const ixDiscriminant = Buffer.from(dataBuffer).readUint8(0);
      const ixSerializer = instructionsLayout.get(ixDiscriminant);
      if (ixSerializer && dataBuffer.byteLength > 0) {
        const decodedShankData = ixSerializer.serializer?.deserialize(dataBuffer);
        if (decodedShankData && decodedShankData[0]) {
          const filteredIdlInstruction = idl.instructions?.filter(
            (instruction) => instruction.discriminant?.value === ixDiscriminant
          );
          if (mapTypes) {
            decodedShankData[0] = mapDataTypeToName(
              decodedShankData[0],
              filteredIdlInstruction[0]?.args,
              filteredIdlInstruction[0]?.discriminant
            );
          }
          if (filteredIdlInstruction.length > 0) {
            const instructionAccounts = filteredIdlInstruction[0]?.accounts;
            const mappedAccountKeys = mapAccountKeysToName(accountKeys, instructionAccounts, mapTypes);
            return {
              name: ixSerializer.instructionName,
              data: { ...(0, import_utils21.convertBNToNumberInObject)(decodedShankData[0]), ...mappedAccountKeys },
              type: "instruction" /* INSTRUCTION */
            };
          }
          return {
            name: ixSerializer.instructionName,
            data: (0, import_utils21.convertBNToNumberInObject)(decodedShankData[0]),
            type: "instruction" /* INSTRUCTION */
          };
        }
      }
      return null;
    } catch (error) {
      console.error(error);
      return null;
    }
  };
  const getProgramName = () => {
    return idl.name;
  };
  return {
    instructionsLayout,
    parseInstructions,
    getProgramName
  };
};

// src/parsers/v2/instruction/ata.ts
var import_umi5 = require("@metaplex-foundation/umi");
var import_utils22 = require("@solanafm/utils");
var createShankIxATA = (idlItem) => {
  const idl = idlItem.idl;
  const instructionsLayout = new KinobiTreeGenerator(idl).constructLayout();
  const parseInstructions = (instructionData, accountKeys, mapTypes) => {
    try {
      if (instructionData !== "") {
        const dataBuffer = import_umi5.base58.serialize(instructionData);
        const ixDiscriminant = Buffer.from(dataBuffer).readUint8(0);
        const ixSerializer = instructionsLayout.get(ixDiscriminant);
        if (ixSerializer && dataBuffer.byteLength > 0) {
          const decodedShankData = ixSerializer.serializer?.deserialize(dataBuffer);
          if (decodedShankData && decodedShankData[0]) {
            const filteredIdlInstruction = idl.instructions?.filter(
              (instruction) => instruction.discriminant?.value === ixDiscriminant
            );
            if (mapTypes) {
              decodedShankData[0] = mapDataTypeToName(
                decodedShankData[0],
                filteredIdlInstruction[0]?.args,
                filteredIdlInstruction[0]?.discriminant
              );
            }
            if (filteredIdlInstruction.length > 0) {
              const instructionAccounts = filteredIdlInstruction[0]?.accounts;
              const mappedAccountKeys = mapAccountKeysToName(accountKeys, instructionAccounts, mapTypes);
              return {
                name: ixSerializer.instructionName,
                data: { ...(0, import_utils22.convertBNToNumberInObject)(decodedShankData[0]), ...mappedAccountKeys },
                type: "instruction" /* INSTRUCTION */
              };
            }
            return {
              name: ixSerializer.instructionName,
              data: (0, import_utils22.convertBNToNumberInObject)(decodedShankData[0]),
              type: "instruction" /* INSTRUCTION */
            };
          }
        }
      } else {
        const filteredIdlInstruction = idl.instructions?.filter((instruction) => instruction.discriminant?.value === 0);
        const instructionAccounts = filteredIdlInstruction[0]?.accounts;
        const mappedAccountKeys = mapAccountKeysToName(accountKeys, instructionAccounts, mapTypes);
        return {
          name: instructionsLayout.get(0).instructionName,
          data: { ...mappedAccountKeys },
          type: "instruction" /* INSTRUCTION */
        };
      }
      return null;
    } catch (error) {
      console.error(error);
      return null;
    }
  };
  const getProgramName = () => {
    return idl.name;
  };
  return {
    instructionsLayout,
    parseInstructions,
    getProgramName
  };
};

// src/parsers/v2/instruction/noop.ts
var import_umi_serializers4 = require("@metaplex-foundation/umi-serializers");
var import_utils23 = require("@solanafm/utils");
var createNoopIx = (idlItem) => {
  const idl = idlItem.idl;
  const instructionsLayout = new KinobiTreeGenerator(idl).constructLayout();
  const parseInstructions = (instructionData, _, mapTypes) => {
    try {
      const dataBuffer = import_umi_serializers4.base58.serialize(instructionData);
      const ixSerializer = instructionsLayout.get(0);
      if (ixSerializer && dataBuffer.byteLength > 0) {
        const decodedShankData = ixSerializer.serializer?.deserialize(dataBuffer);
        if (decodedShankData && decodedShankData[0]) {
          const filteredIdlInstruction = idl.instructions[0];
          if (mapTypes) {
            decodedShankData[0] = mapDataTypeToName(decodedShankData[0], filteredIdlInstruction?.args);
          }
          return {
            name: ixSerializer.instructionName,
            data: (0, import_utils23.convertBNToNumberInObject)(decodedShankData[0]),
            type: "instruction" /* INSTRUCTION */
          };
        }
      }
      return null;
    } catch (error) {
      console.error(error);
      return null;
    }
  };
  const getProgramName = () => {
    return idl.name;
  };
  return {
    instructionsLayout,
    parseInstructions,
    getProgramName
  };
};

// src/parsers/v2/instruction/phoenix.ts
var import_umi6 = require("@metaplex-foundation/umi");
var import_utils24 = require("@solanafm/utils");
var createShankIxPhoenix = (idlItem) => {
  const idl = idlItem.idl;
  const instructionsLayout = new KinobiTreeGenerator(
    {
      version: "",
      name: "",
      instructions: [],
      metadata: {
        address: ""
      }
    },
    1 /* INSTRUCTIONS */,
    idl
  ).constructLayout(1 /* INSTRUCTIONS */);
  const parseInstructions = (instructionData, accountKeys, mapTypes) => {
    try {
      const dataBuffer = import_umi6.base58.serialize(instructionData);
      const ixDiscriminant = Buffer.from(dataBuffer).readUint8(0);
      const ixSerializer = instructionsLayout.get(ixDiscriminant);
      if (ixSerializer && dataBuffer.byteLength > 0) {
        const decodedShankData = ixSerializer.serializer?.deserialize(dataBuffer);
        if (decodedShankData && decodedShankData[0]) {
          const filteredIdlInstruction = PhoenixIDL.instructions?.filter(
            (instruction) => instruction.discriminant?.value === ixDiscriminant
          );
          if (mapTypes) {
            decodedShankData[0] = mapDataTypeToName(
              decodedShankData[0],
              filteredIdlInstruction[0]?.args,
              filteredIdlInstruction[0]?.discriminant
            );
          }
          if (filteredIdlInstruction.length > 0) {
            const instructionAccounts = filteredIdlInstruction[0]?.accounts;
            const mappedAccountKeys = mapAccountKeysToName(accountKeys, instructionAccounts, mapTypes);
            return {
              name: ixSerializer.instructionName,
              data: { ...(0, import_utils24.convertBNToNumberInObject)(decodedShankData[0]), ...mappedAccountKeys },
              type: "instruction" /* INSTRUCTION */
            };
          }
          return {
            name: ixSerializer.instructionName,
            data: (0, import_utils24.convertBNToNumberInObject)(decodedShankData[0]),
            type: "instruction" /* INSTRUCTION */
          };
        }
      }
      return null;
    } catch (error) {
      console.error(error);
      return null;
    }
  };
  const getProgramName = () => {
    return "Phoenix Program";
  };
  return {
    instructionsLayout,
    parseInstructions,
    getProgramName
  };
};

// src/parsers/v2/instruction/token-v2.ts
var import_umi_serializers5 = require("@metaplex-foundation/umi-serializers");
var import_utils26 = require("@solanafm/utils");

// src/helpers/multisig-checker.ts
var mapMultisigAccountKeysToName = (accountKeys, idlIxAccounts, accountName) => {
  if (idlIxAccounts && accountKeys) {
    const names = [];
    idlIxAccounts.forEach((idlIxAccount) => {
      names.push(
        extractIdlIxAccountName(idlIxAccount) ?? {
          name: "Unknown"
        }
      );
    });
    const flattenNames = names.flat(5);
    let translatedAccountKeysObj = {};
    if (flattenNames.length === accountKeys.length) {
      accountKeys.forEach((accountKey, index) => {
        const objectKey = flattenNames[index] ?? {
          name: "Unknown"
        };
        const object = {
          [objectKey.name]: { data: accountKey, type: "publicKey" }
        };
        translatedAccountKeysObj = Object.assign(translatedAccountKeysObj, object);
      });
      return translatedAccountKeysObj;
    } else {
      const signers = accountKeys.splice(names.length - 1);
      accountKeys.forEach((accountKey, index) => {
        const objectKey = flattenNames[index] ?? { name: "Unknown" };
        const object = {
          [objectKey.name]: { data: accountKey, type: "publicKey" }
        };
        translatedAccountKeysObj = Object.assign(translatedAccountKeysObj, object);
      });
      signers.forEach((signerAccountKey, index) => {
        const object = {
          [(accountName ?? `signer`) + (index + 1)]: { data: signerAccountKey, type: "publicKey" }
        };
        translatedAccountKeysObj = Object.assign(translatedAccountKeysObj, object);
      });
      return translatedAccountKeysObj;
    }
  }
  return {};
};

// src/idls/token-22/extensions/confidential-transfer.ts
var ConfidentialTransferExtensionIDL = {
  version: "0.1.0",
  name: "ConfidentialTransferExtension",
  instructions: [
    {
      name: "initializeMint",
      accounts: [
        {
          name: "tokenMint",
          isMut: true,
          isSigner: false
        }
      ],
      args: [
        {
          name: "initializeMintData",
          type: {
            defined: "InitializeMintData"
          }
        }
      ],
      discriminant: {
        type: "u8",
        value: 0
      }
    },
    {
      name: "updateMint",
      accounts: [
        {
          name: "mint",
          isMut: true,
          isSigner: false
        },
        {
          name: "mintAuthority",
          isMut: false,
          isSigner: true
        }
      ],
      args: [
        {
          name: "updateMintData",
          type: {
            defined: "UpdateMintData"
          }
        }
      ],
      discriminant: {
        type: "u8",
        value: 1
      }
    },
    {
      name: "configureAccount",
      accounts: [
        {
          name: "tokenAccount",
          isMut: true,
          isSigner: false
        },
        {
          name: "tokenMint",
          isMut: false,
          isSigner: false
        },
        {
          name: "owner",
          isMut: false,
          isSigner: false
        },
        {
          name: "instructions",
          isMut: false,
          isSigner: true
        },
        {
          name: "signers",
          isMut: false,
          isSigner: true
        }
      ],
      args: [
        {
          name: "configureAccountInstructionData",
          type: {
            defined: "ConfigureAccountInstructionData"
          }
        }
      ],
      discriminant: {
        type: "u8",
        value: 2
      }
    },
    {
      name: "approveAccount",
      accounts: [
        {
          name: "approvingAccount",
          isMut: true,
          isSigner: false
        },
        {
          name: "tokenMint",
          isMut: false,
          isSigner: false
        },
        {
          name: "authority",
          isMut: false,
          isSigner: true
        }
      ],
      args: [],
      discriminant: {
        type: "u8",
        value: 3
      }
    },
    {
      name: "emptyAccount",
      accounts: [
        {
          name: "tokenAccount",
          isMut: true,
          isSigner: false
        },
        {
          name: "instructions",
          isMut: false,
          isSigner: false
        },
        {
          name: "owner",
          isMut: false,
          isSigner: true
        },
        {
          name: "signers",
          isMut: false,
          isSigner: true
        }
      ],
      args: [
        {
          name: "emptyAccountInstructionData",
          type: {
            defined: "EmptyAccountInstructionData"
          }
        }
      ],
      discriminant: {
        type: "u8",
        value: 4
      }
    },
    {
      name: "deposit",
      accounts: [
        {
          name: "tokenAccount",
          isMut: true,
          isSigner: false
        },
        {
          name: "tokenMint",
          isMut: false,
          isSigner: false
        },
        {
          name: "owner",
          isMut: false,
          isSigner: true
        },
        {
          name: "signers",
          isMut: false,
          isSigner: true
        }
      ],
      args: [
        {
          name: "depositInstructionData",
          type: {
            defined: "DepositInstructionData"
          }
        }
      ],
      discriminant: {
        type: "u8",
        value: 5
      }
    },
    {
      name: "withdraw",
      accounts: [
        {
          name: "tokenAccount",
          isMut: true,
          isSigner: false
        },
        {
          name: "tokenMint",
          isMut: false,
          isSigner: false
        },
        {
          name: "instructions",
          isMut: false,
          isSigner: false
        },
        {
          name: "owner",
          isMut: false,
          isSigner: true
        },
        {
          name: "signers",
          isMut: false,
          isSigner: true
        }
      ],
      args: [
        {
          name: "withdrawInstructionData",
          type: {
            defined: "WithdrawInstructionData"
          }
        }
      ],
      discriminant: {
        type: "u8",
        value: 6
      }
    },
    {
      name: "transfer",
      accounts: [
        {
          name: "source",
          isMut: true,
          isSigner: false
        },
        {
          name: "destination",
          isMut: true,
          isSigner: false
        },
        {
          name: "tokenMint",
          isMut: false,
          isSigner: false
        },
        {
          name: "instructions",
          isMut: false,
          isSigner: false
        },
        {
          name: "owner",
          isMut: false,
          isSigner: true
        },
        {
          name: "signers",
          isMut: false,
          isSigner: true
        }
      ],
      args: [
        {
          name: "transferInstructionData",
          type: {
            defined: "TransferInstructionData"
          }
        }
      ],
      discriminant: {
        type: "u8",
        value: 7
      }
    },
    {
      name: "applyPendingBalance",
      accounts: [
        {
          name: "tokenAccount",
          isMut: true,
          isSigner: false
        },
        {
          name: "owner",
          isMut: false,
          isSigner: true
        },
        {
          name: "signers",
          isMut: false,
          isSigner: true
        }
      ],
      args: [
        {
          name: "applyPendingBalanceData",
          type: {
            defined: "ApplyPendingBalanceData"
          }
        }
      ],
      discriminant: {
        type: "u8",
        value: 8
      }
    },
    {
      name: "enableConfidentialCredits",
      accounts: [
        {
          name: "tokenAccount",
          isMut: true,
          isSigner: false
        },
        {
          name: "authority",
          isMut: false,
          isSigner: true
        },
        {
          name: "signers",
          isMut: false,
          isSigner: true
        }
      ],
      args: [],
      discriminant: {
        type: "u8",
        value: 9
      }
    },
    {
      name: "disableConfidentialCredits",
      accounts: [
        {
          name: "tokenAccount",
          isMut: true,
          isSigner: false
        },
        {
          name: "owner",
          isMut: false,
          isSigner: true
        },
        {
          name: "signers",
          isMut: false,
          isSigner: true
        }
      ],
      args: [],
      discriminant: {
        type: "u8",
        value: 10
      }
    },
    {
      name: "enableNonConfidentialCredits",
      accounts: [
        {
          name: "tokenAccount",
          isMut: true,
          isSigner: false
        },
        {
          name: "owner",
          isMut: false,
          isSigner: true
        },
        {
          name: "signers",
          isMut: false,
          isSigner: true
        }
      ],
      args: [],
      discriminant: {
        type: "u8",
        value: 11
      }
    },
    {
      name: "disableNonConfidentialCredits",
      accounts: [
        {
          name: "tokenAccount",
          isMut: true,
          isSigner: false
        },
        {
          name: "owner",
          isMut: false,
          isSigner: true
        },
        {
          name: "signers",
          isMut: false,
          isSigner: true
        }
      ],
      args: [],
      discriminant: {
        type: "u8",
        value: 12
      }
    }
  ],
  accounts: [],
  types: [
    {
      name: "InitializeMintData",
      type: {
        kind: "struct",
        fields: [
          {
            name: "authority",
            type: "publicKey"
          },
          {
            name: "auto_approve_new_accounts",
            type: "u8"
          },
          {
            name: "auditor_elgamal_pubkey",
            type: {
              array: ["u8", 32]
            }
          }
        ]
      }
    },
    {
      name: "UpdateMintData",
      type: {
        kind: "struct",
        fields: [
          {
            name: "auto_approve_new_accounts",
            type: "u8"
          },
          {
            name: "auditor_elgamal_pubkey",
            type: {
              array: ["u8", 32]
            }
          }
        ]
      }
    },
    {
      name: "ConfigureAccountInstructionData",
      type: {
        kind: "struct",
        fields: [
          {
            name: "decryptable_zero_balance",
            type: {
              array: ["u8", 36]
            }
          },
          {
            name: "maximum_pending_balance_credit_counter",
            type: "u64"
          },
          {
            name: "proof_instruction_offset",
            type: "i8"
          }
        ]
      }
    },
    {
      name: "EmptyAccountInstructionData",
      type: {
        kind: "struct",
        fields: [
          {
            name: "proof_insruction_offset",
            type: "i8"
          }
        ]
      }
    },
    {
      name: "DepositInstructionData",
      type: {
        kind: "struct",
        fields: [
          {
            name: "amount",
            type: {
              array: ["u8", 8]
            }
          },
          {
            name: "decimals",
            type: "u8"
          }
        ]
      }
    },
    {
      name: "WithdrawInstructionData",
      type: {
        kind: "struct",
        fields: [
          {
            name: "amount",
            type: {
              array: ["u8", 8]
            }
          },
          {
            name: "decimals",
            type: "u8"
          },
          {
            name: "new_deryptable_available_balance",
            type: {
              array: ["u8", 36]
            }
          },
          {
            name: "proof_instruction_offset",
            type: "i8"
          }
        ]
      }
    },
    {
      name: "TransferInstructionData",
      type: {
        kind: "struct",
        fields: [
          {
            name: "new_source_decryptable_available_balance",
            type: {
              array: ["u8", 36]
            }
          },
          {
            name: "proof_instruction_offset",
            type: "i8"
          }
        ]
      }
    },
    {
      name: "ApplyPendingBalanceData",
      type: {
        kind: "struct",
        fields: [
          {
            name: "expected_pending_balance_credit_counter",
            type: {
              array: ["u8", 8]
            }
          },
          {
            name: "new_decryptable_available_balance",
            type: {
              array: ["u8", 36]
            }
          }
        ]
      }
    }
  ],
  metadata: {
    origin: "shank",
    address: "TokenzQdBNbLqP5VEhdkAS6EPFLC1PHnBqCXEpPxuEb",
    binaryVersion: "0.1.0",
    libVersion: "0.1.0"
  }
};

// src/idls/token-22/extensions/confidential-transfer-fee.ts
var ConfidentialTransferFeeExtensionIDL = {
  version: "0.1.0",
  name: "ConfidentialTransferFee",
  instructions: [
    {
      name: "initializeConfidentialTransferFeeConfig",
      accounts: [
        {
          name: "tokenMint",
          isMut: true,
          isSigner: false
        }
      ],
      args: [
        {
          name: "initializeConfidentialTransferFeeConfigData",
          type: {
            defined: "InitializeConfidentialTransferFeeConfigData"
          }
        }
      ],
      discriminant: {
        type: "u8",
        value: 0
      }
    },
    {
      name: "WithdrawWithheldTokensFromMint",
      accounts: [
        {
          name: "tokenMint",
          isMut: true,
          isSigner: false
        },
        {
          name: "feeReceiver",
          isMut: true,
          isSigner: false
        },
        {
          name: "instructionsSysvarOrContextStateAccount",
          isMut: false,
          isSigner: false
        },
        {
          name: "withdrawWithheldAuthority",
          isMut: false,
          isSigner: true
        }
      ],
      args: [
        {
          name: "withdrawWithheldTokensFromMintData",
          type: {
            defined: "WithdrawWithheldTokensFromMintData"
          }
        }
      ],
      discriminant: {
        type: "u8",
        value: 1
      }
    },
    {
      name: "WithdrawWithheldTokensFromAccounts",
      accounts: [
        {
          name: "tokenMint",
          isMut: true,
          isSigner: false
        },
        {
          name: "feeReceiver",
          isMut: true,
          isSigner: false
        },
        {
          name: "instructionsSysvarOrContextStateAccount",
          isMut: false,
          isSigner: false
        },
        {
          name: "withdrawWithheldAuthority",
          isMut: false,
          isSigner: true
        }
      ],
      args: [
        {
          name: "withdrawWithheldTokensFromAccountsData",
          type: {
            defined: "WithdrawWithheldTokensFromAccountsData"
          }
        }
      ],
      discriminant: {
        type: "u8",
        value: 2
      }
    },
    {
      name: "HarvestWithheldTokensToMint",
      accounts: [
        {
          name: "tokenMint",
          isMut: true,
          isSigner: false
        },
        {
          name: "sourceAccount",
          isMut: true,
          isSigner: false
        }
      ],
      args: [],
      discriminant: {
        type: "u8",
        value: 3
      }
    },
    {
      name: "EnableHarvestToMint",
      accounts: [
        {
          name: "tokenMint",
          isMut: true,
          isSigner: false
        },
        {
          name: "sourceAccount",
          isMut: true,
          isSigner: false
        }
      ],
      args: [],
      discriminant: {
        type: "u8",
        value: 4
      }
    },
    {
      name: "DisableHarvestToMint",
      accounts: [
        {
          name: "tokenMint",
          isMut: true,
          isSigner: false
        },
        {
          name: "confidentialTransferFeeAuthority",
          isMut: false,
          isSigner: true
        }
      ],
      args: [],
      discriminant: {
        type: "u8",
        value: 5
      }
    }
  ],
  accounts: [],
  types: [
    {
      name: "InitializeConfidentialTransferFeeConfigData",
      type: {
        kind: "struct",
        fields: [
          {
            name: "authority",
            type: "publicKey"
          },
          {
            name: "withdraw_withheld_authority_elgamal_pubkey",
            type: {
              array: ["u8", 32]
            }
          }
        ]
      }
    },
    {
      name: "WithdrawWithheldTokensFromMintData",
      type: {
        kind: "struct",
        fields: [
          {
            name: "proof_instruction_offset",
            type: "i8"
          },
          {
            name: "new_decryptable_available_balance",
            type: {
              defined: "DecryptableBalance"
            }
          }
        ]
      }
    },
    {
      name: "DecryptableBalance",
      type: {
        kind: "struct",
        fields: [
          {
            name: "nonce",
            type: {
              array: ["u8", 12]
            }
          },
          {
            name: "ciphertext",
            type: {
              array: ["u8", 24]
            }
          }
        ]
      }
    },
    {
      name: "WithdrawWithheldTokensFromAccountsData",
      type: {
        kind: "struct",
        fields: [
          {
            name: "num_token_accounts",
            type: "u8"
          },
          {
            name: "proof_instruction_offset",
            type: "i8"
          },
          {
            name: "new_decryptable_available_balance",
            type: {
              defined: "DecryptableBalance"
            }
          }
        ]
      }
    }
  ],
  metadata: {
    origin: "shank",
    address: "TokenzQdBNbLqP5VEhdkAS6EPFLC1PHnBqCXEpPxuEb",
    binaryVersion: "0.1.0",
    libVersion: "0.1.0"
  }
};

// src/idls/token-22/extensions/cpi-guard.ts
var CpiGuardExtensionIDL = {
  version: "0.1.0",
  name: "CpiGuardExtension",
  instructions: [
    {
      name: "enableCPIGuard",
      accounts: [
        {
          name: "accountToUpdate",
          isMut: true,
          isSigner: false
        },
        {
          name: "accountOwner",
          isMut: false,
          isSigner: true
        },
        {
          name: "signers",
          isMut: false,
          isSigner: true
        }
      ],
      args: [],
      discriminant: {
        type: "u8",
        value: 0
      }
    },
    {
      name: "disableCPIGuard",
      accounts: [
        {
          name: "accountToUpdate",
          isMut: true,
          isSigner: false
        },
        {
          name: "accountOwner",
          isMut: false,
          isSigner: true
        },
        {
          name: "signers",
          isMut: false,
          isSigner: true
        }
      ],
      args: [],
      discriminant: {
        type: "u8",
        value: 1
      }
    }
  ],
  accounts: [],
  types: [],
  metadata: {
    origin: "shank",
    address: "TokenzQdBNbLqP5VEhdkAS6EPFLC1PHnBqCXEpPxuEb",
    binaryVersion: "0.0.1",
    libVersion: "0.0.1"
  }
};

// src/idls/token-22/extensions/default-account-state.ts
var DefaultAccountStateExtensionIDL = {
  version: "0.1.0",
  name: "DefaultAccountStateExtension",
  instructions: [
    {
      name: "initializeDefaultAccountState",
      accounts: [
        {
          name: "mint",
          isMut: true,
          isSigner: false
        }
      ],
      args: [
        {
          name: "accountState",
          type: {
            defined: "AccountState"
          }
        }
      ],
      discriminant: {
        type: "u8",
        value: 0
      }
    },
    {
      name: "updateDefaultAccountState",
      accounts: [
        {
          name: "mint",
          isMut: true,
          isSigner: false
        },
        {
          name: "freezeAuthority",
          isMut: false,
          isSigner: true
        },
        {
          name: "signers",
          isMut: false,
          isSigner: true
        }
      ],
      args: [
        {
          name: "accountState",
          type: {
            defined: "AccountState"
          }
        }
      ],
      discriminant: {
        type: "u8",
        value: 1
      }
    }
  ],
  accounts: [],
  types: [
    {
      name: "AccountState",
      type: {
        kind: "enum",
        size: "u8",
        variants: [
          {
            name: "Uninitialized"
          },
          {
            name: "Initialized"
          },
          {
            name: "Frozen"
          }
        ]
      }
    }
  ],
  metadata: {
    origin: "shank",
    address: "TokenzQdBNbLqP5VEhdkAS6EPFLC1PHnBqCXEpPxuEb",
    binaryVersion: "0.0.1",
    libVersion: "0.0.1"
  }
};

// src/idls/token-22/extensions/group-member-pointer.ts
var GroupMemberPointerIDL = {
  version: "0.0.0",
  name: "group-member-pointer",
  accounts: [],
  instructions: [
    {
      name: "initializeGroupMemberPointer",
      accounts: [
        {
          name: "mint",
          isMut: true,
          isSigner: false
        }
      ],
      args: [
        {
          name: "initializeGroupMemberPointerData",
          type: {
            defined: "InitializeGroupMemberPointerData"
          }
        }
      ],
      discriminant: {
        type: "u8",
        value: 0
      }
    },
    {
      name: "UpdateGroupMemberPointer",
      accounts: [
        {
          name: "mint",
          isMut: true,
          isSigner: false
        },
        {
          name: "groupPointerAuthority",
          isMut: false,
          isSigner: true
        }
      ],
      args: [
        {
          name: "updateGroupMemberPointerData",
          type: {
            defined: "UpdateGroupMemberPointerData"
          }
        }
      ],
      discriminant: {
        type: "u8",
        value: 1
      }
    }
  ],
  types: [
    {
      name: "InitializeGroupMemberPointerData",
      type: {
        kind: "struct",
        fields: [
          {
            name: "authority",
            type: "publicKey"
          },
          {
            name: "member_address",
            type: "publicKey"
          }
        ]
      }
    },
    {
      name: "UpdateGroupMemberPointerData",
      type: {
        kind: "struct",
        fields: [
          {
            name: "member_address",
            type: "publicKey"
          }
        ]
      }
    }
  ],
  metadata: {
    origin: "shank",
    address: "TokenzQdBNbLqP5VEhdkAS6EPFLC1PHnBqCXEpPxuEb",
    binaryVersion: "0.0.1",
    libVersion: "0.0.1"
  }
};

// src/idls/token-22/extensions/group-pointer.ts
var GroupPointerIDL = {
  version: "0.0.0",
  name: "group-pointer",
  accounts: [],
  instructions: [
    {
      name: "initializeGroupPointer",
      accounts: [
        {
          name: "mint",
          isMut: true,
          isSigner: false
        }
      ],
      args: [
        {
          name: "initializeGroupPointerData",
          type: {
            defined: "InitializeGroupPointerData"
          }
        }
      ],
      discriminant: {
        type: "u8",
        value: 0
      }
    },
    {
      name: "UpdateGroupPointer",
      accounts: [
        {
          name: "mint",
          isMut: true,
          isSigner: false
        },
        {
          name: "groupPointerAuthority",
          isMut: false,
          isSigner: true
        }
      ],
      args: [
        {
          name: "updateGroupPointerData",
          type: {
            defined: "UpdateGroupPointerData"
          }
        }
      ],
      discriminant: {
        type: "u8",
        value: 1
      }
    }
  ],
  types: [
    {
      name: "InitializeGroupPointerData",
      type: {
        kind: "struct",
        fields: [
          {
            name: "authority",
            type: "publicKey"
          },
          {
            name: "group_address",
            type: "publicKey"
          }
        ]
      }
    },
    {
      name: "UpdateGroupPointerData",
      type: {
        kind: "struct",
        fields: [
          {
            name: "group_address",
            type: "publicKey"
          }
        ]
      }
    }
  ],
  metadata: {
    origin: "shank",
    address: "TokenzQdBNbLqP5VEhdkAS6EPFLC1PHnBqCXEpPxuEb",
    binaryVersion: "0.0.1",
    libVersion: "0.0.1"
  }
};

// src/idls/token-22/extensions/interest-bearing-mint.ts
var InterestBearingMintIDL = {
  version: "0.0.0",
  name: "interest-bearing-mint",
  accounts: [],
  instructions: [
    {
      name: "initializeInterestBearingMint",
      accounts: [
        {
          name: "mint",
          isMut: true,
          isSigner: false
        }
      ],
      // rateAuthority should be COption but it's currently not COption ATM for some reason.
      args: [
        {
          name: "rateAuthority",
          type: "publicKey"
        },
        {
          name: "rate",
          type: "i16"
        }
      ],
      discriminant: {
        type: "u8",
        value: 0
      }
    },
    {
      name: "updateInterestBearingMintRate",
      accounts: [
        {
          name: "mint",
          isMut: true,
          isSigner: false
        },
        {
          name: "rateAuthority",
          isMut: false,
          isSigner: true
        },
        {
          name: "signers",
          isMut: false,
          isSigner: true
        }
      ],
      args: [
        {
          name: "newRate",
          type: "i16"
        }
      ],
      discriminant: {
        type: "u8",
        value: 1
      }
    }
  ],
  types: [],
  metadata: {
    origin: "shank",
    address: "TokenzQdBNbLqP5VEhdkAS6EPFLC1PHnBqCXEpPxuEb",
    binaryVersion: "0.0.1",
    libVersion: "0.0.1"
  }
};

// src/idls/token-22/extensions/memo-transfer.ts
var MemoTransferExtensionIDL = {
  version: "0.1.0",
  name: "MemoTransferExtension",
  instructions: [
    {
      name: "enableMemoTransfer",
      accounts: [
        {
          name: "accountToUpdate",
          isMut: true,
          isSigner: false
        },
        {
          name: "accountOwner",
          isMut: false,
          isSigner: true
        },
        {
          name: "signers",
          isMut: false,
          isSigner: true
        }
      ],
      args: [],
      discriminant: {
        type: "u8",
        value: 0
      }
    },
    {
      name: "disableMemoTransfer",
      accounts: [
        {
          name: "accountToUpdate",
          isMut: true,
          isSigner: false
        },
        {
          name: "accountOwner",
          isMut: false,
          isSigner: true
        },
        {
          name: "signers",
          isMut: false,
          isSigner: true
        }
      ],
      args: [],
      discriminant: {
        type: "u8",
        value: 1
      }
    }
  ],
  accounts: [],
  types: [],
  metadata: {
    origin: "shank",
    address: "TokenzQdBNbLqP5VEhdkAS6EPFLC1PHnBqCXEpPxuEb",
    binaryVersion: "0.0.1",
    libVersion: "0.0.1"
  }
};

// src/idls/token-22/extensions/metadata-pointer.ts
var MetadataPointerExtensionIdl = {
  version: "0.1.0",
  name: "MetadataPointerExtension",
  instructions: [
    {
      name: "initializeMetadataPointer",
      accounts: [
        {
          name: "tokenMint",
          isMut: true,
          isSigner: false
        }
      ],
      args: [
        {
          name: "initializeMetadataPointerData",
          type: {
            defined: "InitializeMetadataPointerData"
          }
        }
      ],
      discriminant: {
        type: "u8",
        value: 0
      }
    },
    {
      name: "updateMetadataPointer",
      accounts: [
        {
          name: "tokenMint",
          isMut: true,
          isSigner: false
        },
        {
          name: "metadataPointerAuthority",
          isMut: false,
          isSigner: true
        }
      ],
      args: [
        {
          name: "updateMetadataPointerData",
          type: {
            defined: "UpdateMetadataPointerData"
          }
        }
      ],
      discriminant: {
        type: "u8",
        value: 1
      }
    }
  ],
  accounts: [],
  types: [
    {
      name: "InitializeMetadataPointerData",
      type: {
        kind: "struct",
        fields: [
          {
            name: "authority",
            type: "publicKey"
          },
          {
            name: "metadata_address",
            type: "publicKey"
          }
        ]
      }
    },
    {
      name: "UpdateMetadataPointerData",
      type: {
        kind: "struct",
        fields: [
          {
            name: "metadata_address",
            type: "publicKey"
          }
        ]
      }
    }
  ],
  metadata: {
    origin: "shank",
    address: "TokenzQdBNbLqP5VEhdkAS6EPFLC1PHnBqCXEpPxuEb",
    binaryVersion: "0.1.0",
    libVersion: "0.1.0"
  }
};

// src/idls/token-22/extensions/token-group.ts
var TokenGroupInterfaceExtensionIDL = {
  version: "0.1.0",
  name: "TokenGroupInterfaceExtension",
  instructions: [
    {
      name: "initializeTokenGroup",
      accounts: [
        {
          name: "group",
          isMut: true,
          isSigner: false
        },
        {
          name: "mint",
          isMut: false,
          isSigner: false
        },
        {
          name: "mintAuthority",
          isMut: false,
          isSigner: true
        }
      ],
      args: [
        {
          name: "initializeGroupData",
          type: {
            defined: "InitializeGroupData"
          }
        }
      ]
    },
    {
      name: "updateGroupMaxSize",
      accounts: [
        {
          name: "group",
          isMut: true,
          isSigner: false
        },
        {
          name: "updateAuthority",
          isMut: false,
          isSigner: true
        }
      ],
      args: [
        {
          name: "updateGroupMaxSizeData",
          type: {
            defined: "UpdateGroupMaxSizeData"
          }
        }
      ]
    },
    {
      name: "updateAuthority",
      accounts: [
        {
          name: "group",
          isMut: true,
          isSigner: false
        },
        {
          name: "currentUpdateAuthority",
          isMut: false,
          isSigner: true
        }
      ],
      args: [
        {
          name: "updateGroupAuthorityData",
          type: {
            defined: "UpdateGroupAuthorityData"
          }
        }
      ]
    },
    {
      name: "initializeMember",
      accounts: [
        {
          name: "member",
          isMut: true,
          isSigner: false
        },
        {
          name: "memberMint",
          isMut: false,
          isSigner: false
        },
        {
          name: "memberMintAuthority",
          isMut: false,
          isSigner: true
        },
        {
          name: "group",
          isMut: true,
          isSigner: false
        },
        {
          name: "groupUpdateAuthority",
          isMut: false,
          isSigner: true
        }
      ],
      args: []
    }
  ],
  accounts: [],
  types: [
    {
      name: "InitializeGroupData",
      type: {
        kind: "struct",
        fields: [
          {
            name: "update_authority",
            type: "publicKey"
          },
          {
            name: "max_size",
            type: "u32"
          }
        ]
      }
    },
    {
      name: "UpdateGroupMaxSizeData",
      type: {
        kind: "struct",
        fields: [
          {
            name: "max_size",
            type: "u32"
          }
        ]
      }
    },
    {
      name: "UpdateGroupAuthorityData",
      type: {
        kind: "struct",
        fields: [
          {
            name: "new_authority",
            type: "publicKey"
          }
        ]
      }
    }
  ],
  metadata: {
    origin: "shank",
    address: "TokenzQdBNbLqP5VEhdkAS6EPFLC1PHnBqCXEpPxuEb",
    binaryVersion: "0.1.0",
    libVersion: "0.1.0"
  }
};

// src/idls/token-22/extensions/token-metadata.ts
var TokenMetadataInterfaceExtensionIDL = {
  version: "0.1.0",
  name: "TokenMetadataInterfaceExtension",
  instructions: [
    {
      name: "initializeAccount",
      accounts: [
        {
          name: "metadata",
          isMut: true,
          isSigner: false
        },
        {
          name: "updateAuthority",
          isMut: false,
          isSigner: false
        },
        {
          name: "mint",
          isMut: false,
          isSigner: false
        },
        {
          name: "mintAuthority",
          isMut: false,
          isSigner: true
        }
      ],
      args: [
        {
          name: "initializeAccountData",
          type: {
            defined: "InitializeAccountData"
          }
        }
      ]
    },
    {
      name: "updatingField",
      accounts: [
        {
          name: "metadata",
          isMut: true,
          isSigner: false
        },
        {
          name: "updateAuthority",
          isMut: false,
          isSigner: true
        }
      ],
      args: [
        {
          name: "updatingFieldData",
          type: {
            defined: "UpdatingFieldData"
          }
        }
      ]
    },
    {
      name: "removeKeyIx",
      accounts: [
        {
          name: "metadata",
          isMut: true,
          isSigner: false
        },
        {
          name: "updateAuthority",
          isMut: false,
          isSigner: true
        }
      ],
      args: [
        {
          name: "removeKeyData",
          type: {
            defined: "RemoveKeyData"
          }
        }
      ]
    },
    {
      name: "updateTheAuthority",
      accounts: [
        {
          name: "metadata",
          isMut: true,
          isSigner: false
        },
        {
          name: "updateAuthority",
          isMut: false,
          isSigner: true
        }
      ],
      args: [
        {
          name: "updateAuthorityData",
          type: {
            defined: "UpdateAuthorityData"
          }
        }
      ]
    },
    {
      name: "emitter",
      accounts: [
        {
          name: "metadata",
          isMut: false,
          isSigner: false
        }
      ],
      args: [
        {
          name: "emitData",
          type: {
            defined: "EmitData"
          }
        }
      ]
    }
  ],
  accounts: [],
  types: [
    {
      name: "InitializeAccountData",
      type: {
        kind: "struct",
        fields: [
          {
            name: "name",
            type: "string"
          },
          {
            name: "symbol",
            type: "string"
          },
          {
            name: "uri",
            type: "string"
          }
        ]
      }
    },
    {
      name: "UpdatingFieldData",
      type: {
        kind: "struct",
        fields: [
          {
            name: "field",
            type: {
              defined: "Field"
            }
          },
          {
            name: "value",
            type: "string"
          }
        ]
      }
    },
    {
      name: "Field",
      type: {
        kind: "enum",
        size: "u8",
        variants: [
          {
            name: "Name",
            fields: []
          },
          {
            name: "Symbol",
            fields: []
          },
          {
            name: "Uri",
            fields: []
          },
          {
            name: "Key",
            fields: [
              {
                name: "userKeyField",
                type: "string"
              }
            ]
          }
        ]
      }
    },
    {
      name: "RemoveKeyData",
      type: {
        kind: "struct",
        fields: [
          {
            name: "idempotent",
            type: "bool"
          },
          {
            name: "key",
            type: "string"
          }
        ]
      }
    },
    {
      name: "UpdateAuthorityData",
      type: {
        kind: "struct",
        fields: [
          {
            name: "new_authority",
            type: "publicKey"
          }
        ]
      }
    },
    {
      name: "EmitData",
      type: {
        kind: "struct",
        fields: [
          {
            name: "start",
            type: {
              option: "u64"
            }
          },
          {
            name: "end",
            type: {
              option: "u64"
            }
          }
        ]
      }
    }
  ],
  metadata: {
    origin: "shank",
    address: "TokenzQdBNbLqP5VEhdkAS6EPFLC1PHnBqCXEpPxuEb",
    binaryVersion: "0.1.0",
    libVersion: "0.1.0"
  }
};

// src/idls/token-22/extensions/transfer-fee.ts
var TransferFeeExtensionIDL = {
  version: "0.1.0",
  name: "TransferFeeExtension",
  instructions: [
    {
      name: "initializeTransferFeeConfig",
      accounts: [
        {
          name: "mint",
          isMut: true,
          isSigner: false
        }
      ],
      args: [
        {
          name: "transferFeeConfigAuthority",
          type: {
            coption: "publicKey",
            prefix: "u8"
          }
        },
        {
          name: "withdrawWithheldAuthority",
          type: {
            coption: "publicKey",
            prefix: "u8"
          }
        },
        {
          name: "transferFeeBasisPoints",
          type: "u16"
        },
        {
          name: "maximumFee",
          type: "u64"
        }
      ],
      discriminant: {
        type: "u8",
        value: 0
      }
    },
    {
      name: "transferCheckedWithFee",
      accounts: [
        {
          name: "source",
          isMut: true,
          isSigner: false
        },
        {
          name: "tokenMint",
          isMut: false,
          isSigner: false
        },
        {
          name: "destination",
          isMut: true,
          isSigner: false
        },
        {
          name: "owner",
          isMut: false,
          isSigner: true
        },
        {
          name: "signers",
          isMut: false,
          isSigner: true
        }
      ],
      args: [
        {
          name: "amount",
          type: "u64"
        },
        {
          name: "decimals",
          type: "u8"
        },
        {
          name: "fee",
          type: "u64"
        }
      ],
      discriminant: {
        type: "u8",
        value: 1
      }
    },
    {
      name: "withdrawWithheldTokensFromMint",
      accounts: [
        {
          name: "mint",
          isMut: true,
          isSigner: false
        },
        {
          name: "destination",
          isMut: true,
          isSigner: false
        },
        {
          name: "withdrawWithheldAuthority",
          isMut: false,
          isSigner: true
        },
        {
          name: "signers",
          isMut: false,
          isSigner: true
        }
      ],
      args: [],
      discriminant: {
        type: "u8",
        value: 2
      }
    },
    {
      name: "withdrawWithheldTokensFromAccounts",
      accounts: [
        {
          name: "mint",
          isMut: false,
          isSigner: false
        },
        {
          name: "destination",
          isMut: true,
          isSigner: false
        },
        {
          name: "withdrawWithheldAuthority",
          isMut: false,
          isSigner: true
        },
        {
          name: "signers",
          isMut: false,
          isSigner: true
        },
        {
          name: "source",
          isMut: true,
          isSigner: false
        }
      ],
      args: [
        {
          name: "numTokenAccounts",
          type: "u8"
        }
      ],
      discriminant: {
        type: "u8",
        value: 3
      }
    },
    {
      name: "harvestWithheldTokensToMint",
      accounts: [
        {
          name: "mint",
          isMut: true,
          isSigner: false
        },
        {
          name: "source",
          isMut: true,
          isSigner: false
        }
      ],
      args: [],
      discriminant: {
        type: "u8",
        value: 4
      }
    },
    {
      name: "setTransferFee",
      accounts: [
        {
          name: "mint",
          isMut: true,
          isSigner: false
        },
        {
          name: "owner",
          isMut: false,
          isSigner: true
        },
        {
          name: "signers",
          isMut: false,
          isSigner: true
        }
      ],
      args: [
        {
          name: "transferFeeBasisPoints",
          type: "u16"
        },
        {
          name: "maximumFee",
          type: "u64"
        }
      ],
      discriminant: {
        type: "u8",
        value: 5
      }
    }
  ],
  accounts: [],
  types: [],
  metadata: {
    origin: "shank",
    address: "TokenzQdBNbLqP5VEhdkAS6EPFLC1PHnBqCXEpPxuEb",
    binaryVersion: "0.0.1",
    libVersion: "0.0.1"
  }
};

// src/idls/token-22/extensions/transfer-hook.ts
var TransferHookExtensionIDL = {
  version: "0.1.0",
  name: "TransferHookExtension",
  instructions: [
    {
      name: "initializeTransferHook",
      accounts: [
        {
          name: "tokenMint",
          isMut: true,
          isSigner: false
        }
      ],
      args: [
        {
          name: "initializeTransferHook",
          type: {
            defined: "initializeTransferHookData"
          }
        }
      ],
      discriminant: {
        type: "u8",
        value: 0
      }
    },
    {
      name: "updateTransferHook",
      accounts: [
        {
          name: "tokenMint",
          isMut: true,
          isSigner: false
        },
        {
          name: "transferHookAuthority",
          isMut: false,
          isSigner: true
        }
      ],
      args: [
        {
          name: "updateTransferHook",
          type: {
            defined: "updateTransferHookData"
          }
        }
      ],
      discriminant: {
        type: "u8",
        value: 1
      }
    }
  ],
  accounts: [],
  types: [
    {
      name: "initializeTransferHookData",
      type: {
        kind: "struct",
        fields: [
          {
            name: "authority",
            type: "publicKey"
          },
          {
            name: "program_id",
            type: "publicKey"
          }
        ]
      }
    },
    {
      name: "updateTransferHookData",
      type: {
        kind: "struct",
        fields: [
          {
            name: "program_id",
            type: "publicKey"
          }
        ]
      }
    }
  ],
  metadata: {
    origin: "shank",
    address: "TokenzQdBNbLqP5VEhdkAS6EPFLC1PHnBqCXEpPxuEb",
    binaryVersion: "0.1.0",
    libVersion: "0.1.0"
  }
};

// src/parsers/v2/instruction/token-2022-extensions/transfer-fee.ts
var import_utils25 = require("@solanafm/utils");
var serializeTransferFeeExt = (extensionIDL, dataBuffer, mapTypes, accountKeys) => {
  const extensionSerializerLayout = new KinobiTreeGenerator(extensionIDL).constructLayout();
  const extensionIxDiscriminant = Buffer.from(dataBuffer).readUint8(1);
  const extensionSerializer = extensionSerializerLayout.get(extensionIxDiscriminant);
  const dataToSerialize = dataBuffer.slice(1);
  if (extensionSerializer) {
    const decodedShankData = extensionSerializer.serializer?.deserialize(dataToSerialize);
    if (decodedShankData && decodedShankData[0]) {
      const filteredIdlInstruction = extensionIDL.instructions?.filter(
        (instruction) => instruction.discriminant?.value === extensionIxDiscriminant
      );
      if (mapTypes) {
        decodedShankData[0] = mapDataTypeToName(
          decodedShankData[0],
          filteredIdlInstruction[0]?.args,
          filteredIdlInstruction[0]?.discriminant
        );
      }
      if (filteredIdlInstruction.length > 0) {
        const instructionAccounts = filteredIdlInstruction[0]?.accounts;
        let mappedAccountKeys;
        switch (extensionIxDiscriminant) {
          case 3:
            if (accountKeys && accountKeys.length > 3 && instructionAccounts) {
              const numberOfTokenAccounts = decodedShankData[0].numTokenAccounts.data;
              const [tokenMint, destination, authority] = [accountKeys[0], accountKeys[1], accountKeys[2]];
              const sources = accountKeys.splice(-1 * numberOfTokenAccounts);
              const names = [];
              let signers = [];
              if (accountKeys.length > 3) {
                signers = accountKeys.splice(3);
              }
              instructionAccounts.forEach((idlIxAccount) => {
                names.push(extractIdlIxAccountName(idlIxAccount) ?? { name: "Unknown" });
              });
              const flattenNames = names.flat(5);
              let toCopy = {
                [flattenNames[0]?.name]: { data: tokenMint ?? accountKeys[0], type: "publicKey" },
                [flattenNames[1]?.name]: { data: destination ?? accountKeys[1], type: "publicKey" },
                [flattenNames[2]?.name]: { data: authority ?? accountKeys[2], type: "publicKey" }
              };
              signers.forEach((signerAccountKey, index) => {
                const object = {
                  [`signer` + (index + 1)]: { data: signerAccountKey, type: "publicKey" }
                };
                toCopy = Object.assign(toCopy, object);
              });
              sources.forEach((sourceAccountKey, index) => {
                const object = {
                  [`sourceAccount` + (index + 1)]: { data: sourceAccountKey, type: "publicKey" }
                };
                toCopy = Object.assign(toCopy, object);
              });
              mappedAccountKeys = toCopy;
            } else {
              mappedAccountKeys = mapMultisigAccountKeysToName(accountKeys, instructionAccounts);
            }
            break;
          case 4:
            mappedAccountKeys = mapMultisigAccountKeysToName(accountKeys, instructionAccounts, "source");
            break;
          default:
            mappedAccountKeys = mapMultisigAccountKeysToName(accountKeys, instructionAccounts);
            break;
        }
        return {
          extensionInstructionName: extensionSerializer.instructionName,
          extensionInstructionData: { ...(0, import_utils25.convertBNToNumberInObject)(decodedShankData[0]), ...mappedAccountKeys }
        };
      }
      return {
        extensionInstructionName: extensionSerializer.instructionName,
        extensionInstructionData: (0, import_utils25.convertBNToNumberInObject)(decodedShankData[0])
      };
    }
  }
  return null;
};

// src/parsers/v2/instruction/token-v2.ts
var createTokenV2Ix = (idlItem) => {
  const idl = idlItem.idl;
  const instructionsLayout = new KinobiTreeGenerator(idl).constructLayout();
  const tokenMetadataInterfaceLayout = new KinobiTreeGenerator(TokenMetadataInterfaceExtensionIDL).constructLayout(
    1 /* INSTRUCTIONS */,
    true,
    "spl_token_metadata_interface"
  );
  const tokenGroupInterfaceLayout = new KinobiTreeGenerator(TokenGroupInterfaceExtensionIDL).constructLayout(
    1 /* INSTRUCTIONS */,
    true,
    "spl_token_group_interface"
  );
  const parseInstructions = (instructionData, accountKeys, mapTypes) => {
    try {
      const dataBuffer = import_umi_serializers5.base58.serialize(instructionData);
      const ixDiscriminant = Buffer.from(dataBuffer).readUint8(0);
      const ixSerializer = instructionsLayout.get(ixDiscriminant);
      if (ixSerializer && dataBuffer.byteLength > 0) {
        switch (ixDiscriminant) {
          case 26:
            const transferFeeData = serializeTransferFeeExt(TransferFeeExtensionIDL, dataBuffer, mapTypes, accountKeys);
            if (transferFeeData) {
              return {
                name: ixSerializer.instructionName,
                data: (0, import_utils26.convertBNToNumberInObject)(transferFeeData),
                type: "instruction" /* INSTRUCTION */
              };
            }
            break;
          case 27:
            const confidentialTransferData = serializeExtension(
              ConfidentialTransferExtensionIDL,
              dataBuffer,
              mapTypes,
              accountKeys
            );
            if (confidentialTransferData) {
              return {
                name: ixSerializer.instructionName,
                data: (0, import_utils26.convertBNToNumberInObject)(confidentialTransferData),
                type: "instruction" /* INSTRUCTION */
              };
            }
            break;
          case 28:
            const defaultAccountStateData = serializeExtension(
              DefaultAccountStateExtensionIDL,
              dataBuffer,
              mapTypes,
              accountKeys
            );
            if (defaultAccountStateData) {
              return {
                name: ixSerializer.instructionName,
                data: (0, import_utils26.convertBNToNumberInObject)(defaultAccountStateData),
                type: "instruction" /* INSTRUCTION */
              };
            }
            break;
          case 30:
            const memoTransferData = serializeExtension(MemoTransferExtensionIDL, dataBuffer, mapTypes, accountKeys);
            if (memoTransferData) {
              return {
                name: ixSerializer.instructionName,
                data: (0, import_utils26.convertBNToNumberInObject)(memoTransferData),
                type: "instruction" /* INSTRUCTION */
              };
            }
            break;
          case 33:
            if (dataBuffer.byteLength < 2) {
              return null;
            }
            const interestBearingMintData = serializeExtension(
              InterestBearingMintIDL,
              dataBuffer,
              mapTypes,
              accountKeys
            );
            if (interestBearingMintData) {
              return {
                name: ixSerializer.instructionName,
                data: (0, import_utils26.convertBNToNumberInObject)(interestBearingMintData),
                type: "instruction" /* INSTRUCTION */
              };
            }
            break;
          case 34:
            if (dataBuffer.byteLength < 2) {
              return null;
            }
            const cpiGuardData = serializeExtension(CpiGuardExtensionIDL, dataBuffer, mapTypes, accountKeys);
            if (cpiGuardData) {
              return {
                name: ixSerializer.instructionName,
                data: (0, import_utils26.convertBNToNumberInObject)(cpiGuardData),
                type: "instruction" /* INSTRUCTION */
              };
            }
            break;
          case 36:
            if (dataBuffer.byteLength < 2) {
              return null;
            }
            const transferHookData = serializeExtension(TransferHookExtensionIDL, dataBuffer, mapTypes, accountKeys);
            if (transferHookData) {
              return {
                name: ixSerializer.instructionName,
                data: (0, import_utils26.convertBNToNumberInObject)(transferHookData),
                type: "instruction" /* INSTRUCTION */
              };
            }
            break;
          case 37:
            if (dataBuffer.byteLength < 2) {
              return null;
            }
            const confidentialTransferFeeData = serializeExtension(
              ConfidentialTransferFeeExtensionIDL,
              dataBuffer,
              mapTypes,
              accountKeys
            );
            if (confidentialTransferFeeData) {
              return {
                name: ixSerializer.instructionName,
                data: (0, import_utils26.convertBNToNumberInObject)(confidentialTransferFeeData),
                type: "instruction" /* INSTRUCTION */
              };
            }
            break;
          case 39:
            if (dataBuffer.byteLength < 2) {
              return null;
            }
            const metadataPointerData = serializeExtension(
              MetadataPointerExtensionIdl,
              dataBuffer,
              mapTypes,
              accountKeys
            );
            if (metadataPointerData) {
              return {
                name: ixSerializer.instructionName,
                data: (0, import_utils26.convertBNToNumberInObject)(metadataPointerData),
                type: "instruction" /* INSTRUCTION */
              };
            }
            break;
          case 40:
            if (dataBuffer.byteLength < 2) {
              return null;
            }
            const groupMemberPointerData = serializeExtension(GroupMemberPointerIDL, dataBuffer, mapTypes, accountKeys);
            if (groupMemberPointerData) {
              return {
                name: ixSerializer.instructionName,
                data: (0, import_utils26.convertBNToNumberInObject)(groupMemberPointerData),
                type: "instruction" /* INSTRUCTION */
              };
            }
            break;
          case 41:
            if (dataBuffer.byteLength < 2) {
              return null;
            }
            const groupPointerData = serializeExtension(GroupPointerIDL, dataBuffer, mapTypes, accountKeys);
            if (groupPointerData) {
              return {
                name: ixSerializer.instructionName,
                data: (0, import_utils26.convertBNToNumberInObject)(groupPointerData),
                type: "instruction" /* INSTRUCTION */
              };
            }
            break;
          default:
            const decodedShankData = ixSerializer.serializer?.deserialize(dataBuffer);
            if (decodedShankData && decodedShankData[0]) {
              const filteredIdlInstruction = idl.instructions?.filter(
                (instruction) => instruction.discriminant?.value === ixDiscriminant
              );
              if (mapTypes) {
                decodedShankData[0] = mapDataTypeToName(
                  decodedShankData[0],
                  filteredIdlInstruction[0]?.args,
                  filteredIdlInstruction[0]?.discriminant
                );
              }
              if (filteredIdlInstruction.length > 0) {
                const instructionAccounts = filteredIdlInstruction[0]?.accounts;
                const mappedAccountKeys = mapMultisigAccountKeysToName(accountKeys, instructionAccounts);
                return {
                  name: ixSerializer.instructionName,
                  data: { ...(0, import_utils26.convertBNToNumberInObject)(decodedShankData[0]), ...mappedAccountKeys },
                  type: "instruction" /* INSTRUCTION */
                };
              }
              return {
                name: ixSerializer.instructionName,
                data: (0, import_utils26.convertBNToNumberInObject)(decodedShankData[0]),
                type: "instruction" /* INSTRUCTION */
              };
            }
            break;
        }
      } else {
        const interfaceDiscriminant = Buffer.from(dataBuffer).subarray(0, 8);
        const bs58Discriminant = (0, import_utils26.encodeBase58)(interfaceDiscriminant);
        let interfaceSerializer;
        if (tokenMetadataInterfaceLayout.has(bs58Discriminant) && dataBuffer.byteLength > 8) {
          interfaceSerializer = tokenMetadataInterfaceLayout.get(bs58Discriminant);
        } else if (tokenGroupInterfaceLayout.has(bs58Discriminant) && dataBuffer.byteLength > 8) {
          interfaceSerializer = tokenGroupInterfaceLayout.get(bs58Discriminant);
        }
        if (interfaceSerializer) {
          const decodedShankData = interfaceSerializer.serializer?.deserialize(dataBuffer.subarray(8));
          if (decodedShankData && decodedShankData[0]) {
            const filteredIdlInstruction = idl.instructions?.filter(
              (instruction) => instruction.discriminant?.value === ixDiscriminant
            );
            if (mapTypes) {
              decodedShankData[0] = mapDataTypeToName(
                decodedShankData[0],
                filteredIdlInstruction[0]?.args,
                filteredIdlInstruction[0]?.discriminant
              );
            }
            if (filteredIdlInstruction.length > 0) {
              const instructionAccounts = filteredIdlInstruction[0]?.accounts;
              const mappedAccountKeys = mapMultisigAccountKeysToName(accountKeys, instructionAccounts);
              return {
                name: interfaceSerializer.instructionName,
                data: { ...(0, import_utils26.convertBNToNumberInObject)(decodedShankData[0]), ...mappedAccountKeys },
                type: "instruction" /* INSTRUCTION */
              };
            }
            return {
              name: interfaceSerializer.instructionName,
              data: (0, import_utils26.convertBNToNumberInObject)(decodedShankData[0]),
              type: "instruction" /* INSTRUCTION */
            };
          }
        }
      }
      return null;
    } catch (error) {
      console.error(error);
      return null;
    }
  };
  const getProgramName = () => {
    return idl.name;
  };
  const serializeExtension = (extensionIDL, dataBuffer, mapTypes, accountKeys) => {
    const extensionSerializerLayout = new KinobiTreeGenerator(extensionIDL).constructLayout();
    const extensionIxDiscriminant = Buffer.from(dataBuffer).readUint8(1);
    const extensionSerializer = extensionSerializerLayout.get(extensionIxDiscriminant);
    const dataToSerialize = dataBuffer.slice(1);
    if (extensionSerializer) {
      const decodedShankData = extensionSerializer.serializer?.deserialize(dataToSerialize);
      if (decodedShankData && decodedShankData[0]) {
        const filteredIdlInstruction = extensionIDL.instructions?.filter(
          (instruction) => instruction.discriminant?.value === extensionIxDiscriminant
        );
        if (mapTypes) {
          decodedShankData[0] = mapDataTypeToName(
            decodedShankData[0],
            filteredIdlInstruction[0]?.args,
            filteredIdlInstruction[0]?.discriminant
          );
        }
        if (filteredIdlInstruction.length > 0) {
          const instructionAccounts = filteredIdlInstruction[0]?.accounts;
          const mappedAccountKeys = mapMultisigAccountKeysToName(accountKeys, instructionAccounts);
          return {
            extensionInstructionName: extensionSerializer.instructionName,
            extensionInstructionData: { ...(0, import_utils26.convertBNToNumberInObject)(decodedShankData[0]), ...mappedAccountKeys }
          };
        }
        return {
          extensionInstructionName: extensionSerializer.instructionName,
          extensionInstructionData: (0, import_utils26.convertBNToNumberInObject)(decodedShankData[0])
        };
      }
    }
    return null;
  };
  return {
    instructionsLayout,
    parseInstructions,
    getProgramName
  };
};

// src/interfaces/InstructionParserInterface.ts
var createInstructionParser = (idlItem, programHash) => {
  switch (idlItem.idlType) {
    case "anchor":
      return createAnchorInstructionParser(idlItem);
    case "anchorV1":
      return createAnchorV1InstructionParser(idlItem);
    case "shank":
      switch (programHash) {
        case "Config1111111111111111111111111111111111111":
          return createShankIxConfig(idlItem);
        case "ATokenGPvbdGVxr1b2hvZbsiqW5xWH25efTNsLJA8knL":
          return createShankIxATA(idlItem);
        case "TokenzQdBNbLqP5VEhdkAS6EPFLC1PHnBqCXEpPxuEb":
          return createTokenV2Ix(idlItem);
        case "noopb9bkMVfRPU8AsbpTUg8AQkHtKwMYZiFUjNRtMmV":
          return createNoopIx(idlItem);
      }
      return createShankInstructionParser(idlItem);
    case "kinobi":
      switch (programHash) {
        case "MemoSq4gqABAXKb96qnH8TysNcWxMyWCqXgDLGmfcHr":
          return createShankIxMemo(idlItem);
        case "Memo1UhkJRfHyvLMcVucJwxXeuD728EqVDDwQDxFMNo":
          return createShankIxMemo(idlItem);
        case "PhoeNiXZ8ByJGLkxNfZRnkUfjvmuYqLR89jjFHGqdXY":
          return createShankIxPhoenix(idlItem);
        default:
          return null;
      }
    default:
      return null;
  }
};

// src/SolanaFMParser.ts
var SolanaFMParser = class {
  /**
   * The IDL item.
   */
  idlItem;
  /**
   * The program hash.
   * @remarks For account parsing, this is also known as the owner of the account
   */
  programHash;
  /**
   * The account hash.
   * @remarks This is optional because not all parsers require an account hash and it's only usable for parsing accounts such as sysvar accounts
   */
  accountHash;
  /**
   * Creates a new instance of the FMClient class.
   * @param idl The IDL that's to be used for initalizing the client.
   * @param programHash The program hash.
   * @param accountHash The account hash.
   */
  constructor(idl, programHash, accountHash) {
    this.idlItem = idl;
    this.programHash = programHash;
    this.accountHash = accountHash;
  }
  /**
   * Creates a parser based on the specified parser type.
   * @param parserType The parser type.
   * @returns A parser instance.
   */
  createParser(parserType) {
    switch (parserType) {
      case "account" /* ACCOUNT */:
        return createAccountParser(this.idlItem, this.programHash, this.accountHash);
      case "instruction" /* INSTRUCTION */:
        return createInstructionParser(this.idlItem, this.programHash);
      case "event" /* EVENT */:
        return createEventParser(this.idlItem, this.programHash);
      case "error" /* ERROR */:
        return createErrorParser(this.idlItem);
      default:
        return null;
    }
  }
  /**
   * Gets the program hash.
   * @returns The program hash.
   */
  getProgramHash() {
    return this.programHash;
  }
};
// Annotate the CommonJS export names for ESM import in node:
0 && (module.exports = {
  ParserType,
  SolanaFMParser,
  checkIfAccountParser,
  checkIfErrorsParser,
  checkIfEventParser,
  checkIfInstructionParser,
  isDataWithMappedType,
  isIdlAccounts
});
